
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire887a"];
var parcelRegister = parcelRequire.register;
parcelRegister("jLnKo", function(module, exports) {

$parcel$export(module.exports, "WcmQrCode", function () { return $e634d3d4b646501e$export$9681a3251bf7934f; });
$parcel$export(module.exports, "WcmModal", function () { return $e634d3d4b646501e$export$9efa81f00f3a145b; });
parcelRequire("hO4b7");
var $lEG98 = parcelRequire("lEG98");
var $7mSD6 = parcelRequire("7mSD6");
var $356Px = parcelRequire("356Px");
parcelRequire("bJ6qj");
var $7UJjG = parcelRequire("7UJjG");
var $N2oWd = parcelRequire("N2oWd");
var $7WxjU = parcelRequire("7WxjU");
parcelRequire("3EeEZ");
var $f1WVg = parcelRequire("f1WVg");

var $dYErK = parcelRequire("dYErK");

var $7mSD6 = parcelRequire("7mSD6");

var $4TjqH = parcelRequire("4TjqH");
parcelRequire("4a57W");
var $7He6a = parcelRequire("7He6a");

var $doQTd = parcelRequire("doQTd");
var $e634d3d4b646501e$var$et = Object.defineProperty, $e634d3d4b646501e$var$Be = Object.getOwnPropertySymbols, $e634d3d4b646501e$var$tt = Object.prototype.hasOwnProperty, $e634d3d4b646501e$var$ot = Object.prototype.propertyIsEnumerable, $e634d3d4b646501e$var$Ue = (e, o, r)=>o in e ? $e634d3d4b646501e$var$et(e, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[o] = r, $e634d3d4b646501e$var$ve = (e, o)=>{
    for(var r in o || (o = {}))$e634d3d4b646501e$var$tt.call(o, r) && $e634d3d4b646501e$var$Ue(e, r, o[r]);
    if ($e634d3d4b646501e$var$Be) for (var r of $e634d3d4b646501e$var$Be(o))$e634d3d4b646501e$var$ot.call(o, r) && $e634d3d4b646501e$var$Ue(e, r, o[r]);
    return e;
};
function $e634d3d4b646501e$var$rt() {
    var e;
    const o = (e = (0, $dYErK.ThemeCtrl).state.themeMode) != null ? e : "dark", r = {
        light: {
            foreground: {
                1: "rgb(20,20,20)",
                2: "rgb(121,134,134)",
                3: "rgb(158,169,169)"
            },
            background: {
                1: "rgb(255,255,255)",
                2: "rgb(241,243,243)",
                3: "rgb(228,231,231)"
            },
            overlay: "rgba(0,0,0,0.1)"
        },
        dark: {
            foreground: {
                1: "rgb(228,231,231)",
                2: "rgb(148,158,158)",
                3: "rgb(110,119,119)"
            },
            background: {
                1: "rgb(20,20,20)",
                2: "rgb(39,42,42)",
                3: "rgb(59,64,64)"
            },
            overlay: "rgba(255,255,255,0.1)"
        }
    }[o];
    return {
        "--wcm-color-fg-1": r.foreground[1],
        "--wcm-color-fg-2": r.foreground[2],
        "--wcm-color-fg-3": r.foreground[3],
        "--wcm-color-bg-1": r.background[1],
        "--wcm-color-bg-2": r.background[2],
        "--wcm-color-bg-3": r.background[3],
        "--wcm-color-overlay": r.overlay
    };
}
function $e634d3d4b646501e$var$He() {
    return {
        "--wcm-accent-color": "#3396FF",
        "--wcm-accent-fill-color": "#FFFFFF",
        "--wcm-z-index": "89",
        "--wcm-background-color": "#3396FF",
        "--wcm-background-border-radius": "8px",
        "--wcm-container-border-radius": "30px",
        "--wcm-wallet-icon-border-radius": "15px",
        "--wcm-wallet-icon-large-border-radius": "30px",
        "--wcm-wallet-icon-small-border-radius": "7px",
        "--wcm-input-border-radius": "28px",
        "--wcm-button-border-radius": "10px",
        "--wcm-notification-border-radius": "36px",
        "--wcm-secondary-button-border-radius": "28px",
        "--wcm-icon-button-border-radius": "50%",
        "--wcm-button-hover-highlight-border-radius": "10px",
        "--wcm-text-big-bold-size": "20px",
        "--wcm-text-big-bold-weight": "600",
        "--wcm-text-big-bold-line-height": "24px",
        "--wcm-text-big-bold-letter-spacing": "-0.03em",
        "--wcm-text-big-bold-text-transform": "none",
        "--wcm-text-xsmall-bold-size": "10px",
        "--wcm-text-xsmall-bold-weight": "700",
        "--wcm-text-xsmall-bold-line-height": "12px",
        "--wcm-text-xsmall-bold-letter-spacing": "0.02em",
        "--wcm-text-xsmall-bold-text-transform": "uppercase",
        "--wcm-text-xsmall-regular-size": "12px",
        "--wcm-text-xsmall-regular-weight": "600",
        "--wcm-text-xsmall-regular-line-height": "14px",
        "--wcm-text-xsmall-regular-letter-spacing": "-0.03em",
        "--wcm-text-xsmall-regular-text-transform": "none",
        "--wcm-text-small-thin-size": "14px",
        "--wcm-text-small-thin-weight": "500",
        "--wcm-text-small-thin-line-height": "16px",
        "--wcm-text-small-thin-letter-spacing": "-0.03em",
        "--wcm-text-small-thin-text-transform": "none",
        "--wcm-text-small-regular-size": "14px",
        "--wcm-text-small-regular-weight": "600",
        "--wcm-text-small-regular-line-height": "16px",
        "--wcm-text-small-regular-letter-spacing": "-0.03em",
        "--wcm-text-small-regular-text-transform": "none",
        "--wcm-text-medium-regular-size": "16px",
        "--wcm-text-medium-regular-weight": "600",
        "--wcm-text-medium-regular-line-height": "20px",
        "--wcm-text-medium-regular-letter-spacing": "-0.03em",
        "--wcm-text-medium-regular-text-transform": "none",
        "--wcm-font-family": "-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif",
        "--wcm-font-feature-settings": "'tnum' on, 'lnum' on, 'case' on",
        "--wcm-success-color": "rgb(38,181,98)",
        "--wcm-error-color": "rgb(242, 90, 103)",
        "--wcm-overlay-background-color": "rgba(0, 0, 0, 0.3)",
        "--wcm-overlay-backdrop-filter": "none"
    };
}
const $e634d3d4b646501e$var$h = {
    getPreset (e) {
        return $e634d3d4b646501e$var$He()[e];
    },
    setTheme () {
        const e = document.querySelector(":root"), { themeVariables: o } = (0, $dYErK.ThemeCtrl).state;
        if (e) {
            const r = $e634d3d4b646501e$var$ve($e634d3d4b646501e$var$ve($e634d3d4b646501e$var$ve({}, $e634d3d4b646501e$var$rt()), $e634d3d4b646501e$var$He()), o);
            Object.entries(r).forEach(([a, t])=>e.style.setProperty(a, t));
        }
    },
    globalCss: (0, $lEG98.css)`*,::after,::before{margin:0;padding:0;box-sizing:border-box;font-style:normal;text-rendering:optimizeSpeed;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;backface-visibility:hidden}button{cursor:pointer;display:flex;justify-content:center;align-items:center;position:relative;border:none;background-color:transparent;transition:all .2s ease}@media (hover:hover) and (pointer:fine){button:active{transition:all .1s ease;transform:scale(.93)}}button::after{content:'';position:absolute;top:0;bottom:0;left:0;right:0;transition:background-color,.2s ease}button:disabled{cursor:not-allowed}button svg,button wcm-text{position:relative;z-index:1}input{border:none;outline:0;appearance:none}img{display:block}::selection{color:var(--wcm-accent-fill-color);background:var(--wcm-accent-color)}`
}, $e634d3d4b646501e$var$at = (0, $lEG98.css)`button{border-radius:var(--wcm-secondary-button-border-radius);height:28px;padding:0 10px;background-color:var(--wcm-accent-color)}button path{fill:var(--wcm-accent-fill-color)}button::after{border-radius:inherit;border:1px solid var(--wcm-color-overlay)}button:disabled::after{background-color:transparent}.wcm-icon-left svg{margin-right:5px}.wcm-icon-right svg{margin-left:5px}button:active::after{background-color:var(--wcm-color-overlay)}.wcm-ghost,.wcm-ghost:active::after,.wcm-outline{background-color:transparent}.wcm-ghost:active{opacity:.5}@media(hover:hover){button:hover::after{background-color:var(--wcm-color-overlay)}.wcm-ghost:hover::after{background-color:transparent}.wcm-ghost:hover{opacity:.5}}button:disabled{background-color:var(--wcm-color-bg-3);pointer-events:none}.wcm-ghost::after{border-color:transparent}.wcm-ghost path{fill:var(--wcm-color-fg-2)}.wcm-outline path{fill:var(--wcm-accent-color)}.wcm-outline:disabled{background-color:transparent;opacity:.5}`;
var $e634d3d4b646501e$var$lt = Object.defineProperty, $e634d3d4b646501e$var$it = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$F = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$it(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$lt(o, r, t), t;
};
let $e634d3d4b646501e$var$T = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.disabled = !1, this.iconLeft = void 0, this.iconRight = void 0, this.onClick = ()=>null, this.variant = "default";
    }
    render() {
        const e = {
            "wcm-icon-left": this.iconLeft !== void 0,
            "wcm-icon-right": this.iconRight !== void 0,
            "wcm-ghost": this.variant === "ghost",
            "wcm-outline": this.variant === "outline"
        };
        let o = "inverse";
        return this.variant === "ghost" && (o = "secondary"), this.variant === "outline" && (o = "accent"), (0, $7mSD6.html)`<button class="${(0, $f1WVg.classMap)(e)}" ?disabled="${this.disabled}" @click="${this.onClick}">${this.iconLeft}<wcm-text variant="small-regular" color="${o}"><slot></slot></wcm-text>${this.iconRight}</button>`;
    }
};
$e634d3d4b646501e$var$T.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$at
], $e634d3d4b646501e$var$F([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$T.prototype, "disabled", 2), $e634d3d4b646501e$var$F([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$T.prototype, "iconLeft", 2), $e634d3d4b646501e$var$F([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$T.prototype, "iconRight", 2), $e634d3d4b646501e$var$F([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$T.prototype, "onClick", 2), $e634d3d4b646501e$var$F([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$T.prototype, "variant", 2), $e634d3d4b646501e$var$T = $e634d3d4b646501e$var$F([
    (0, $7UJjG.customElement)("wcm-button")
], $e634d3d4b646501e$var$T);
const $e634d3d4b646501e$var$nt = (0, $lEG98.css)`:host{display:inline-block}button{padding:0 15px 1px;height:40px;border-radius:var(--wcm-button-border-radius);color:var(--wcm-accent-fill-color);background-color:var(--wcm-accent-color)}button::after{content:'';top:0;bottom:0;left:0;right:0;position:absolute;background-color:transparent;border-radius:inherit;transition:background-color .2s ease;border:1px solid var(--wcm-color-overlay)}button:active::after{background-color:var(--wcm-color-overlay)}button:disabled{padding-bottom:0;background-color:var(--wcm-color-bg-3);color:var(--wcm-color-fg-3)}.wcm-secondary{color:var(--wcm-accent-color);background-color:transparent}.wcm-secondary::after{display:none}@media(hover:hover){button:hover::after{background-color:var(--wcm-color-overlay)}}`;
var $e634d3d4b646501e$var$ct = Object.defineProperty, $e634d3d4b646501e$var$st = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ue = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$st(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$ct(o, r, t), t;
};
let $e634d3d4b646501e$var$ee = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.disabled = !1, this.variant = "primary";
    }
    render() {
        const e = {
            "wcm-secondary": this.variant === "secondary"
        };
        return (0, $7mSD6.html)`<button ?disabled="${this.disabled}" class="${(0, $f1WVg.classMap)(e)}"><slot></slot></button>`;
    }
};
$e634d3d4b646501e$var$ee.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$nt
], $e634d3d4b646501e$var$ue([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$ee.prototype, "disabled", 2), $e634d3d4b646501e$var$ue([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$ee.prototype, "variant", 2), $e634d3d4b646501e$var$ee = $e634d3d4b646501e$var$ue([
    (0, $7UJjG.customElement)("wcm-button-big")
], $e634d3d4b646501e$var$ee);
const $e634d3d4b646501e$var$dt = (0, $lEG98.css)`:host{background-color:var(--wcm-color-bg-2);border-top:1px solid var(--wcm-color-bg-3)}div{padding:10px 20px;display:inherit;flex-direction:inherit;align-items:inherit;width:inherit;justify-content:inherit}`;
var $e634d3d4b646501e$var$mt = Object.defineProperty, $e634d3d4b646501e$var$ht = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$wt = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$ht(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$mt(o, r, t), t;
};
let $e634d3d4b646501e$var$be = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<div><slot></slot></div>`;
    }
};
$e634d3d4b646501e$var$be.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$dt
], $e634d3d4b646501e$var$be = $e634d3d4b646501e$var$wt([
    (0, $7UJjG.customElement)("wcm-info-footer")
], $e634d3d4b646501e$var$be);
const $e634d3d4b646501e$var$v = {
    CROSS_ICON: (0, $7mSD6.svg)`<svg width="12" height="12" viewBox="0 0 12 12"><path d="M9.94 11A.75.75 0 1 0 11 9.94L7.414 6.353a.5.5 0 0 1 0-.708L11 2.061A.75.75 0 1 0 9.94 1L6.353 4.586a.5.5 0 0 1-.708 0L2.061 1A.75.75 0 0 0 1 2.06l3.586 3.586a.5.5 0 0 1 0 .708L1 9.939A.75.75 0 1 0 2.06 11l3.586-3.586a.5.5 0 0 1 .708 0L9.939 11Z" fill="#fff"/></svg>`,
    WALLET_CONNECT_LOGO: (0, $7mSD6.svg)`<svg width="178" height="29" viewBox="0 0 178 29" id="wcm-wc-logo"><path d="M10.683 7.926c5.284-5.17 13.85-5.17 19.134 0l.636.623a.652.652 0 0 1 0 .936l-2.176 2.129a.343.343 0 0 1-.478 0l-.875-.857c-3.686-3.607-9.662-3.607-13.348 0l-.937.918a.343.343 0 0 1-.479 0l-2.175-2.13a.652.652 0 0 1 0-.936l.698-.683Zm23.633 4.403 1.935 1.895a.652.652 0 0 1 0 .936l-8.73 8.543a.687.687 0 0 1-.956 0L20.37 17.64a.172.172 0 0 0-.239 0l-6.195 6.063a.687.687 0 0 1-.957 0l-8.73-8.543a.652.652 0 0 1 0-.936l1.936-1.895a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .239 0l6.195-6.064a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .24 0l6.195-6.064a.687.687 0 0 1 .956 0ZM48.093 20.948l2.338-9.355c.139-.515.258-1.07.416-1.942.12.872.258 1.427.357 1.942l2.022 9.355h4.181l3.528-13.874h-3.21l-1.943 8.523a24.825 24.825 0 0 0-.456 2.457c-.158-.931-.317-1.625-.495-2.438l-1.883-8.542h-4.201l-2.042 8.542a41.204 41.204 0 0 0-.475 2.438 41.208 41.208 0 0 0-.476-2.438l-1.903-8.542h-3.349l3.508 13.874h4.083ZM63.33 21.304c1.585 0 2.596-.654 3.11-1.605-.059.297-.078.595-.078.892v.357h2.655V15.22c0-2.735-1.248-4.32-4.3-4.32-2.636 0-4.36 1.466-4.52 3.487h2.914c.1-.891.734-1.426 1.705-1.426.911 0 1.407.515 1.407 1.11 0 .435-.258.693-1.03.792l-1.388.159c-2.061.257-3.825 1.01-3.825 3.19 0 1.982 1.645 3.092 3.35 3.092Zm.891-2.041c-.773 0-1.348-.436-1.348-1.19 0-.733.655-1.09 1.645-1.268l.674-.119c.575-.118.892-.218 1.09-.396v.912c0 1.228-.892 2.06-2.06 2.06ZM70.398 7.074v13.874h2.874V7.074h-2.874ZM74.934 7.074v13.874h2.874V7.074h-2.874ZM84.08 21.304c2.735 0 4.5-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922H81.92ZM94.92 21.146c.633 0 1.248-.1 1.525-.179v-2.18c-.218.04-.475.06-.693.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.338v-2.24h-2.338V7.788H91.47v3.448H89.37v2.24h2.1v4.201c0 2.3 1.15 3.469 3.45 3.469ZM104.62 21.304c3.924 0 6.302-2.299 6.599-5.608h-3.111c-.238 1.803-1.506 3.032-3.369 3.032-2.2 0-3.746-1.784-3.746-4.796 0-2.953 1.605-4.638 3.805-4.638 1.883 0 2.953 1.15 3.171 2.834h3.191c-.317-3.448-2.854-5.41-6.342-5.41-3.984 0-7.036 2.695-7.036 7.214 0 4.677 2.676 7.372 6.838 7.372ZM117.449 21.304c2.993 0 5.114-1.882 5.114-5.172 0-3.23-2.121-5.233-5.114-5.233-2.972 0-5.093 2.002-5.093 5.233 0 3.29 2.101 5.172 5.093 5.172Zm0-2.22c-1.327 0-2.18-1.09-2.18-2.952 0-1.903.892-2.973 2.18-2.973 1.308 0 2.2 1.07 2.2 2.973 0 1.862-.872 2.953-2.2 2.953ZM126.569 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.229-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM137.464 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.228-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM149.949 21.304c2.735 0 4.499-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922h-3.984ZM160.876 21.304c3.013 0 4.658-1.645 4.975-4.201h-2.874c-.099 1.07-.713 1.982-2.001 1.982-1.309 0-2.2-1.21-2.2-2.993 0-1.942 1.03-2.933 2.259-2.933 1.209 0 1.803.872 1.883 1.882h2.873c-.218-2.358-1.823-4.142-4.776-4.142-2.874 0-5.153 1.903-5.153 5.193 0 3.25 1.923 5.212 5.014 5.212ZM172.067 21.146c.634 0 1.248-.1 1.526-.179v-2.18c-.218.04-.476.06-.694.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.339v-2.24h-2.339V7.788h-2.854v3.448h-2.1v2.24h2.1v4.201c0 2.3 1.15 3.469 3.449 3.469Z" fill="#fff"/></svg>`,
    WALLET_CONNECT_ICON: (0, $7mSD6.svg)`<svg width="28" height="20" viewBox="0 0 28 20"><g clip-path="url(#a)"><path d="M7.386 6.482c3.653-3.576 9.575-3.576 13.228 0l.44.43a.451.451 0 0 1 0 .648L19.55 9.033a.237.237 0 0 1-.33 0l-.606-.592c-2.548-2.496-6.68-2.496-9.228 0l-.648.634a.237.237 0 0 1-.33 0L6.902 7.602a.451.451 0 0 1 0-.647l.483-.473Zm16.338 3.046 1.339 1.31a.451.451 0 0 1 0 .648l-6.035 5.909a.475.475 0 0 1-.662 0L14.083 13.2a.119.119 0 0 0-.166 0l-4.283 4.194a.475.475 0 0 1-.662 0l-6.035-5.91a.451.451 0 0 1 0-.647l1.338-1.31a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0Z" fill="#000000"/></g><defs><clipPath id="a"><path fill="#ffffff" d="M0 0h28v20H0z"/></clipPath></defs></svg>`,
    WALLET_CONNECT_ICON_COLORED: (0, $7mSD6.svg)`<svg width="96" height="96" fill="none"><path fill="#fff" d="M25.322 33.597c12.525-12.263 32.83-12.263 45.355 0l1.507 1.476a1.547 1.547 0 0 1 0 2.22l-5.156 5.048a.814.814 0 0 1-1.134 0l-2.074-2.03c-8.737-8.555-22.903-8.555-31.64 0l-2.222 2.175a.814.814 0 0 1-1.134 0l-5.156-5.049a1.547 1.547 0 0 1 0-2.22l1.654-1.62Zm56.019 10.44 4.589 4.494a1.547 1.547 0 0 1 0 2.22l-20.693 20.26a1.628 1.628 0 0 1-2.267 0L48.283 56.632a.407.407 0 0 0-.567 0L33.03 71.012a1.628 1.628 0 0 1-2.268 0L10.07 50.75a1.547 1.547 0 0 1 0-2.22l4.59-4.494a1.628 1.628 0 0 1 2.267 0l14.687 14.38c.156.153.41.153.567 0l14.685-14.38a1.628 1.628 0 0 1 2.268 0l14.687 14.38c.156.153.41.153.567 0l14.686-14.38a1.628 1.628 0 0 1 2.268 0Z"/><path stroke="#000" d="M25.672 33.954c12.33-12.072 32.325-12.072 44.655 0l1.508 1.476a1.047 1.047 0 0 1 0 1.506l-5.157 5.048a.314.314 0 0 1-.434 0l-2.074-2.03c-8.932-8.746-23.409-8.746-32.34 0l-2.222 2.174a.314.314 0 0 1-.434 0l-5.157-5.048a1.047 1.047 0 0 1 0-1.506l1.655-1.62Zm55.319 10.44 4.59 4.494a1.047 1.047 0 0 1 0 1.506l-20.694 20.26a1.128 1.128 0 0 1-1.568 0l-14.686-14.38a.907.907 0 0 0-1.267 0L32.68 70.655a1.128 1.128 0 0 1-1.568 0L10.42 50.394a1.047 1.047 0 0 1 0-1.506l4.59-4.493a1.128 1.128 0 0 1 1.567 0l14.687 14.379a.907.907 0 0 0 1.266 0l-.35-.357.35.357 14.686-14.38a1.128 1.128 0 0 1 1.568 0l14.687 14.38a.907.907 0 0 0 1.267 0l14.686-14.38a1.128 1.128 0 0 1 1.568 0Z"/></svg>`,
    BACK_ICON: (0, $7mSD6.svg)`<svg width="10" height="18" viewBox="0 0 10 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.735.179a.75.75 0 0 1 .087 1.057L2.92 8.192a1.25 1.25 0 0 0 0 1.617l5.902 6.956a.75.75 0 1 1-1.144.97L1.776 10.78a2.75 2.75 0 0 1 0-3.559L7.678.265A.75.75 0 0 1 8.735.18Z" fill="#fff"/></svg>`,
    COPY_ICON: (0, $7mSD6.svg)`<svg width="24" height="24" fill="none"><path fill="#fff" fill-rule="evenodd" d="M7.01 7.01c.03-1.545.138-2.5.535-3.28A5 5 0 0 1 9.73 1.545C10.8 1 12.2 1 15 1c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C23 4.8 23 6.2 23 9c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185c-.78.397-1.735.505-3.28.534l-.001.01c-.03 1.54-.138 2.493-.534 3.27a5 5 0 0 1-2.185 2.186C13.2 23 11.8 23 9 23c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C1 19.2 1 17.8 1 15c0-2.8 0-4.2.545-5.27A5 5 0 0 1 3.73 7.545C4.508 7.149 5.46 7.04 7 7.01h.01ZM15 15.5c-1.425 0-2.403-.001-3.162-.063-.74-.06-1.139-.172-1.427-.319a3.5 3.5 0 0 1-1.53-1.529c-.146-.288-.257-.686-.318-1.427C8.501 11.403 8.5 10.425 8.5 9c0-1.425.001-2.403.063-3.162.06-.74.172-1.139.318-1.427a3.5 3.5 0 0 1 1.53-1.53c.288-.146.686-.257 1.427-.318.759-.062 1.737-.063 3.162-.063 1.425 0 2.403.001 3.162.063.74.06 1.139.172 1.427.318a3.5 3.5 0 0 1 1.53 1.53c.146.288.257.686.318 1.427.062.759.063 1.737.063 3.162 0 1.425-.001 2.403-.063 3.162-.06.74-.172 1.139-.319 1.427a3.5 3.5 0 0 1-1.529 1.53c-.288.146-.686.257-1.427.318-.759.062-1.737.063-3.162.063ZM7 8.511c-.444.009-.825.025-1.162.052-.74.06-1.139.172-1.427.318a3.5 3.5 0 0 0-1.53 1.53c-.146.288-.257.686-.318 1.427-.062.759-.063 1.737-.063 3.162 0 1.425.001 2.403.063 3.162.06.74.172 1.139.318 1.427a3.5 3.5 0 0 0 1.53 1.53c.288.146.686.257 1.427.318.759.062 1.737.063 3.162.063 1.425 0 2.403-.001 3.162-.063.74-.06 1.139-.172 1.427-.319a3.5 3.5 0 0 0 1.53-1.53c.146-.287.257-.685.318-1.426.027-.337.043-.718.052-1.162H15c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C7 13.2 7 11.8 7 9v-.489Z" clip-rule="evenodd"/></svg>`,
    RETRY_ICON: (0, $7mSD6.svg)`<svg width="15" height="16" viewBox="0 0 15 16"><path d="M6.464 2.03A.75.75 0 0 0 5.403.97L2.08 4.293a1 1 0 0 0 0 1.414L5.403 9.03a.75.75 0 0 0 1.06-1.06L4.672 6.177a.25.25 0 0 1 .177-.427h2.085a4 4 0 1 1-3.93 4.746c-.077-.407-.405-.746-.82-.746-.414 0-.755.338-.7.748a5.501 5.501 0 1 0 5.45-6.248H4.848a.25.25 0 0 1-.177-.427L6.464 2.03Z" fill="#fff"/></svg>`,
    DESKTOP_ICON: (0, $7mSD6.svg)`<svg width="16" height="16" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C2.204 1 3.13 1 4.98 1h6.04c1.85 0 2.775 0 3.466.394a3 3 0 0 1 1.12 1.12C16 3.204 16 4.13 16 5.98v1.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C13.796 12 12.87 12 11.02 12H4.98c-1.85 0-2.775 0-3.466-.394a3 3 0 0 1-1.12-1.12C0 9.796 0 8.87 0 7.02V5.98ZM4.98 2.5h6.04c.953 0 1.568.001 2.034.043.446.04.608.108.69.154a1.5 1.5 0 0 1 .559.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033v1.04c0 .952-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.046-.243.114-.69.154-.466.042-1.08.043-2.033.043H4.98c-.952 0-1.568-.001-2.034-.043-.446-.04-.608-.108-.69-.154a1.5 1.5 0 0 1-.559-.56c-.046-.08-.114-.243-.154-.69-.042-.465-.043-1.08-.043-2.033V5.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.046.243-.114.69-.154.465-.042 1.08-.043 2.033-.043Z" fill="#fff"/><path d="M4 14.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,
    MOBILE_ICON: (0, $7mSD6.svg)`<svg width="16" height="16" viewBox="0 0 16 16"><path d="M6.75 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C5.204 0 6.136 0 8 0s2.795 0 3.486.394a3 3 0 0 1 1.12 1.12C13 2.204 13 3.13 13 4.98v6.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C10.796 16 9.864 16 8 16s-2.795 0-3.486-.394a3 3 0 0 1-1.12-1.12C3 13.796 3 12.87 3 11.02V4.98Zm8.5 0v6.04c0 .953-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.045-.242.113-.693.154-.47.042-1.091.043-2.05.043-.959 0-1.58-.001-2.05-.043-.45-.04-.613-.109-.693-.154a1.5 1.5 0 0 1-.56-.56c-.046-.08-.114-.243-.154-.69-.042-.466-.043-1.08-.043-2.033V4.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.045.243-.113.693-.154C6.42 1.501 7.041 1.5 8 1.5c.959 0 1.58.001 2.05.043.45.04.613.109.693.154a1.5 1.5 0 0 1 .56.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033Z" fill="#fff"/></svg>`,
    ARROW_DOWN_ICON: (0, $7mSD6.svg)`<svg width="14" height="14" viewBox="0 0 14 14"><path d="M2.28 7.47a.75.75 0 0 0-1.06 1.06l5.25 5.25a.75.75 0 0 0 1.06 0l5.25-5.25a.75.75 0 0 0-1.06-1.06l-3.544 3.543a.25.25 0 0 1-.426-.177V.75a.75.75 0 0 0-1.5 0v10.086a.25.25 0 0 1-.427.176L2.28 7.47Z" fill="#fff"/></svg>`,
    ARROW_UP_RIGHT_ICON: (0, $7mSD6.svg)`<svg width="15" height="14" fill="none"><path d="M4.5 1.75A.75.75 0 0 1 5.25 1H12a1.5 1.5 0 0 1 1.5 1.5v6.75a.75.75 0 0 1-1.5 0V4.164a.25.25 0 0 0-.427-.176L4.061 11.5A.75.75 0 0 1 3 10.44l7.513-7.513a.25.25 0 0 0-.177-.427H5.25a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,
    ARROW_RIGHT_ICON: (0, $7mSD6.svg)`<svg width="6" height="14" viewBox="0 0 6 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.181 1.099a.75.75 0 0 1 1.024.279l2.433 4.258a2.75 2.75 0 0 1 0 2.729l-2.433 4.257a.75.75 0 1 1-1.303-.744L4.335 7.62a1.25 1.25 0 0 0 0-1.24L1.902 2.122a.75.75 0 0 1 .28-1.023Z" fill="#fff"/></svg>`,
    QRCODE_ICON: (0, $7mSD6.svg)`<svg width="25" height="24" viewBox="0 0 25 24"><path d="M23.748 9a.748.748 0 0 0 .748-.752c-.018-2.596-.128-4.07-.784-5.22a6 6 0 0 0-2.24-2.24c-1.15-.656-2.624-.766-5.22-.784a.748.748 0 0 0-.752.748c0 .414.335.749.748.752 1.015.007 1.82.028 2.494.088.995.09 1.561.256 1.988.5.7.398 1.28.978 1.679 1.678.243.427.41.993.498 1.988.061.675.082 1.479.09 2.493a.753.753 0 0 0 .75.749ZM3.527.788C4.677.132 6.152.022 8.747.004A.748.748 0 0 1 9.5.752a.753.753 0 0 1-.749.752c-1.014.007-1.818.028-2.493.088-.995.09-1.561.256-1.988.5-.7.398-1.28.978-1.679 1.678-.243.427-.41.993-.499 1.988-.06.675-.081 1.479-.088 2.493A.753.753 0 0 1 1.252 9a.748.748 0 0 1-.748-.752c.018-2.596.128-4.07.784-5.22a6 6 0 0 1 2.24-2.24ZM1.252 15a.748.748 0 0 0-.748.752c.018 2.596.128 4.07.784 5.22a6 6 0 0 0 2.24 2.24c1.15.656 2.624.766 5.22.784a.748.748 0 0 0 .752-.748.753.753 0 0 0-.749-.752c-1.014-.007-1.818-.028-2.493-.089-.995-.089-1.561-.255-1.988-.498a4.5 4.5 0 0 1-1.679-1.68c-.243-.426-.41-.992-.499-1.987-.06-.675-.081-1.479-.088-2.493A.753.753 0 0 0 1.252 15ZM22.996 15.749a.753.753 0 0 1 .752-.749c.415 0 .751.338.748.752-.018 2.596-.128 4.07-.784 5.22a6 6 0 0 1-2.24 2.24c-1.15.656-2.624.766-5.22.784a.748.748 0 0 1-.752-.748c0-.414.335-.749.748-.752 1.015-.007 1.82-.028 2.494-.089.995-.089 1.561-.255 1.988-.498a4.5 4.5 0 0 0 1.679-1.68c.243-.426.41-.992.498-1.987.061-.675.082-1.479.09-2.493Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 11h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 4H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM13.5 6.5A2.5 2.5 0 0 1 16 4h2a2.5 2.5 0 0 1 2.5 2.5v2A2.5 2.5 0 0 1 18 11h-2a2.5 2.5 0 0 1-2.5-2.5v-2Zm2.5-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1ZM7 13a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 20h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 13H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z" fill="#fff"/><path d="M13.5 15.5c0-.465 0-.697.038-.89a2 2 0 0 1 1.572-1.572C15.303 13 15.535 13 16 13v2.5h-2.5ZM18 13c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89H18V13ZM18 17.5h2.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C18.697 20 18.465 20 18 20v-2.5ZM13.5 17.5H16V20c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572c-.038-.193-.038-.425-.038-.89Z" fill="#fff"/></svg>`,
    SCAN_ICON: (0, $7mSD6.svg)`<svg width="16" height="16" fill="none"><path fill="#fff" d="M10 15.216c0 .422.347.763.768.74 1.202-.064 2.025-.222 2.71-.613a5.001 5.001 0 0 0 1.865-1.866c.39-.684.549-1.507.613-2.709a.735.735 0 0 0-.74-.768.768.768 0 0 0-.76.732c-.009.157-.02.306-.032.447-.073.812-.206 1.244-.384 1.555-.31.545-.761.996-1.306 1.306-.311.178-.743.311-1.555.384-.141.013-.29.023-.447.032a.768.768 0 0 0-.732.76ZM10 .784c0 .407.325.737.732.76.157.009.306.02.447.032.812.073 1.244.206 1.555.384a3.5 3.5 0 0 1 1.306 1.306c.178.311.311.743.384 1.555.013.142.023.29.032.447a.768.768 0 0 0 .76.732.734.734 0 0 0 .74-.768c-.064-1.202-.222-2.025-.613-2.71A5 5 0 0 0 13.477.658c-.684-.39-1.507-.549-2.709-.613a.735.735 0 0 0-.768.74ZM5.232.044A.735.735 0 0 1 6 .784a.768.768 0 0 1-.732.76c-.157.009-.305.02-.447.032-.812.073-1.244.206-1.555.384A3.5 3.5 0 0 0 1.96 3.266c-.178.311-.311.743-.384 1.555-.013.142-.023.29-.032.447A.768.768 0 0 1 .784 6a.735.735 0 0 1-.74-.768c.064-1.202.222-2.025.613-2.71A5 5 0 0 1 2.523.658C3.207.267 4.03.108 5.233.044ZM5.268 14.456a.768.768 0 0 1 .732.76.734.734 0 0 1-.768.74c-1.202-.064-2.025-.222-2.71-.613a5 5 0 0 1-1.865-1.866c-.39-.684-.549-1.507-.613-2.709A.735.735 0 0 1 .784 10c.407 0 .737.325.76.732.009.157.02.306.032.447.073.812.206 1.244.384 1.555a3.5 3.5 0 0 0 1.306 1.306c.311.178.743.311 1.555.384.142.013.29.023.447.032Z"/></svg>`,
    CHECKMARK_ICON: (0, $7mSD6.svg)`<svg width="13" height="12" viewBox="0 0 13 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.155.132a.75.75 0 0 1 .232 1.035L5.821 11.535a1 1 0 0 1-1.626.09L.665 7.21a.75.75 0 1 1 1.17-.937L4.71 9.867a.25.25 0 0 0 .406-.023L11.12.364a.75.75 0 0 1 1.035-.232Z" fill="#fff"/></svg>`,
    SEARCH_ICON: (0, $7mSD6.svg)`<svg width="20" height="21"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.432 13.992c-.354-.353-.91-.382-1.35-.146a5.5 5.5 0 1 1 2.265-2.265c-.237.441-.208.997.145 1.35l3.296 3.296a.75.75 0 1 1-1.06 1.061l-3.296-3.296Zm.06-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" fill="#949E9E"/></svg>`,
    WALLET_PLACEHOLDER: (0, $7mSD6.svg)`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#q)"><path id="wallet-placeholder-fill" fill="#fff" d="M0 24.9c0-9.251 0-13.877 1.97-17.332a15 15 0 0 1 5.598-5.597C11.023 0 15.648 0 24.9 0h10.2c9.252 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.598C60 11.023 60 15.648 60 24.9v10.2c0 9.252 0 13.877-1.97 17.332a15.001 15.001 0 0 1-5.598 5.597C48.977 60 44.352 60 35.1 60H24.9c-9.251 0-13.877 0-17.332-1.97a15 15 0 0 1-5.597-5.598C0 48.977 0 44.352 0 35.1V24.9Z"/><path id="wallet-placeholder-dash" stroke="#000" stroke-dasharray="4 4" stroke-width="1.5" d="M.04 41.708a231.598 231.598 0 0 1-.039-4.403l.75-.001L.75 35.1v-2.55H0v-5.1h.75V24.9l.001-2.204h-.75c.003-1.617.011-3.077.039-4.404l.75.016c.034-1.65.099-3.08.218-4.343l-.746-.07c.158-1.678.412-3.083.82-4.316l.713.236c.224-.679.497-1.296.827-1.875a14.25 14.25 0 0 1 1.05-1.585L3.076 5.9A15 15 0 0 1 5.9 3.076l.455.596a14.25 14.25 0 0 1 1.585-1.05c.579-.33 1.196-.603 1.875-.827l-.236-.712C10.812.674 12.217.42 13.895.262l.07.746C15.23.89 16.66.824 18.308.79l-.016-.75C19.62.012 21.08.004 22.695.001l.001.75L24.9.75h2.55V0h5.1v.75h2.55l2.204.001v-.75c1.617.003 3.077.011 4.404.039l-.016.75c1.65.034 3.08.099 4.343.218l.07-.746c1.678.158 3.083.412 4.316.82l-.236.713c.679.224 1.296.497 1.875.827a14.24 14.24 0 0 1 1.585 1.05l.455-.596A14.999 14.999 0 0 1 56.924 5.9l-.596.455c.384.502.735 1.032 1.05 1.585.33.579.602 1.196.827 1.875l.712-.236c.409 1.233.663 2.638.822 4.316l-.747.07c.119 1.264.184 2.694.218 4.343l.75-.016c.028 1.327.036 2.787.039 4.403l-.75.001.001 2.204v2.55H60v5.1h-.75v2.55l-.001 2.204h.75a231.431 231.431 0 0 1-.039 4.404l-.75-.016c-.034 1.65-.099 3.08-.218 4.343l.747.07c-.159 1.678-.413 3.083-.822 4.316l-.712-.236a10.255 10.255 0 0 1-.827 1.875 14.242 14.242 0 0 1-1.05 1.585l.596.455a14.997 14.997 0 0 1-2.824 2.824l-.455-.596c-.502.384-1.032.735-1.585 1.05-.579.33-1.196.602-1.875.827l.236.712c-1.233.409-2.638.663-4.316.822l-.07-.747c-1.264.119-2.694.184-4.343.218l.016.75c-1.327.028-2.787.036-4.403.039l-.001-.75-2.204.001h-2.55V60h-5.1v-.75H24.9l-2.204-.001v.75a231.431 231.431 0 0 1-4.404-.039l.016-.75c-1.65-.034-3.08-.099-4.343-.218l-.07.747c-1.678-.159-3.083-.413-4.316-.822l.236-.712a10.258 10.258 0 0 1-1.875-.827 14.252 14.252 0 0 1-1.585-1.05l-.455.596A14.999 14.999 0 0 1 3.076 54.1l.596-.455a14.24 14.24 0 0 1-1.05-1.585 10.259 10.259 0 0 1-.827-1.875l-.712.236C.674 49.188.42 47.783.262 46.105l.746-.07C.89 44.77.824 43.34.79 41.692l-.75.016Z"/><path fill="#fff" fill-rule="evenodd" d="M35.643 32.145c-.297-.743-.445-1.114-.401-1.275a.42.42 0 0 1 .182-.27c.134-.1.463-.1 1.123-.1.742 0 1.499.046 2.236-.05a6 6 0 0 0 5.166-5.166c.051-.39.051-.855.051-1.784 0-.928 0-1.393-.051-1.783a6 6 0 0 0-5.166-5.165c-.39-.052-.854-.052-1.783-.052h-7.72c-4.934 0-7.401 0-9.244 1.051a8 8 0 0 0-2.985 2.986C16.057 22.28 16.003 24.58 16 29 15.998 31.075 16 33.15 16 35.224A7.778 7.778 0 0 0 23.778 43H28.5c1.394 0 2.09 0 2.67-.116a6 6 0 0 0 4.715-4.714c.115-.58.115-1.301.115-2.744 0-1.31 0-1.964-.114-2.49a4.998 4.998 0 0 0-.243-.792Z" clip-rule="evenodd"/><path fill="#9EA9A9" fill-rule="evenodd" d="M37 18h-7.72c-2.494 0-4.266.002-5.647.126-1.361.122-2.197.354-2.854.728a6.5 6.5 0 0 0-2.425 2.426c-.375.657-.607 1.492-.729 2.853-.11 1.233-.123 2.777-.125 4.867 0 .7 0 1.05.097 1.181.096.13.182.181.343.2.163.02.518-.18 1.229-.581a6.195 6.195 0 0 1 3.053-.8H37c.977 0 1.32-.003 1.587-.038a4.5 4.5 0 0 0 3.874-3.874c.036-.268.039-.611.039-1.588 0-.976-.003-1.319-.038-1.587a4.5 4.5 0 0 0-3.875-3.874C38.32 18.004 37.977 18 37 18Zm-7.364 12.5h-7.414a4.722 4.722 0 0 0-4.722 4.723 6.278 6.278 0 0 0 6.278 6.278H28.5c1.466 0 1.98-.008 2.378-.087a4.5 4.5 0 0 0 3.535-3.536c.08-.397.087-.933.087-2.451 0-1.391-.009-1.843-.08-2.17a3.5 3.5 0 0 0-2.676-2.676c-.328-.072-.762-.08-2.108-.08Z" clip-rule="evenodd"/></g><defs><clipPath id="q"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,
    GLOBE_ICON: (0, $7mSD6.svg)`<svg width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#fff" fill-rule="evenodd" d="M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm-2.113.75c.301 0 .535.264.47.558a6.01 6.01 0 0 1-2.867 3.896c-.203.116-.42-.103-.334-.32.409-1.018.691-2.274.797-3.657a.512.512 0 0 1 .507-.477h1.427Zm.47-2.058c.065.294-.169.558-.47.558H11.96a.512.512 0 0 1-.507-.477c-.106-1.383-.389-2.638-.797-3.656-.087-.217.13-.437.333-.32a6.01 6.01 0 0 1 2.868 3.895Zm-4.402.558c.286 0 .515-.24.49-.525-.121-1.361-.429-2.534-.83-3.393-.279-.6-.549-.93-.753-1.112a.535.535 0 0 0-.724 0c-.204.182-.474.513-.754 1.112-.4.859-.708 2.032-.828 3.393a.486.486 0 0 0 .49.525h2.909Zm-5.415 0c.267 0 .486-.21.507-.477.106-1.383.389-2.638.797-3.656.087-.217-.13-.437-.333-.32a6.01 6.01 0 0 0-2.868 3.895c-.065.294.169.558.47.558H4.04ZM2.143 9.308c-.065-.294.169-.558.47-.558H4.04c.267 0 .486.21.507.477.106 1.383.389 2.639.797 3.657.087.217-.13.436-.333.32a6.01 6.01 0 0 1-2.868-3.896Zm3.913-.033a.486.486 0 0 1 .49-.525h2.909c.286 0 .515.24.49.525-.121 1.361-.428 2.535-.83 3.394-.279.6-.549.93-.753 1.112a.535.535 0 0 1-.724 0c-.204-.182-.474-.513-.754-1.112-.4-.859-.708-2.033-.828-3.394Z" clip-rule="evenodd"/></svg>`
}, $e634d3d4b646501e$var$pt = (0, $lEG98.css)`.wcm-toolbar-placeholder{top:0;bottom:0;left:0;right:0;width:100%;position:absolute;display:block;pointer-events:none;height:100px;border-radius:calc(var(--wcm-background-border-radius) * .9);background-color:var(--wcm-background-color);background-position:center;background-size:cover}.wcm-toolbar{height:38px;display:flex;position:relative;margin:5px 15px 5px 5px;justify-content:space-between;align-items:center}.wcm-toolbar img,.wcm-toolbar svg{height:28px;object-position:left center;object-fit:contain}#wcm-wc-logo path{fill:var(--wcm-accent-fill-color)}button{width:28px;height:28px;border-radius:var(--wcm-icon-button-border-radius);border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;background-color:var(--wcm-color-bg-1);box-shadow:0 0 0 1px var(--wcm-color-overlay)}button:active{background-color:var(--wcm-color-bg-2)}button svg{display:block;object-position:center}button path{fill:var(--wcm-color-fg-1)}.wcm-toolbar div{display:flex}@media(hover:hover){button:hover{background-color:var(--wcm-color-bg-2)}}`;
var $e634d3d4b646501e$var$gt = Object.defineProperty, $e634d3d4b646501e$var$vt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ut = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$vt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$gt(o, r, t), t;
};
let $e634d3d4b646501e$var$fe = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<div class="wcm-toolbar-placeholder"></div><div class="wcm-toolbar">${$e634d3d4b646501e$var$v.WALLET_CONNECT_LOGO} <button @click="${(0, $dYErK.ModalCtrl).close}">${$e634d3d4b646501e$var$v.CROSS_ICON}</button></div>`;
    }
};
$e634d3d4b646501e$var$fe.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$pt
], $e634d3d4b646501e$var$fe = $e634d3d4b646501e$var$ut([
    (0, $7UJjG.customElement)("wcm-modal-backcard")
], $e634d3d4b646501e$var$fe);
const $e634d3d4b646501e$var$bt = (0, $lEG98.css)`main{padding:20px;padding-top:0;width:100%}`;
var $e634d3d4b646501e$var$ft = Object.defineProperty, $e634d3d4b646501e$var$xt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$yt = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$xt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$ft(o, r, t), t;
};
let $e634d3d4b646501e$var$xe = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<main><slot></slot></main>`;
    }
};
$e634d3d4b646501e$var$xe.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$bt
], $e634d3d4b646501e$var$xe = $e634d3d4b646501e$var$yt([
    (0, $7UJjG.customElement)("wcm-modal-content")
], $e634d3d4b646501e$var$xe);
const $e634d3d4b646501e$var$$t = (0, $lEG98.css)`footer{padding:10px;display:flex;flex-direction:column;align-items:inherit;justify-content:inherit;border-top:1px solid var(--wcm-color-bg-2)}`;
var $e634d3d4b646501e$var$Ct = Object.defineProperty, $e634d3d4b646501e$var$kt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Ot = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$kt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Ct(o, r, t), t;
};
let $e634d3d4b646501e$var$ye = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<footer><slot></slot></footer>`;
    }
};
$e634d3d4b646501e$var$ye.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$$t
], $e634d3d4b646501e$var$ye = $e634d3d4b646501e$var$Ot([
    (0, $7UJjG.customElement)("wcm-modal-footer")
], $e634d3d4b646501e$var$ye);
const $e634d3d4b646501e$var$Wt = (0, $lEG98.css)`header{display:flex;justify-content:center;align-items:center;padding:20px;position:relative}.wcm-border{border-bottom:1px solid var(--wcm-color-bg-2);margin-bottom:20px}header button{padding:15px 20px}header button:active{opacity:.5}@media(hover:hover){header button:hover{opacity:.5}}.wcm-back-btn{position:absolute;left:0}.wcm-action-btn{position:absolute;right:0}path{fill:var(--wcm-accent-color)}`;
var $e634d3d4b646501e$var$It = Object.defineProperty, $e634d3d4b646501e$var$Et = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$te = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Et(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$It(o, r, t), t;
};
let $e634d3d4b646501e$var$S = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.title = "", this.onAction = void 0, this.actionIcon = void 0, this.border = !1;
    }
    backBtnTemplate() {
        return (0, $7mSD6.html)`<button class="wcm-back-btn" @click="${(0, $dYErK.RouterCtrl).goBack}">${$e634d3d4b646501e$var$v.BACK_ICON}</button>`;
    }
    actionBtnTemplate() {
        return (0, $7mSD6.html)`<button class="wcm-action-btn" @click="${this.onAction}">${this.actionIcon}</button>`;
    }
    render() {
        const e = {
            "wcm-border": this.border
        }, o = (0, $dYErK.RouterCtrl).state.history.length > 1, r = this.title ? (0, $7mSD6.html)`<wcm-text variant="big-bold">${this.title}</wcm-text>` : (0, $7mSD6.html)`<slot></slot>`;
        return (0, $7mSD6.html)`<header class="${(0, $f1WVg.classMap)(e)}">${o ? this.backBtnTemplate() : null} ${r} ${this.onAction ? this.actionBtnTemplate() : null}</header>`;
    }
};
$e634d3d4b646501e$var$S.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Wt
], $e634d3d4b646501e$var$te([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$S.prototype, "title", 2), $e634d3d4b646501e$var$te([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$S.prototype, "onAction", 2), $e634d3d4b646501e$var$te([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$S.prototype, "actionIcon", 2), $e634d3d4b646501e$var$te([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$S.prototype, "border", 2), $e634d3d4b646501e$var$S = $e634d3d4b646501e$var$te([
    (0, $7UJjG.customElement)("wcm-modal-header")
], $e634d3d4b646501e$var$S);
const $e634d3d4b646501e$var$c = {
    MOBILE_BREAKPOINT: 600,
    WCM_RECENT_WALLET_DATA: "WCM_RECENT_WALLET_DATA",
    EXPLORER_WALLET_URL: "https://explorer.walletconnect.com/?type=wallet",
    getShadowRootElement (e, o) {
        const r = e.renderRoot.querySelector(o);
        if (!r) throw new Error(`${o} not found`);
        return r;
    },
    getWalletIcon ({ id: e, image_id: o }) {
        const { walletImages: r } = (0, $dYErK.ConfigCtrl).state;
        return r != null && r[e] ? r[e] : o ? (0, $dYErK.ExplorerCtrl).getWalletImageUrl(o) : "";
    },
    getWalletName (e, o = !1) {
        return o && e.length > 8 ? `${e.substring(0, 8)}..` : e;
    },
    isMobileAnimation () {
        return window.innerWidth <= $e634d3d4b646501e$var$c.MOBILE_BREAKPOINT;
    },
    async preloadImage (e) {
        const o = new Promise((r, a)=>{
            const t = new Image;
            t.onload = r, t.onerror = a, t.crossOrigin = "anonymous", t.src = e;
        });
        return Promise.race([
            o,
            (0, $dYErK.CoreUtil).wait(3e3)
        ]);
    },
    getErrorMessage (e) {
        return e instanceof Error ? e.message : "Unknown Error";
    },
    debounce (e, o = 500) {
        let r;
        return (...a)=>{
            function t() {
                e(...a);
            }
            r && clearTimeout(r), r = setTimeout(t, o);
        };
    },
    handleMobileLinking (e) {
        const { walletConnectUri: o } = (0, $dYErK.OptionsCtrl).state, { mobile: r, name: a } = e, t = r?.native, l = r?.universal;
        $e634d3d4b646501e$var$c.setRecentWallet(e);
        function i(s) {
            let $ = "";
            t ? $ = (0, $dYErK.CoreUtil).formatUniversalUrl(t, s, a) : l && ($ = (0, $dYErK.CoreUtil).formatNativeUrl(l, s, a)), (0, $dYErK.CoreUtil).openHref($, "_self");
        }
        o && i(o);
    },
    handleAndroidLinking () {
        const { walletConnectUri: e } = (0, $dYErK.OptionsCtrl).state;
        e && ((0, $dYErK.CoreUtil).setWalletConnectAndroidDeepLink(e), (0, $dYErK.CoreUtil).openHref(e, "_self"));
    },
    async handleUriCopy () {
        const { walletConnectUri: e } = (0, $dYErK.OptionsCtrl).state;
        if (e) try {
            await navigator.clipboard.writeText(e), (0, $dYErK.ToastCtrl).openToast("Link copied", "success");
        } catch  {
            (0, $dYErK.ToastCtrl).openToast("Failed to copy", "error");
        }
    },
    getCustomImageUrls () {
        const { walletImages: e } = (0, $dYErK.ConfigCtrl).state, o = Object.values(e ?? {});
        return Object.values(o);
    },
    truncate (e, o = 8) {
        return e.length <= o ? e : `${e.substring(0, 4)}...${e.substring(e.length - 4)}`;
    },
    setRecentWallet (e) {
        try {
            localStorage.setItem($e634d3d4b646501e$var$c.WCM_RECENT_WALLET_DATA, JSON.stringify(e));
        } catch  {
            console.info("Unable to set recent wallet");
        }
    },
    getRecentWallet () {
        try {
            const e = localStorage.getItem($e634d3d4b646501e$var$c.WCM_RECENT_WALLET_DATA);
            return e ? JSON.parse(e) : void 0;
        } catch  {
            console.info("Unable to get recent wallet");
        }
    },
    caseSafeIncludes (e, o) {
        return e.toUpperCase().includes(o.toUpperCase());
    },
    openWalletExplorerUrl () {
        (0, $dYErK.CoreUtil).openHref($e634d3d4b646501e$var$c.EXPLORER_WALLET_URL, "_blank");
    },
    getCachedRouterWalletPlatforms () {
        const { desktop: e, mobile: o } = (0, $dYErK.CoreUtil).getWalletRouterData(), r = Boolean(e?.native), a = Boolean(e?.universal), t = Boolean(o?.native) || Boolean(o?.universal);
        return {
            isDesktop: r,
            isMobile: t,
            isWeb: a
        };
    },
    goToConnectingView (e) {
        (0, $dYErK.RouterCtrl).setData({
            Wallet: e
        });
        const o = (0, $dYErK.CoreUtil).isMobile(), { isDesktop: r, isWeb: a, isMobile: t } = $e634d3d4b646501e$var$c.getCachedRouterWalletPlatforms();
        o ? t ? (0, $dYErK.RouterCtrl).push("MobileConnecting") : a ? (0, $dYErK.RouterCtrl).push("WebConnecting") : (0, $dYErK.RouterCtrl).push("InstallWallet") : r ? (0, $dYErK.RouterCtrl).push("DesktopConnecting") : a ? (0, $dYErK.RouterCtrl).push("WebConnecting") : t ? (0, $dYErK.RouterCtrl).push("MobileQrcodeConnecting") : (0, $dYErK.RouterCtrl).push("InstallWallet");
    }
}, $e634d3d4b646501e$var$Mt = (0, $lEG98.css)`.wcm-router{overflow:hidden;will-change:transform}.wcm-content{display:flex;flex-direction:column}`;
var $e634d3d4b646501e$var$Lt = Object.defineProperty, $e634d3d4b646501e$var$Rt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$$e = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Rt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Lt(o, r, t), t;
};
let $e634d3d4b646501e$var$oe = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.view = (0, $dYErK.RouterCtrl).state.view, this.prevView = (0, $dYErK.RouterCtrl).state.view, this.unsubscribe = void 0, this.oldHeight = "0px", this.resizeObserver = void 0, this.unsubscribe = (0, $dYErK.RouterCtrl).subscribe((e)=>{
            this.view !== e.view && this.onChangeRoute();
        });
    }
    firstUpdated() {
        this.resizeObserver = new ResizeObserver(([e])=>{
            const o = `${e.contentRect.height}px`;
            this.oldHeight !== "0px" && (0, $4TjqH.animate)(this.routerEl, {
                height: [
                    this.oldHeight,
                    o
                ]
            }, {
                duration: .2
            }), this.oldHeight = o;
        }), this.resizeObserver.observe(this.contentEl);
    }
    disconnectedCallback() {
        var e, o;
        (e = this.unsubscribe) == null || e.call(this), (o = this.resizeObserver) == null || o.disconnect();
    }
    get routerEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-router");
    }
    get contentEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-content");
    }
    viewTemplate() {
        switch(this.view){
            case "ConnectWallet":
                return (0, $7mSD6.html)`<wcm-connect-wallet-view></wcm-connect-wallet-view>`;
            case "DesktopConnecting":
                return (0, $7mSD6.html)`<wcm-desktop-connecting-view></wcm-desktop-connecting-view>`;
            case "MobileConnecting":
                return (0, $7mSD6.html)`<wcm-mobile-connecting-view></wcm-mobile-connecting-view>`;
            case "WebConnecting":
                return (0, $7mSD6.html)`<wcm-web-connecting-view></wcm-web-connecting-view>`;
            case "MobileQrcodeConnecting":
                return (0, $7mSD6.html)`<wcm-mobile-qr-connecting-view></wcm-mobile-qr-connecting-view>`;
            case "WalletExplorer":
                return (0, $7mSD6.html)`<wcm-wallet-explorer-view></wcm-wallet-explorer-view>`;
            case "Qrcode":
                return (0, $7mSD6.html)`<wcm-qrcode-view></wcm-qrcode-view>`;
            case "InstallWallet":
                return (0, $7mSD6.html)`<wcm-install-wallet-view></wcm-install-wallet-view>`;
            default:
                return (0, $7mSD6.html)`<div>Not Found</div>`;
        }
    }
    async onChangeRoute() {
        await (0, $4TjqH.animate)(this.routerEl, {
            opacity: [
                1,
                0
            ],
            scale: [
                1,
                1.02
            ]
        }, {
            duration: .15,
            delay: .1
        }).finished, this.view = (0, $dYErK.RouterCtrl).state.view, (0, $4TjqH.animate)(this.routerEl, {
            opacity: [
                0,
                1
            ],
            scale: [
                .99,
                1
            ]
        }, {
            duration: .37,
            delay: .05
        });
    }
    render() {
        return (0, $7mSD6.html)`<div class="wcm-router"><div class="wcm-content">${this.viewTemplate()}</div></div>`;
    }
};
$e634d3d4b646501e$var$oe.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Mt
], $e634d3d4b646501e$var$$e([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$oe.prototype, "view", 2), $e634d3d4b646501e$var$$e([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$oe.prototype, "prevView", 2), $e634d3d4b646501e$var$oe = $e634d3d4b646501e$var$$e([
    (0, $7UJjG.customElement)("wcm-modal-router")
], $e634d3d4b646501e$var$oe);
const $e634d3d4b646501e$var$At = (0, $lEG98.css)`div{height:36px;width:max-content;display:flex;justify-content:center;align-items:center;padding:9px 15px 11px;position:absolute;top:12px;box-shadow:0 6px 14px -6px rgba(10,16,31,.3),0 10px 32px -4px rgba(10,16,31,.15);z-index:2;left:50%;transform:translateX(-50%);pointer-events:none;backdrop-filter:blur(20px) saturate(1.8);-webkit-backdrop-filter:blur(20px) saturate(1.8);border-radius:var(--wcm-notification-border-radius);border:1px solid var(--wcm-color-overlay);background-color:var(--wcm-color-overlay)}svg{margin-right:5px}@-moz-document url-prefix(){div{background-color:var(--wcm-color-bg-3)}}.wcm-success path{fill:var(--wcm-accent-color)}.wcm-error path{fill:var(--wcm-error-color)}`;
var $e634d3d4b646501e$var$Pt = Object.defineProperty, $e634d3d4b646501e$var$Tt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ze = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Tt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Pt(o, r, t), t;
};
let $e634d3d4b646501e$var$ne = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.open = !1, this.unsubscribe = void 0, this.timeout = void 0, this.unsubscribe = (0, $dYErK.ToastCtrl).subscribe((e)=>{
            e.open ? (this.open = !0, this.timeout = setTimeout(()=>(0, $dYErK.ToastCtrl).closeToast(), 2200)) : (this.open = !1, clearTimeout(this.timeout));
        });
    }
    disconnectedCallback() {
        var e;
        (e = this.unsubscribe) == null || e.call(this), clearTimeout(this.timeout), (0, $dYErK.ToastCtrl).closeToast();
    }
    render() {
        const { message: e, variant: o } = (0, $dYErK.ToastCtrl).state, r = {
            "wcm-success": o === "success",
            "wcm-error": o === "error"
        };
        return this.open ? (0, $7mSD6.html)`<div class="${(0, $f1WVg.classMap)(r)}">${o === "success" ? $e634d3d4b646501e$var$v.CHECKMARK_ICON : null} ${o === "error" ? $e634d3d4b646501e$var$v.CROSS_ICON : null}<wcm-text variant="small-regular">${e}</wcm-text></div>` : null;
    }
};
$e634d3d4b646501e$var$ne.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$At
], $e634d3d4b646501e$var$ze([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$ne.prototype, "open", 2), $e634d3d4b646501e$var$ne = $e634d3d4b646501e$var$ze([
    (0, $7UJjG.customElement)("wcm-modal-toast")
], $e634d3d4b646501e$var$ne);
const $e634d3d4b646501e$var$jt = .1, $e634d3d4b646501e$var$Ve = 2.5, $e634d3d4b646501e$var$A = 7;
function $e634d3d4b646501e$var$Ce(e, o, r) {
    return e === o ? !1 : (e - o < 0 ? o - e : e - o) <= r + $e634d3d4b646501e$var$jt;
}
function $e634d3d4b646501e$var$_t(e, o) {
    const r = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($doQTd))).create(e, {
        errorCorrectionLevel: o
    }).modules.data, 0), a = Math.sqrt(r.length);
    return r.reduce((t, l, i)=>(i % a === 0 ? t.push([
            l
        ]) : t[t.length - 1].push(l)) && t, []);
}
const $e634d3d4b646501e$var$Dt = {
    generate (e, o, r) {
        const a = "#141414", t = "#ffffff", l = [], i = $e634d3d4b646501e$var$_t(e, "Q"), s = o / i.length, $ = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        $.forEach(({ x: y, y: u })=>{
            const O = (i.length - $e634d3d4b646501e$var$A) * s * y, b = (i.length - $e634d3d4b646501e$var$A) * s * u, E = .45;
            for(let M = 0; M < $.length; M += 1){
                const V = s * ($e634d3d4b646501e$var$A - M * 2);
                l.push((0, $7mSD6.svg)`<rect fill="${M % 2 === 0 ? a : t}" height="${V}" rx="${V * E}" ry="${V * E}" width="${V}" x="${O + s * M}" y="${b + s * M}">`);
            }
        });
        const f = Math.floor((r + 25) / s), Ne = i.length / 2 - f / 2, Ze = i.length / 2 + f / 2 - 1, Se = [];
        i.forEach((y, u)=>{
            y.forEach((O, b)=>{
                if (i[u][b] && !(u < $e634d3d4b646501e$var$A && b < $e634d3d4b646501e$var$A || u > i.length - ($e634d3d4b646501e$var$A + 1) && b < $e634d3d4b646501e$var$A || u < $e634d3d4b646501e$var$A && b > i.length - ($e634d3d4b646501e$var$A + 1)) && !(u > Ne && u < Ze && b > Ne && b < Ze)) {
                    const E = u * s + s / 2, M = b * s + s / 2;
                    Se.push([
                        E,
                        M
                    ]);
                }
            });
        });
        const J = {};
        return Se.forEach(([y, u])=>{
            J[y] ? J[y].push(u) : J[y] = [
                u
            ];
        }), Object.entries(J).map(([y, u])=>{
            const O = u.filter((b)=>u.every((E)=>!$e634d3d4b646501e$var$Ce(b, E, s)));
            return [
                Number(y),
                O
            ];
        }).forEach(([y, u])=>{
            u.forEach((O)=>{
                l.push((0, $7mSD6.svg)`<circle cx="${y}" cy="${O}" fill="${a}" r="${s / $e634d3d4b646501e$var$Ve}">`);
            });
        }), Object.entries(J).filter(([y, u])=>u.length > 1).map(([y, u])=>{
            const O = u.filter((b)=>u.some((E)=>$e634d3d4b646501e$var$Ce(b, E, s)));
            return [
                Number(y),
                O
            ];
        }).map(([y, u])=>{
            u.sort((b, E)=>b < E ? -1 : 1);
            const O = [];
            for (const b of u){
                const E = O.find((M)=>M.some((V)=>$e634d3d4b646501e$var$Ce(b, V, s)));
                E ? E.push(b) : O.push([
                    b
                ]);
            }
            return [
                y,
                O.map((b)=>[
                        b[0],
                        b[b.length - 1]
                    ])
            ];
        }).forEach(([y, u])=>{
            u.forEach(([O, b])=>{
                l.push((0, $7mSD6.svg)`<line x1="${y}" x2="${y}" y1="${O}" y2="${b}" stroke="${a}" stroke-width="${s / ($e634d3d4b646501e$var$Ve / 2)}" stroke-linecap="round">`);
            });
        }), l;
    }
}, $e634d3d4b646501e$var$Nt = (0, $lEG98.css)`@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}div{position:relative;user-select:none;display:block;overflow:hidden;aspect-ratio:1/1;animation:fadeIn ease .2s}.wcm-dark{background-color:#fff;border-radius:var(--wcm-container-border-radius);padding:18px;box-shadow:0 2px 5px #000}svg:first-child,wcm-wallet-image{position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%)}wcm-wallet-image{transform:translateY(-50%) translateX(-50%)}wcm-wallet-image{width:25%;height:25%;border-radius:var(--wcm-wallet-icon-border-radius)}svg:first-child{transform:translateY(-50%) translateX(-50%) scale(.9)}svg:first-child path:first-child{fill:var(--wcm-accent-color)}svg:first-child path:last-child{stroke:var(--wcm-color-overlay)}`;
var $e634d3d4b646501e$var$Zt = Object.defineProperty, $e634d3d4b646501e$var$St = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$q = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$St(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Zt(o, r, t), t;
};
let $e634d3d4b646501e$export$9681a3251bf7934f = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.uri = "", this.size = 0, this.imageId = void 0, this.walletId = void 0, this.imageUrl = void 0;
    }
    svgTemplate() {
        const e = (0, $dYErK.ThemeCtrl).state.themeMode === "light" ? this.size : this.size - 36;
        return (0, $7mSD6.svg)`<svg height="${e}" width="${e}">${$e634d3d4b646501e$var$Dt.generate(this.uri, e, e / 4)}</svg>`;
    }
    render() {
        const e = {
            "wcm-dark": (0, $dYErK.ThemeCtrl).state.themeMode === "dark"
        };
        return (0, $7mSD6.html)`<div style="${`width: ${this.size}px`}" class="${(0, $f1WVg.classMap)(e)}">${this.walletId || this.imageUrl ? (0, $7mSD6.html)`<wcm-wallet-image walletId="${(0, $7He6a.ifDefined)(this.walletId)}" imageId="${(0, $7He6a.ifDefined)(this.imageId)}" imageUrl="${(0, $7He6a.ifDefined)(this.imageUrl)}"></wcm-wallet-image>` : $e634d3d4b646501e$var$v.WALLET_CONNECT_ICON_COLORED} ${this.svgTemplate()}</div>`;
    }
};
$e634d3d4b646501e$export$9681a3251bf7934f.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Nt
], $e634d3d4b646501e$var$q([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$export$9681a3251bf7934f.prototype, "uri", 2), $e634d3d4b646501e$var$q([
    (0, $N2oWd.property)({
        type: Number
    })
], $e634d3d4b646501e$export$9681a3251bf7934f.prototype, "size", 2), $e634d3d4b646501e$var$q([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$export$9681a3251bf7934f.prototype, "imageId", 2), $e634d3d4b646501e$var$q([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$export$9681a3251bf7934f.prototype, "walletId", 2), $e634d3d4b646501e$var$q([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$export$9681a3251bf7934f.prototype, "imageUrl", 2), $e634d3d4b646501e$export$9681a3251bf7934f = $e634d3d4b646501e$var$q([
    (0, $7UJjG.customElement)("wcm-qrcode")
], $e634d3d4b646501e$export$9681a3251bf7934f);
const $e634d3d4b646501e$var$Bt = (0, $lEG98.css)`:host{position:relative;height:28px;width:80%}input{width:100%;height:100%;line-height:28px!important;border-radius:var(--wcm-input-border-radius);font-style:normal;font-family:-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,Ubuntu,'Helvetica Neue',sans-serif;font-feature-settings:'case' on;font-weight:500;font-size:16px;letter-spacing:-.03em;padding:0 10px 0 34px;transition:.2s all ease;color:var(--wcm-color-fg-1);background-color:var(--wcm-color-bg-3);box-shadow:inset 0 0 0 1px var(--wcm-color-overlay);caret-color:var(--wcm-accent-color)}input::placeholder{color:var(--wcm-color-fg-2)}svg{left:10px;top:4px;pointer-events:none;position:absolute;width:20px;height:20px}input:focus-within{box-shadow:inset 0 0 0 1px var(--wcm-accent-color)}path{fill:var(--wcm-color-fg-2)}`;
var $e634d3d4b646501e$var$Ut = Object.defineProperty, $e634d3d4b646501e$var$Ht = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Fe = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Ht(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Ut(o, r, t), t;
};
let $e634d3d4b646501e$var$ce = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.onChange = ()=>null;
    }
    render() {
        return (0, $7mSD6.html)`<input type="text" @input="${this.onChange}" placeholder="Search wallets"> ${$e634d3d4b646501e$var$v.SEARCH_ICON}`;
    }
};
$e634d3d4b646501e$var$ce.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Bt
], $e634d3d4b646501e$var$Fe([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$ce.prototype, "onChange", 2), $e634d3d4b646501e$var$ce = $e634d3d4b646501e$var$Fe([
    (0, $7UJjG.customElement)("wcm-search-input")
], $e634d3d4b646501e$var$ce);
const $e634d3d4b646501e$var$zt = (0, $lEG98.css)`@keyframes rotate{100%{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}svg{animation:rotate 2s linear infinite;display:flex;justify-content:center;align-items:center}svg circle{stroke-linecap:round;animation:dash 1.5s ease infinite;stroke:var(--wcm-accent-color)}`;
var $e634d3d4b646501e$var$Vt = Object.defineProperty, $e634d3d4b646501e$var$Ft = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$qt = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Ft(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Vt(o, r, t), t;
};
let $e634d3d4b646501e$var$ke = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<svg viewBox="0 0 50 50" width="24" height="24"><circle cx="25" cy="25" r="20" fill="none" stroke-width="4" stroke="#fff"/></svg>`;
    }
};
$e634d3d4b646501e$var$ke.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$zt
], $e634d3d4b646501e$var$ke = $e634d3d4b646501e$var$qt([
    (0, $7UJjG.customElement)("wcm-spinner")
], $e634d3d4b646501e$var$ke);
const $e634d3d4b646501e$var$Qt = (0, $lEG98.css)`span{font-style:normal;font-family:var(--wcm-font-family);font-feature-settings:var(--wcm-font-feature-settings)}.wcm-xsmall-bold{font-family:var(--wcm-text-xsmall-bold-font-family);font-weight:var(--wcm-text-xsmall-bold-weight);font-size:var(--wcm-text-xsmall-bold-size);line-height:var(--wcm-text-xsmall-bold-line-height);letter-spacing:var(--wcm-text-xsmall-bold-letter-spacing);text-transform:var(--wcm-text-xsmall-bold-text-transform)}.wcm-xsmall-regular{font-family:var(--wcm-text-xsmall-regular-font-family);font-weight:var(--wcm-text-xsmall-regular-weight);font-size:var(--wcm-text-xsmall-regular-size);line-height:var(--wcm-text-xsmall-regular-line-height);letter-spacing:var(--wcm-text-xsmall-regular-letter-spacing);text-transform:var(--wcm-text-xsmall-regular-text-transform)}.wcm-small-thin{font-family:var(--wcm-text-small-thin-font-family);font-weight:var(--wcm-text-small-thin-weight);font-size:var(--wcm-text-small-thin-size);line-height:var(--wcm-text-small-thin-line-height);letter-spacing:var(--wcm-text-small-thin-letter-spacing);text-transform:var(--wcm-text-small-thin-text-transform)}.wcm-small-regular{font-family:var(--wcm-text-small-regular-font-family);font-weight:var(--wcm-text-small-regular-weight);font-size:var(--wcm-text-small-regular-size);line-height:var(--wcm-text-small-regular-line-height);letter-spacing:var(--wcm-text-small-regular-letter-spacing);text-transform:var(--wcm-text-small-regular-text-transform)}.wcm-medium-regular{font-family:var(--wcm-text-medium-regular-font-family);font-weight:var(--wcm-text-medium-regular-weight);font-size:var(--wcm-text-medium-regular-size);line-height:var(--wcm-text-medium-regular-line-height);letter-spacing:var(--wcm-text-medium-regular-letter-spacing);text-transform:var(--wcm-text-medium-regular-text-transform)}.wcm-big-bold{font-family:var(--wcm-text-big-bold-font-family);font-weight:var(--wcm-text-big-bold-weight);font-size:var(--wcm-text-big-bold-size);line-height:var(--wcm-text-big-bold-line-height);letter-spacing:var(--wcm-text-big-bold-letter-spacing);text-transform:var(--wcm-text-big-bold-text-transform)}:host(*){color:var(--wcm-color-fg-1)}.wcm-color-primary{color:var(--wcm-color-fg-1)}.wcm-color-secondary{color:var(--wcm-color-fg-2)}.wcm-color-tertiary{color:var(--wcm-color-fg-3)}.wcm-color-inverse{color:var(--wcm-accent-fill-color)}.wcm-color-accnt{color:var(--wcm-accent-color)}.wcm-color-error{color:var(--wcm-error-color)}`;
var $e634d3d4b646501e$var$Kt = Object.defineProperty, $e634d3d4b646501e$var$Yt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Oe = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Yt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Kt(o, r, t), t;
};
let $e634d3d4b646501e$var$re = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.variant = "medium-regular", this.color = "primary";
    }
    render() {
        const e = {
            "wcm-big-bold": this.variant === "big-bold",
            "wcm-medium-regular": this.variant === "medium-regular",
            "wcm-small-regular": this.variant === "small-regular",
            "wcm-small-thin": this.variant === "small-thin",
            "wcm-xsmall-regular": this.variant === "xsmall-regular",
            "wcm-xsmall-bold": this.variant === "xsmall-bold",
            "wcm-color-primary": this.color === "primary",
            "wcm-color-secondary": this.color === "secondary",
            "wcm-color-tertiary": this.color === "tertiary",
            "wcm-color-inverse": this.color === "inverse",
            "wcm-color-accnt": this.color === "accent",
            "wcm-color-error": this.color === "error"
        };
        return (0, $7mSD6.html)`<span><slot class="${(0, $f1WVg.classMap)(e)}"></slot></span>`;
    }
};
$e634d3d4b646501e$var$re.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Qt
], $e634d3d4b646501e$var$Oe([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$re.prototype, "variant", 2), $e634d3d4b646501e$var$Oe([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$re.prototype, "color", 2), $e634d3d4b646501e$var$re = $e634d3d4b646501e$var$Oe([
    (0, $7UJjG.customElement)("wcm-text")
], $e634d3d4b646501e$var$re);
const $e634d3d4b646501e$var$Gt = (0, $lEG98.css)`button{width:100%;height:100%;border-radius:var(--wcm-button-hover-highlight-border-radius);display:flex;align-items:flex-start}button:active{background-color:var(--wcm-color-overlay)}@media(hover:hover){button:hover{background-color:var(--wcm-color-overlay)}}button>div{width:80px;padding:5px 0;display:flex;flex-direction:column;align-items:center}wcm-text{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center}wcm-wallet-image{height:60px;width:60px;transition:all .2s ease;border-radius:var(--wcm-wallet-icon-border-radius);margin-bottom:5px}.wcm-sublabel{margin-top:2px}`;
var $e634d3d4b646501e$var$Xt = Object.defineProperty, $e634d3d4b646501e$var$Jt = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$_ = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Jt(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Xt(o, r, t), t;
};
let $e634d3d4b646501e$var$L = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.onClick = ()=>null, this.name = "", this.walletId = "", this.label = void 0, this.imageId = void 0, this.installed = !1, this.recent = !1;
    }
    sublabelTemplate() {
        return this.recent ? (0, $7mSD6.html)`<wcm-text class="wcm-sublabel" variant="xsmall-bold" color="tertiary">RECENT</wcm-text>` : this.installed ? (0, $7mSD6.html)`<wcm-text class="wcm-sublabel" variant="xsmall-bold" color="tertiary">INSTALLED</wcm-text>` : null;
    }
    handleClick() {
        (0, $dYErK.EventsCtrl).click({
            name: "WALLET_BUTTON",
            walletId: this.walletId
        }), this.onClick();
    }
    render() {
        var e;
        return (0, $7mSD6.html)`<button @click="${this.handleClick.bind(this)}"><div><wcm-wallet-image walletId="${this.walletId}" imageId="${(0, $7He6a.ifDefined)(this.imageId)}"></wcm-wallet-image><wcm-text variant="xsmall-regular">${(e = this.label) != null ? e : $e634d3d4b646501e$var$c.getWalletName(this.name, !0)}</wcm-text>${this.sublabelTemplate()}</div></button>`;
    }
};
$e634d3d4b646501e$var$L.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Gt
], $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$L.prototype, "onClick", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$L.prototype, "name", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$L.prototype, "walletId", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$L.prototype, "label", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$L.prototype, "imageId", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$L.prototype, "installed", 2), $e634d3d4b646501e$var$_([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$L.prototype, "recent", 2), $e634d3d4b646501e$var$L = $e634d3d4b646501e$var$_([
    (0, $7UJjG.customElement)("wcm-wallet-button")
], $e634d3d4b646501e$var$L);
const $e634d3d4b646501e$var$eo = (0, $lEG98.css)`:host{display:block}div{overflow:hidden;position:relative;border-radius:inherit;width:100%;height:100%;background-color:var(--wcm-color-overlay)}svg{position:relative;width:100%;height:100%}div::after{content:'';position:absolute;top:0;bottom:0;left:0;right:0;border-radius:inherit;border:1px solid var(--wcm-color-overlay)}div img{width:100%;height:100%;object-fit:cover;object-position:center}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;
var $e634d3d4b646501e$var$to = Object.defineProperty, $e634d3d4b646501e$var$oo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$se = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$oo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$to(o, r, t), t;
};
let $e634d3d4b646501e$var$Q = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.walletId = "", this.imageId = void 0, this.imageUrl = void 0;
    }
    render() {
        var e;
        const o = (e = this.imageUrl) != null && e.length ? this.imageUrl : $e634d3d4b646501e$var$c.getWalletIcon({
            id: this.walletId,
            image_id: this.imageId
        });
        return (0, $7mSD6.html)`${o.length ? (0, $7mSD6.html)`<div><img crossorigin="anonymous" src="${o}" alt="${this.id}"></div>` : $e634d3d4b646501e$var$v.WALLET_PLACEHOLDER}`;
    }
};
$e634d3d4b646501e$var$Q.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$eo
], $e634d3d4b646501e$var$se([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$Q.prototype, "walletId", 2), $e634d3d4b646501e$var$se([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$Q.prototype, "imageId", 2), $e634d3d4b646501e$var$se([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$Q.prototype, "imageUrl", 2), $e634d3d4b646501e$var$Q = $e634d3d4b646501e$var$se([
    (0, $7UJjG.customElement)("wcm-wallet-image")
], $e634d3d4b646501e$var$Q);
var $e634d3d4b646501e$var$ro = Object.defineProperty, $e634d3d4b646501e$var$ao = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$qe = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$ao(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$ro(o, r, t), t;
};
let $e634d3d4b646501e$var$We = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.preload = !0, this.preloadData();
    }
    async loadImages(e) {
        try {
            e != null && e.length && await Promise.all(e.map(async (o)=>$e634d3d4b646501e$var$c.preloadImage(o)));
        } catch  {
            console.info("Unsuccessful attempt at preloading some images", e);
        }
    }
    async preloadListings() {
        if ((0, $dYErK.ConfigCtrl).state.enableExplorer) {
            await (0, $dYErK.ExplorerCtrl).getRecomendedWallets(), (0, $dYErK.OptionsCtrl).setIsDataLoaded(!0);
            const { recomendedWallets: e } = (0, $dYErK.ExplorerCtrl).state, o = e.map((r)=>$e634d3d4b646501e$var$c.getWalletIcon(r));
            await this.loadImages(o);
        } else (0, $dYErK.OptionsCtrl).setIsDataLoaded(!0);
    }
    async preloadCustomImages() {
        const e = $e634d3d4b646501e$var$c.getCustomImageUrls();
        await this.loadImages(e);
    }
    async preloadData() {
        try {
            this.preload && (this.preload = !1, await Promise.all([
                this.preloadListings(),
                this.preloadCustomImages()
            ]));
        } catch (e) {
            console.error(e), (0, $dYErK.ToastCtrl).openToast("Failed preloading", "error");
        }
    }
};
$e634d3d4b646501e$var$qe([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$We.prototype, "preload", 2), $e634d3d4b646501e$var$We = $e634d3d4b646501e$var$qe([
    (0, $7UJjG.customElement)("wcm-explorer-context")
], $e634d3d4b646501e$var$We);
var $e634d3d4b646501e$var$lo = Object.defineProperty, $e634d3d4b646501e$var$io = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$no = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$io(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$lo(o, r, t), t;
};
let $e634d3d4b646501e$var$Qe = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.unsubscribeTheme = void 0, $e634d3d4b646501e$var$h.setTheme(), this.unsubscribeTheme = (0, $dYErK.ThemeCtrl).subscribe($e634d3d4b646501e$var$h.setTheme);
    }
    disconnectedCallback() {
        var e;
        (e = this.unsubscribeTheme) == null || e.call(this);
    }
};
$e634d3d4b646501e$var$Qe = $e634d3d4b646501e$var$no([
    (0, $7UJjG.customElement)("wcm-theme-context")
], $e634d3d4b646501e$var$Qe);
const $e634d3d4b646501e$var$co = (0, $lEG98.css)`@keyframes scroll{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(calc(-70px * 9),0,0)}}.wcm-slider{position:relative;overflow-x:hidden;padding:10px 0;margin:0 -20px;width:calc(100% + 40px)}.wcm-track{display:flex;width:calc(70px * 18);animation:scroll 20s linear infinite;opacity:.7}.wcm-track svg{margin:0 5px}wcm-wallet-image{width:60px;height:60px;margin:0 5px;border-radius:var(--wcm-wallet-icon-border-radius)}.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between}.wcm-title{display:flex;align-items:center;margin-bottom:10px}.wcm-title svg{margin-right:6px}.wcm-title path{fill:var(--wcm-accent-color)}wcm-modal-footer .wcm-title{padding:0 10px}wcm-button-big{position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);filter:drop-shadow(0 0 17px var(--wcm-color-bg-1))}wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-info-footer wcm-text{text-align:center;margin-bottom:15px}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;
var $e634d3d4b646501e$var$so = Object.defineProperty, $e634d3d4b646501e$var$mo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ho = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$mo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$so(o, r, t), t;
};
let $e634d3d4b646501e$var$Ie = class extends (0, $356Px.LitElement) {
    onGoToQrcode() {
        (0, $dYErK.RouterCtrl).push("Qrcode");
    }
    render() {
        const { recomendedWallets: e } = (0, $dYErK.ExplorerCtrl).state, o = [
            ...e,
            ...e
        ], r = (0, $dYErK.CoreUtil).RECOMMENDED_WALLET_AMOUNT * 2;
        return (0, $7mSD6.html)`<wcm-modal-header title="Connect your wallet" .onAction="${this.onGoToQrcode}" .actionIcon="${$e634d3d4b646501e$var$v.QRCODE_ICON}"></wcm-modal-header><wcm-modal-content><div class="wcm-title">${$e634d3d4b646501e$var$v.MOBILE_ICON}<wcm-text variant="small-regular" color="accent">WalletConnect</wcm-text></div><div class="wcm-slider"><div class="wcm-track">${[
            ...Array(r)
        ].map((a, t)=>{
            const l = o[t % o.length];
            return l ? (0, $7mSD6.html)`<wcm-wallet-image walletId="${l.id}" imageId="${l.image_id}"></wcm-wallet-image>` : $e634d3d4b646501e$var$v.WALLET_PLACEHOLDER;
        })}</div><wcm-button-big @click="${$e634d3d4b646501e$var$c.handleAndroidLinking}"><wcm-text variant="medium-regular" color="inverse">Select Wallet</wcm-text></wcm-button-big></div></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">Choose WalletConnect to see supported apps on your device</wcm-text></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$Ie.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$co
], $e634d3d4b646501e$var$Ie = $e634d3d4b646501e$var$ho([
    (0, $7UJjG.customElement)("wcm-android-wallet-selection")
], $e634d3d4b646501e$var$Ie);
const $e634d3d4b646501e$var$wo = (0, $lEG98.css)`@keyframes loading{to{stroke-dashoffset:0}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(1px,0,0)}30%,50%,70%{transform:translate3d(-2px,0,0)}40%,60%{transform:translate3d(2px,0,0)}}:host{display:flex;flex-direction:column;align-items:center}div{position:relative;width:110px;height:110px;display:flex;justify-content:center;align-items:center;margin:40px 0 20px 0;transform:translate3d(0,0,0)}svg{position:absolute;width:110px;height:110px;fill:none;stroke:transparent;stroke-linecap:round;stroke-width:2px;top:0;left:0}use{stroke:var(--wcm-accent-color);animation:loading 1s linear infinite}wcm-wallet-image{border-radius:var(--wcm-wallet-icon-large-border-radius);width:90px;height:90px}wcm-text{margin-bottom:40px}.wcm-error svg{stroke:var(--wcm-error-color)}.wcm-error use{display:none}.wcm-error{animation:shake .4s cubic-bezier(.36,.07,.19,.97) both}.wcm-stale svg,.wcm-stale use{display:none}`;
var $e634d3d4b646501e$var$po = Object.defineProperty, $e634d3d4b646501e$var$go = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$K = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$go(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$po(o, r, t), t;
};
let $e634d3d4b646501e$var$D = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.walletId = void 0, this.imageId = void 0, this.isError = !1, this.isStale = !1, this.label = "";
    }
    svgLoaderTemplate() {
        var e, o;
        const r = (o = (e = (0, $dYErK.ThemeCtrl).state.themeVariables) == null ? void 0 : e["--wcm-wallet-icon-large-border-radius"]) != null ? o : $e634d3d4b646501e$var$h.getPreset("--wcm-wallet-icon-large-border-radius");
        let a = 0;
        r.includes("%") ? a = 0.88 * parseInt(r, 10) : a = parseInt(r, 10), a *= 1.17;
        const t = 317 - a * 1.57, l = 425 - a * 1.8;
        return (0, $7mSD6.html)`<svg viewBox="0 0 110 110" width="110" height="110"><rect id="wcm-loader" x="2" y="2" width="106" height="106" rx="${a}"/><use xlink:href="#wcm-loader" stroke-dasharray="106 ${t}" stroke-dashoffset="${l}"></use></svg>`;
    }
    render() {
        const e = {
            "wcm-error": this.isError,
            "wcm-stale": this.isStale
        };
        return (0, $7mSD6.html)`<div class="${(0, $f1WVg.classMap)(e)}">${this.svgLoaderTemplate()}<wcm-wallet-image walletId="${(0, $7He6a.ifDefined)(this.walletId)}" imageId="${(0, $7He6a.ifDefined)(this.imageId)}"></wcm-wallet-image></div><wcm-text variant="medium-regular" color="${this.isError ? "error" : "primary"}">${this.isError ? "Connection declined" : this.label}</wcm-text>`;
    }
};
$e634d3d4b646501e$var$D.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$wo
], $e634d3d4b646501e$var$K([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$D.prototype, "walletId", 2), $e634d3d4b646501e$var$K([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$D.prototype, "imageId", 2), $e634d3d4b646501e$var$K([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$D.prototype, "isError", 2), $e634d3d4b646501e$var$K([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$D.prototype, "isStale", 2), $e634d3d4b646501e$var$K([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$D.prototype, "label", 2), $e634d3d4b646501e$var$D = $e634d3d4b646501e$var$K([
    (0, $7UJjG.customElement)("wcm-connector-waiting")
], $e634d3d4b646501e$var$D);
const $e634d3d4b646501e$var$G = {
    manualWallets () {
        var e, o;
        const { mobileWallets: r, desktopWallets: a } = (0, $dYErK.ConfigCtrl).state, t = (e = $e634d3d4b646501e$var$G.recentWallet()) == null ? void 0 : e.id, l = (0, $dYErK.CoreUtil).isMobile() ? r : a, i = l?.filter((s)=>t !== s.id);
        return (o = (0, $dYErK.CoreUtil).isMobile() ? i?.map(({ id: s, name: $, links: f })=>({
                id: s,
                name: $,
                mobile: f,
                links: f
            })) : i?.map(({ id: s, name: $, links: f })=>({
                id: s,
                name: $,
                desktop: f,
                links: f
            }))) != null ? o : [];
    },
    recentWallet () {
        return $e634d3d4b646501e$var$c.getRecentWallet();
    },
    recomendedWallets (e = !1) {
        var o;
        const r = e || (o = $e634d3d4b646501e$var$G.recentWallet()) == null ? void 0 : o.id, { recomendedWallets: a } = (0, $dYErK.ExplorerCtrl).state;
        return a.filter((t)=>r !== t.id);
    }
}, $e634d3d4b646501e$var$Z = {
    onConnecting (e) {
        $e634d3d4b646501e$var$c.goToConnectingView(e);
    },
    manualWalletsTemplate () {
        return $e634d3d4b646501e$var$G.manualWallets().map((e)=>(0, $7mSD6.html)`<wcm-wallet-button walletId="${e.id}" name="${e.name}" .onClick="${()=>this.onConnecting(e)}"></wcm-wallet-button>`);
    },
    recomendedWalletsTemplate (e = !1) {
        return $e634d3d4b646501e$var$G.recomendedWallets(e).map((o)=>(0, $7mSD6.html)`<wcm-wallet-button name="${o.name}" walletId="${o.id}" imageId="${o.image_id}" .onClick="${()=>this.onConnecting(o)}"></wcm-wallet-button>`);
    },
    recentWalletTemplate () {
        const e = $e634d3d4b646501e$var$G.recentWallet();
        if (e) return (0, $7mSD6.html)`<wcm-wallet-button name="${e.name}" walletId="${e.id}" imageId="${(0, $7He6a.ifDefined)(e.image_id)}" .recent="${!0}" .onClick="${()=>this.onConnecting(e)}"></wcm-wallet-button>`;
    }
}, $e634d3d4b646501e$var$vo = (0, $lEG98.css)`.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between}.wcm-desktop-title,.wcm-mobile-title{display:flex;align-items:center}.wcm-mobile-title{justify-content:space-between;margin-bottom:20px;margin-top:-10px}.wcm-desktop-title{margin-bottom:10px;padding:0 10px}.wcm-subtitle{display:flex;align-items:center}.wcm-subtitle:last-child path{fill:var(--wcm-color-fg-3)}.wcm-desktop-title svg,.wcm-mobile-title svg{margin-right:6px}.wcm-desktop-title path,.wcm-mobile-title path{fill:var(--wcm-accent-color)}`;
var $e634d3d4b646501e$var$uo = Object.defineProperty, $e634d3d4b646501e$var$bo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$fo = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$bo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$uo(o, r, t), t;
};
let $e634d3d4b646501e$var$Ee = class extends (0, $356Px.LitElement) {
    render() {
        const { explorerExcludedWalletIds: e, enableExplorer: o } = (0, $dYErK.ConfigCtrl).state, r = e !== "ALL" && o, a = $e634d3d4b646501e$var$Z.manualWalletsTemplate(), t = $e634d3d4b646501e$var$Z.recomendedWalletsTemplate();
        let l = [
            $e634d3d4b646501e$var$Z.recentWalletTemplate(),
            ...a,
            ...t
        ];
        l = l.filter(Boolean);
        const i = l.length > 4 || r;
        let s = [];
        i ? s = l.slice(0, 3) : s = l;
        const $ = Boolean(s.length);
        return (0, $7mSD6.html)`<wcm-modal-header .border="${!0}" title="Connect your wallet" .onAction="${$e634d3d4b646501e$var$c.handleUriCopy}" .actionIcon="${$e634d3d4b646501e$var$v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><div class="wcm-mobile-title"><div class="wcm-subtitle">${$e634d3d4b646501e$var$v.MOBILE_ICON}<wcm-text variant="small-regular" color="accent">Mobile</wcm-text></div><div class="wcm-subtitle">${$e634d3d4b646501e$var$v.SCAN_ICON}<wcm-text variant="small-regular" color="secondary">Scan with your wallet</wcm-text></div></div><wcm-walletconnect-qr></wcm-walletconnect-qr></wcm-modal-content>${$ ? (0, $7mSD6.html)`<wcm-modal-footer><div class="wcm-desktop-title">${$e634d3d4b646501e$var$v.DESKTOP_ICON}<wcm-text variant="small-regular" color="accent">Desktop</wcm-text></div><div class="wcm-grid">${s} ${i ? (0, $7mSD6.html)`<wcm-view-all-wallets-button></wcm-view-all-wallets-button>` : null}</div></wcm-modal-footer>` : null}`;
    }
};
$e634d3d4b646501e$var$Ee.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$vo
], $e634d3d4b646501e$var$Ee = $e634d3d4b646501e$var$fo([
    (0, $7UJjG.customElement)("wcm-desktop-wallet-selection")
], $e634d3d4b646501e$var$Ee);
const $e634d3d4b646501e$var$xo = (0, $lEG98.css)`div{background-color:var(--wcm-color-bg-2);padding:10px 20px 15px 20px;border-top:1px solid var(--wcm-color-bg-3);text-align:center}a{color:var(--wcm-accent-color);text-decoration:none;transition:opacity .2s ease-in-out;display:inline}a:active{opacity:.8}@media(hover:hover){a:hover{opacity:.8}}`;
var $e634d3d4b646501e$var$yo = Object.defineProperty, $e634d3d4b646501e$var$$o = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Co = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$$o(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$yo(o, r, t), t;
};
let $e634d3d4b646501e$var$Me = class extends (0, $356Px.LitElement) {
    render() {
        const { termsOfServiceUrl: e, privacyPolicyUrl: o } = (0, $dYErK.ConfigCtrl).state;
        return e ?? o ? (0, $7mSD6.html)`<div><wcm-text variant="small-regular" color="secondary">By connecting your wallet to this app, you agree to the app's ${e ? (0, $7mSD6.html)`<a href="${e}" target="_blank" rel="noopener noreferrer">Terms of Service</a>` : null} ${e && o ? "and" : null} ${o ? (0, $7mSD6.html)`<a href="${o}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>` : null}</wcm-text></div>` : null;
    }
};
$e634d3d4b646501e$var$Me.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$xo
], $e634d3d4b646501e$var$Me = $e634d3d4b646501e$var$Co([
    (0, $7UJjG.customElement)("wcm-legal-notice")
], $e634d3d4b646501e$var$Me);
const $e634d3d4b646501e$var$ko = (0, $lEG98.css)`div{display:grid;grid-template-columns:repeat(4,80px);margin:0 -10px;justify-content:space-between;row-gap:10px}`;
var $e634d3d4b646501e$var$Oo = Object.defineProperty, $e634d3d4b646501e$var$Wo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Io = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Wo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Oo(o, r, t), t;
};
let $e634d3d4b646501e$var$Le = class extends (0, $356Px.LitElement) {
    onQrcode() {
        (0, $dYErK.RouterCtrl).push("Qrcode");
    }
    render() {
        const { explorerExcludedWalletIds: e, enableExplorer: o } = (0, $dYErK.ConfigCtrl).state, r = e !== "ALL" && o, a = $e634d3d4b646501e$var$Z.manualWalletsTemplate(), t = $e634d3d4b646501e$var$Z.recomendedWalletsTemplate();
        let l = [
            $e634d3d4b646501e$var$Z.recentWalletTemplate(),
            ...a,
            ...t
        ];
        l = l.filter(Boolean);
        const i = l.length > 8 || r;
        let s = [];
        i ? s = l.slice(0, 7) : s = l;
        const $ = Boolean(s.length);
        return (0, $7mSD6.html)`<wcm-modal-header title="Connect your wallet" .onAction="${this.onQrcode}" .actionIcon="${$e634d3d4b646501e$var$v.QRCODE_ICON}"></wcm-modal-header>${$ ? (0, $7mSD6.html)`<wcm-modal-content><div>${s} ${i ? (0, $7mSD6.html)`<wcm-view-all-wallets-button></wcm-view-all-wallets-button>` : null}</div></wcm-modal-content>` : null}`;
    }
};
$e634d3d4b646501e$var$Le.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$ko
], $e634d3d4b646501e$var$Le = $e634d3d4b646501e$var$Io([
    (0, $7UJjG.customElement)("wcm-mobile-wallet-selection")
], $e634d3d4b646501e$var$Le);
const $e634d3d4b646501e$var$Eo = (0, $lEG98.css)`:host{all:initial}.wcm-overlay{top:0;bottom:0;left:0;right:0;position:fixed;z-index:var(--wcm-z-index);overflow:hidden;display:flex;justify-content:center;align-items:center;opacity:0;pointer-events:none;background-color:var(--wcm-overlay-background-color);backdrop-filter:var(--wcm-overlay-backdrop-filter)}@media(max-height:720px) and (orientation:landscape){.wcm-overlay{overflow:scroll;align-items:flex-start;padding:20px 0}}.wcm-active{pointer-events:auto}.wcm-container{position:relative;max-width:360px;width:100%;outline:0;border-radius:var(--wcm-background-border-radius) var(--wcm-background-border-radius) var(--wcm-container-border-radius) var(--wcm-container-border-radius);border:1px solid var(--wcm-color-overlay);overflow:hidden}.wcm-card{width:100%;position:relative;border-radius:var(--wcm-container-border-radius);overflow:hidden;box-shadow:0 6px 14px -6px rgba(10,16,31,.12),0 10px 32px -4px rgba(10,16,31,.1),0 0 0 1px var(--wcm-color-overlay);background-color:var(--wcm-color-bg-1);color:var(--wcm-color-fg-1)}@media(max-width:600px){.wcm-container{max-width:440px;border-radius:var(--wcm-background-border-radius) var(--wcm-background-border-radius) 0 0}.wcm-card{border-radius:var(--wcm-container-border-radius) var(--wcm-container-border-radius) 0 0}.wcm-overlay{align-items:flex-end}}@media(max-width:440px){.wcm-container{border:0}}`;
var $e634d3d4b646501e$var$Mo = Object.defineProperty, $e634d3d4b646501e$var$Lo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Re = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Lo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Mo(o, r, t), t;
};
let $e634d3d4b646501e$export$9efa81f00f3a145b = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.open = !1, this.active = !1, this.unsubscribeModal = void 0, this.abortController = void 0, this.unsubscribeModal = (0, $dYErK.ModalCtrl).subscribe((e)=>{
            e.open ? this.onOpenModalEvent() : this.onCloseModalEvent();
        });
    }
    disconnectedCallback() {
        var e;
        (e = this.unsubscribeModal) == null || e.call(this);
    }
    get overlayEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-overlay");
    }
    get containerEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-container");
    }
    toggleBodyScroll(e) {
        if (document.querySelector("body")) {
            if (e) {
                const o = document.getElementById("wcm-styles");
                o?.remove();
            } else document.head.insertAdjacentHTML("beforeend", '<style id="wcm-styles">html,body{touch-action:none;overflow:hidden;overscroll-behavior:contain;}</style>');
        }
    }
    onCloseModal(e) {
        e.target === e.currentTarget && (0, $dYErK.ModalCtrl).close();
    }
    onOpenModalEvent() {
        this.toggleBodyScroll(!1), this.addKeyboardEvents(), this.open = !0, setTimeout(async ()=>{
            const e = $e634d3d4b646501e$var$c.isMobileAnimation() ? {
                y: [
                    "50vh",
                    "0vh"
                ]
            } : {
                scale: [
                    .98,
                    1
                ]
            }, o = .1, r = .2;
            await Promise.all([
                (0, $4TjqH.animate)(this.overlayEl, {
                    opacity: [
                        0,
                        1
                    ]
                }, {
                    delay: o,
                    duration: r
                }).finished,
                (0, $4TjqH.animate)(this.containerEl, e, {
                    delay: o,
                    duration: r
                }).finished
            ]), this.active = !0;
        }, 0);
    }
    async onCloseModalEvent() {
        this.toggleBodyScroll(!0), this.removeKeyboardEvents();
        const e = $e634d3d4b646501e$var$c.isMobileAnimation() ? {
            y: [
                "0vh",
                "50vh"
            ]
        } : {
            scale: [
                1,
                .98
            ]
        }, o = .2;
        await Promise.all([
            (0, $4TjqH.animate)(this.overlayEl, {
                opacity: [
                    1,
                    0
                ]
            }, {
                duration: o
            }).finished,
            (0, $4TjqH.animate)(this.containerEl, e, {
                duration: o
            }).finished
        ]), this.containerEl.removeAttribute("style"), this.active = !1, this.open = !1;
    }
    addKeyboardEvents() {
        this.abortController = new AbortController, window.addEventListener("keydown", (e)=>{
            var o;
            e.key === "Escape" ? (0, $dYErK.ModalCtrl).close() : e.key === "Tab" && ((o = e.target) != null && o.tagName.includes("wcm-") || this.containerEl.focus());
        }, this.abortController), this.containerEl.focus();
    }
    removeKeyboardEvents() {
        var e;
        (e = this.abortController) == null || e.abort(), this.abortController = void 0;
    }
    render() {
        const e = {
            "wcm-overlay": !0,
            "wcm-active": this.active
        };
        return (0, $7mSD6.html)`<wcm-explorer-context></wcm-explorer-context><wcm-theme-context></wcm-theme-context><div id="wcm-modal" class="${(0, $f1WVg.classMap)(e)}" @click="${this.onCloseModal}" role="alertdialog" aria-modal="true"><div class="wcm-container" tabindex="0">${this.open ? (0, $7mSD6.html)`<wcm-modal-backcard></wcm-modal-backcard><div class="wcm-card"><wcm-modal-router></wcm-modal-router><wcm-modal-toast></wcm-modal-toast></div>` : null}</div></div>`;
    }
};
$e634d3d4b646501e$export$9efa81f00f3a145b.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Eo
], $e634d3d4b646501e$var$Re([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$export$9efa81f00f3a145b.prototype, "open", 2), $e634d3d4b646501e$var$Re([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$export$9efa81f00f3a145b.prototype, "active", 2), $e634d3d4b646501e$export$9efa81f00f3a145b = $e634d3d4b646501e$var$Re([
    (0, $7UJjG.customElement)("wcm-modal")
], $e634d3d4b646501e$export$9efa81f00f3a145b);
const $e634d3d4b646501e$var$Ro = (0, $lEG98.css)`div{display:flex;margin-top:15px}slot{display:inline-block;margin:0 5px}wcm-button{margin:0 5px}`;
var $e634d3d4b646501e$var$Ao = Object.defineProperty, $e634d3d4b646501e$var$Po = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$le = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Po(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Ao(o, r, t), t;
};
let $e634d3d4b646501e$var$B = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.isMobile = !1, this.isDesktop = !1, this.isWeb = !1, this.isRetry = !1;
    }
    onMobile() {
        (0, $dYErK.CoreUtil).isMobile() ? (0, $dYErK.RouterCtrl).replace("MobileConnecting") : (0, $dYErK.RouterCtrl).replace("MobileQrcodeConnecting");
    }
    onDesktop() {
        (0, $dYErK.RouterCtrl).replace("DesktopConnecting");
    }
    onWeb() {
        (0, $dYErK.RouterCtrl).replace("WebConnecting");
    }
    render() {
        return (0, $7mSD6.html)`<div>${this.isRetry ? (0, $7mSD6.html)`<slot></slot>` : null} ${this.isMobile ? (0, $7mSD6.html)`<wcm-button .onClick="${this.onMobile}" .iconLeft="${$e634d3d4b646501e$var$v.MOBILE_ICON}" variant="outline">Mobile</wcm-button>` : null} ${this.isDesktop ? (0, $7mSD6.html)`<wcm-button .onClick="${this.onDesktop}" .iconLeft="${$e634d3d4b646501e$var$v.DESKTOP_ICON}" variant="outline">Desktop</wcm-button>` : null} ${this.isWeb ? (0, $7mSD6.html)`<wcm-button .onClick="${this.onWeb}" .iconLeft="${$e634d3d4b646501e$var$v.GLOBE_ICON}" variant="outline">Web</wcm-button>` : null}</div>`;
    }
};
$e634d3d4b646501e$var$B.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Ro
], $e634d3d4b646501e$var$le([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$B.prototype, "isMobile", 2), $e634d3d4b646501e$var$le([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$B.prototype, "isDesktop", 2), $e634d3d4b646501e$var$le([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$B.prototype, "isWeb", 2), $e634d3d4b646501e$var$le([
    (0, $N2oWd.property)({
        type: Boolean
    })
], $e634d3d4b646501e$var$B.prototype, "isRetry", 2), $e634d3d4b646501e$var$B = $e634d3d4b646501e$var$le([
    (0, $7UJjG.customElement)("wcm-platform-selection")
], $e634d3d4b646501e$var$B);
const $e634d3d4b646501e$var$To = (0, $lEG98.css)`button{display:flex;flex-direction:column;padding:5px 10px;border-radius:var(--wcm-button-hover-highlight-border-radius);height:100%;justify-content:flex-start}.wcm-icons{width:60px;height:60px;display:flex;flex-wrap:wrap;padding:7px;border-radius:var(--wcm-wallet-icon-border-radius);justify-content:space-between;align-items:center;margin-bottom:5px;background-color:var(--wcm-color-bg-2);box-shadow:inset 0 0 0 1px var(--wcm-color-overlay)}button:active{background-color:var(--wcm-color-overlay)}@media(hover:hover){button:hover{background-color:var(--wcm-color-overlay)}}.wcm-icons img{width:21px;height:21px;object-fit:cover;object-position:center;border-radius:calc(var(--wcm-wallet-icon-border-radius)/ 2);border:1px solid var(--wcm-color-overlay)}.wcm-icons svg{width:21px;height:21px}.wcm-icons img:nth-child(1),.wcm-icons img:nth-child(2),.wcm-icons svg:nth-child(1),.wcm-icons svg:nth-child(2){margin-bottom:4px}wcm-text{width:100%;text-align:center}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;
var $e634d3d4b646501e$var$jo = Object.defineProperty, $e634d3d4b646501e$var$_o = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Do = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$_o(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$jo(o, r, t), t;
};
let $e634d3d4b646501e$var$Ae = class extends (0, $356Px.LitElement) {
    onClick() {
        (0, $dYErK.RouterCtrl).push("WalletExplorer");
    }
    render() {
        const { recomendedWallets: e } = (0, $dYErK.ExplorerCtrl).state, o = $e634d3d4b646501e$var$G.manualWallets(), r = [
            ...e,
            ...o
        ].reverse().slice(0, 4);
        return (0, $7mSD6.html)`<button @click="${this.onClick}"><div class="wcm-icons">${r.map((a)=>{
            const t = $e634d3d4b646501e$var$c.getWalletIcon(a);
            if (t) return (0, $7mSD6.html)`<img crossorigin="anonymous" src="${t}">`;
            const l = $e634d3d4b646501e$var$c.getWalletIcon({
                id: a.id
            });
            return l ? (0, $7mSD6.html)`<img crossorigin="anonymous" src="${l}">` : $e634d3d4b646501e$var$v.WALLET_PLACEHOLDER;
        })} ${[
            ...Array(4 - r.length)
        ].map(()=>$e634d3d4b646501e$var$v.WALLET_PLACEHOLDER)}</div><wcm-text variant="xsmall-regular">View All</wcm-text></button>`;
    }
};
$e634d3d4b646501e$var$Ae.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$To
], $e634d3d4b646501e$var$Ae = $e634d3d4b646501e$var$Do([
    (0, $7UJjG.customElement)("wcm-view-all-wallets-button")
], $e634d3d4b646501e$var$Ae);
const $e634d3d4b646501e$var$No = (0, $lEG98.css)`.wcm-qr-container{width:100%;display:flex;justify-content:center;align-items:center;aspect-ratio:1/1}`;
var $e634d3d4b646501e$var$Zo = Object.defineProperty, $e634d3d4b646501e$var$So = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$de = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$So(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Zo(o, r, t), t;
};
let $e634d3d4b646501e$var$Y = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.walletId = "", this.imageId = "", this.uri = "", setTimeout(()=>{
            const { walletConnectUri: e } = (0, $dYErK.OptionsCtrl).state;
            this.uri = e;
        }, 0);
    }
    get overlayEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-qr-container");
    }
    render() {
        return (0, $7mSD6.html)`<div class="wcm-qr-container">${this.uri ? (0, $7mSD6.html)`<wcm-qrcode size="${this.overlayEl.offsetWidth}" uri="${this.uri}" walletId="${(0, $7He6a.ifDefined)(this.walletId)}" imageId="${(0, $7He6a.ifDefined)(this.imageId)}"></wcm-qrcode>` : (0, $7mSD6.html)`<wcm-spinner></wcm-spinner>`}</div>`;
    }
};
$e634d3d4b646501e$var$Y.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$No
], $e634d3d4b646501e$var$de([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$Y.prototype, "walletId", 2), $e634d3d4b646501e$var$de([
    (0, $N2oWd.property)()
], $e634d3d4b646501e$var$Y.prototype, "imageId", 2), $e634d3d4b646501e$var$de([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$Y.prototype, "uri", 2), $e634d3d4b646501e$var$Y = $e634d3d4b646501e$var$de([
    (0, $7UJjG.customElement)("wcm-walletconnect-qr")
], $e634d3d4b646501e$var$Y);
var $e634d3d4b646501e$var$Bo = Object.defineProperty, $e634d3d4b646501e$var$Uo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Ho = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Uo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Bo(o, r, t), t;
};
let $e634d3d4b646501e$var$Pe = class extends (0, $356Px.LitElement) {
    viewTemplate() {
        return (0, $dYErK.CoreUtil).isAndroid() ? (0, $7mSD6.html)`<wcm-android-wallet-selection></wcm-android-wallet-selection>` : (0, $dYErK.CoreUtil).isMobile() ? (0, $7mSD6.html)`<wcm-mobile-wallet-selection></wcm-mobile-wallet-selection>` : (0, $7mSD6.html)`<wcm-desktop-wallet-selection></wcm-desktop-wallet-selection>`;
    }
    render() {
        return (0, $7mSD6.html)`${this.viewTemplate()}<wcm-legal-notice></wcm-legal-notice>`;
    }
};
$e634d3d4b646501e$var$Pe.styles = [
    $e634d3d4b646501e$var$h.globalCss
], $e634d3d4b646501e$var$Pe = $e634d3d4b646501e$var$Ho([
    (0, $7UJjG.customElement)("wcm-connect-wallet-view")
], $e634d3d4b646501e$var$Pe);
const $e634d3d4b646501e$var$zo = (0, $lEG98.css)`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;
var $e634d3d4b646501e$var$Vo = Object.defineProperty, $e634d3d4b646501e$var$Fo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Ke = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Fo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Vo(o, r, t), t;
};
let $e634d3d4b646501e$var$me = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.isError = !1, this.openDesktopApp();
    }
    onFormatAndRedirect(e) {
        const { desktop: o, name: r } = (0, $dYErK.CoreUtil).getWalletRouterData(), a = o?.native;
        if (a) {
            const t = (0, $dYErK.CoreUtil).formatNativeUrl(a, e, r);
            (0, $dYErK.CoreUtil).openHref(t, "_self");
        }
    }
    openDesktopApp() {
        const { walletConnectUri: e } = (0, $dYErK.OptionsCtrl).state, o = (0, $dYErK.CoreUtil).getWalletRouterData();
        $e634d3d4b646501e$var$c.setRecentWallet(o), e && this.onFormatAndRedirect(e);
    }
    render() {
        const { name: e, id: o, image_id: r } = (0, $dYErK.CoreUtil).getWalletRouterData(), { isMobile: a, isWeb: t } = $e634d3d4b646501e$var$c.getCachedRouterWalletPlatforms();
        return (0, $7mSD6.html)`<wcm-modal-header title="${e}" .onAction="${$e634d3d4b646501e$var$c.handleUriCopy}" .actionIcon="${$e634d3d4b646501e$var$v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}" label="${`Continue in ${e}...`}" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Connection can continue loading if ${e} is not installed on your device`}</wcm-text><wcm-platform-selection .isMobile="${a}" .isWeb="${t}" .isRetry="${!0}"><wcm-button .onClick="${this.openDesktopApp.bind(this)}" .iconRight="${$e634d3d4b646501e$var$v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$me.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$zo
], $e634d3d4b646501e$var$Ke([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$me.prototype, "isError", 2), $e634d3d4b646501e$var$me = $e634d3d4b646501e$var$Ke([
    (0, $7UJjG.customElement)("wcm-desktop-connecting-view")
], $e634d3d4b646501e$var$me);
const $e634d3d4b646501e$var$qo = (0, $lEG98.css)`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}wcm-button{margin-top:15px}`;
var $e634d3d4b646501e$var$Qo = Object.defineProperty, $e634d3d4b646501e$var$Ko = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Yo = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Ko(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Qo(o, r, t), t;
};
let $e634d3d4b646501e$var$Te = class extends (0, $356Px.LitElement) {
    onInstall(e) {
        e && (0, $dYErK.CoreUtil).openHref(e, "_blank");
    }
    render() {
        const { name: e, id: o, image_id: r, homepage: a } = (0, $dYErK.CoreUtil).getWalletRouterData();
        return (0, $7mSD6.html)`<wcm-modal-header title="${e}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}" label="Not Detected" .isStale="${!0}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Download ${e} to continue. If multiple browser extensions are installed, disable non ${e} ones and try again`}</wcm-text><wcm-button .onClick="${()=>this.onInstall(a)}" .iconLeft="${$e634d3d4b646501e$var$v.ARROW_DOWN_ICON}">Download</wcm-button></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$Te.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$qo
], $e634d3d4b646501e$var$Te = $e634d3d4b646501e$var$Yo([
    (0, $7UJjG.customElement)("wcm-install-wallet-view")
], $e634d3d4b646501e$var$Te);
const $e634d3d4b646501e$var$Go = (0, $lEG98.css)`wcm-wallet-image{border-radius:var(--wcm-wallet-icon-large-border-radius);width:96px;height:96px;margin-bottom:20px}wcm-info-footer{display:flex;width:100%}.wcm-app-store{justify-content:space-between}.wcm-app-store wcm-wallet-image{margin-right:10px;margin-bottom:0;width:28px;height:28px;border-radius:var(--wcm-wallet-icon-small-border-radius)}.wcm-app-store div{display:flex;align-items:center}.wcm-app-store wcm-button{margin-right:-10px}.wcm-note{flex-direction:column;align-items:center;padding:5px 0}.wcm-note wcm-text{text-align:center}wcm-platform-selection{margin-top:-15px}.wcm-note wcm-text{margin-top:15px}.wcm-note wcm-text span{color:var(--wcm-accent-color)}`;
var $e634d3d4b646501e$var$Xo = Object.defineProperty, $e634d3d4b646501e$var$Jo = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Ye = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$Jo(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$Xo(o, r, t), t;
};
let $e634d3d4b646501e$var$he = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.isError = !1, this.openMobileApp();
    }
    onFormatAndRedirect(e, o = !1) {
        const { mobile: r, name: a } = (0, $dYErK.CoreUtil).getWalletRouterData(), t = r?.native, l = r?.universal;
        if (t && !o) {
            const i = (0, $dYErK.CoreUtil).formatNativeUrl(t, e, a);
            (0, $dYErK.CoreUtil).openHref(i, "_self");
        } else if (l) {
            const i = (0, $dYErK.CoreUtil).formatUniversalUrl(l, e, a);
            (0, $dYErK.CoreUtil).openHref(i, "_self");
        }
    }
    openMobileApp(e = !1) {
        const { walletConnectUri: o } = (0, $dYErK.OptionsCtrl).state, r = (0, $dYErK.CoreUtil).getWalletRouterData();
        $e634d3d4b646501e$var$c.setRecentWallet(r), o && this.onFormatAndRedirect(o, e);
    }
    onGoToAppStore(e) {
        e && (0, $dYErK.CoreUtil).openHref(e, "_blank");
    }
    render() {
        const { name: e, id: o, image_id: r, app: a, mobile: t } = (0, $dYErK.CoreUtil).getWalletRouterData(), { isWeb: l } = $e634d3d4b646501e$var$c.getCachedRouterWalletPlatforms(), i = a?.ios, s = t?.universal;
        return (0, $7mSD6.html)`<wcm-modal-header title="${e}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}" label="Tap 'Open' to continue…" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer class="wcm-note"><wcm-platform-selection .isWeb="${l}" .isRetry="${!0}"><wcm-button .onClick="${()=>this.openMobileApp(!1)}" .iconRight="${$e634d3d4b646501e$var$v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection>${s ? (0, $7mSD6.html)`<wcm-text color="secondary" variant="small-thin">Still doesn't work? <span tabindex="0" @click="${()=>this.openMobileApp(!0)}">Try this alternate link</span></wcm-text>` : null}</wcm-info-footer><wcm-info-footer class="wcm-app-store"><div><wcm-wallet-image walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}"></wcm-wallet-image><wcm-text>${`Get ${e}`}</wcm-text></div><wcm-button .iconRight="${$e634d3d4b646501e$var$v.ARROW_RIGHT_ICON}" .onClick="${()=>this.onGoToAppStore(i)}" variant="ghost">App Store</wcm-button></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$he.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$Go
], $e634d3d4b646501e$var$Ye([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$he.prototype, "isError", 2), $e634d3d4b646501e$var$he = $e634d3d4b646501e$var$Ye([
    (0, $7UJjG.customElement)("wcm-mobile-connecting-view")
], $e634d3d4b646501e$var$he);
const $e634d3d4b646501e$var$er = (0, $lEG98.css)`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;
var $e634d3d4b646501e$var$tr = Object.defineProperty, $e634d3d4b646501e$var$or = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$rr = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$or(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$tr(o, r, t), t;
};
let $e634d3d4b646501e$var$je = class extends (0, $356Px.LitElement) {
    render() {
        const { name: e, id: o, image_id: r } = (0, $dYErK.CoreUtil).getWalletRouterData(), { isDesktop: a, isWeb: t } = $e634d3d4b646501e$var$c.getCachedRouterWalletPlatforms();
        return (0, $7mSD6.html)`<wcm-modal-header title="${e}" .onAction="${$e634d3d4b646501e$var$c.handleUriCopy}" .actionIcon="${$e634d3d4b646501e$var$v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-walletconnect-qr walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}"></wcm-walletconnect-qr></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Scan this QR Code with your phone's camera or inside ${e} app`}</wcm-text><wcm-platform-selection .isDesktop="${a}" .isWeb="${t}"></wcm-platform-selection></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$je.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$er
], $e634d3d4b646501e$var$je = $e634d3d4b646501e$var$rr([
    (0, $7UJjG.customElement)("wcm-mobile-qr-connecting-view")
], $e634d3d4b646501e$var$je);
var $e634d3d4b646501e$var$ar = Object.defineProperty, $e634d3d4b646501e$var$lr = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ir = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$lr(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$ar(o, r, t), t;
};
let $e634d3d4b646501e$var$_e = class extends (0, $356Px.LitElement) {
    render() {
        return (0, $7mSD6.html)`<wcm-modal-header title="Scan the code" .onAction="${$e634d3d4b646501e$var$c.handleUriCopy}" .actionIcon="${$e634d3d4b646501e$var$v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-walletconnect-qr></wcm-walletconnect-qr></wcm-modal-content>`;
    }
};
$e634d3d4b646501e$var$_e.styles = [
    $e634d3d4b646501e$var$h.globalCss
], $e634d3d4b646501e$var$_e = $e634d3d4b646501e$var$ir([
    (0, $7UJjG.customElement)("wcm-qrcode-view")
], $e634d3d4b646501e$var$_e);
const $e634d3d4b646501e$var$nr = (0, $lEG98.css)`wcm-modal-content{height:clamp(200px,60vh,600px);display:block;overflow:scroll;scrollbar-width:none;position:relative;margin-top:1px}.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between;margin:-15px -10px;padding-top:20px}wcm-modal-content::after,wcm-modal-content::before{content:'';position:fixed;pointer-events:none;z-index:1;width:100%;height:20px;opacity:1}wcm-modal-content::before{box-shadow:0 -1px 0 0 var(--wcm-color-bg-1);background:linear-gradient(var(--wcm-color-bg-1),rgba(255,255,255,0))}wcm-modal-content::after{box-shadow:0 1px 0 0 var(--wcm-color-bg-1);background:linear-gradient(rgba(255,255,255,0),var(--wcm-color-bg-1));top:calc(100% - 20px)}wcm-modal-content::-webkit-scrollbar{display:none}.wcm-placeholder-block{display:flex;justify-content:center;align-items:center;height:100px;overflow:hidden}.wcm-empty,.wcm-loading{display:flex}.wcm-loading .wcm-placeholder-block{height:100%}.wcm-end-reached .wcm-placeholder-block{height:0;opacity:0}.wcm-empty .wcm-placeholder-block{opacity:1;height:100%}wcm-wallet-button{margin:calc((100% - 60px)/ 3) 0}`;
var $e634d3d4b646501e$var$cr = Object.defineProperty, $e634d3d4b646501e$var$sr = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$ie = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$sr(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$cr(o, r, t), t;
};
const $e634d3d4b646501e$var$De = 40;
let $e634d3d4b646501e$var$U = class extends (0, $356Px.LitElement) {
    constructor(){
        super(...arguments), this.loading = !(0, $dYErK.ExplorerCtrl).state.wallets.listings.length, this.firstFetch = !(0, $dYErK.ExplorerCtrl).state.wallets.listings.length, this.search = "", this.endReached = !1, this.intersectionObserver = void 0, this.searchDebounce = $e634d3d4b646501e$var$c.debounce((e)=>{
            e.length >= 1 ? (this.firstFetch = !0, this.endReached = !1, this.search = e, (0, $dYErK.ExplorerCtrl).resetSearch(), this.fetchWallets()) : this.search && (this.search = "", this.endReached = this.isLastPage(), (0, $dYErK.ExplorerCtrl).resetSearch());
        });
    }
    firstUpdated() {
        this.createPaginationObserver();
    }
    disconnectedCallback() {
        var e;
        (e = this.intersectionObserver) == null || e.disconnect();
    }
    get placeholderEl() {
        return $e634d3d4b646501e$var$c.getShadowRootElement(this, ".wcm-placeholder-block");
    }
    createPaginationObserver() {
        this.intersectionObserver = new IntersectionObserver(([e])=>{
            e.isIntersecting && !(this.search && this.firstFetch) && this.fetchWallets();
        }), this.intersectionObserver.observe(this.placeholderEl);
    }
    isLastPage() {
        const { wallets: e, search: o } = (0, $dYErK.ExplorerCtrl).state, { listings: r, total: a } = this.search ? o : e;
        return a <= $e634d3d4b646501e$var$De || r.length >= a;
    }
    async fetchWallets() {
        var e;
        const { wallets: o, search: r } = (0, $dYErK.ExplorerCtrl).state, { listings: a, total: t, page: l } = this.search ? r : o;
        if (!this.endReached && (this.firstFetch || t > $e634d3d4b646501e$var$De && a.length < t)) try {
            this.loading = !0;
            const i = (e = (0, $dYErK.OptionsCtrl).state.chains) == null ? void 0 : e.join(","), { listings: s } = await (0, $dYErK.ExplorerCtrl).getWallets({
                page: this.firstFetch ? 1 : l + 1,
                entries: $e634d3d4b646501e$var$De,
                search: this.search,
                version: 2,
                chains: i
            }), $ = s.map((f)=>$e634d3d4b646501e$var$c.getWalletIcon(f));
            await Promise.all([
                ...$.map(async (f)=>$e634d3d4b646501e$var$c.preloadImage(f)),
                (0, $dYErK.CoreUtil).wait(300)
            ]), this.endReached = this.isLastPage();
        } catch (i) {
            console.error(i), (0, $dYErK.ToastCtrl).openToast($e634d3d4b646501e$var$c.getErrorMessage(i), "error");
        } finally{
            this.loading = !1, this.firstFetch = !1;
        }
    }
    onConnect(e) {
        (0, $dYErK.CoreUtil).isAndroid() ? $e634d3d4b646501e$var$c.handleMobileLinking(e) : $e634d3d4b646501e$var$c.goToConnectingView(e);
    }
    onSearchChange(e) {
        const { value: o } = e.target;
        this.searchDebounce(o);
    }
    render() {
        const { wallets: e, search: o } = (0, $dYErK.ExplorerCtrl).state, { listings: r } = this.search ? o : e, a = this.loading && !r.length, t = this.search.length >= 3;
        let l = $e634d3d4b646501e$var$Z.manualWalletsTemplate(), i = $e634d3d4b646501e$var$Z.recomendedWalletsTemplate(!0);
        t && (l = l.filter(({ values: f })=>$e634d3d4b646501e$var$c.caseSafeIncludes(f[0], this.search)), i = i.filter(({ values: f })=>$e634d3d4b646501e$var$c.caseSafeIncludes(f[0], this.search)));
        const s = !this.loading && !r.length && !i.length, $ = {
            "wcm-loading": a,
            "wcm-end-reached": this.endReached || !this.loading,
            "wcm-empty": s
        };
        return (0, $7mSD6.html)`<wcm-modal-header><wcm-search-input .onChange="${this.onSearchChange.bind(this)}"></wcm-search-input></wcm-modal-header><wcm-modal-content class="${(0, $f1WVg.classMap)($)}"><div class="wcm-grid">${a ? null : l} ${a ? null : i} ${a ? null : r.map((f)=>(0, $7mSD6.html)`${f ? (0, $7mSD6.html)`<wcm-wallet-button imageId="${f.image_id}" name="${f.name}" walletId="${f.id}" .onClick="${()=>this.onConnect(f)}"></wcm-wallet-button>` : null}`)}</div><div class="wcm-placeholder-block">${s ? (0, $7mSD6.html)`<wcm-text variant="big-bold" color="secondary">No results found</wcm-text>` : null} ${!s && this.loading ? (0, $7mSD6.html)`<wcm-spinner></wcm-spinner>` : null}</div></wcm-modal-content>`;
    }
};
$e634d3d4b646501e$var$U.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$nr
], $e634d3d4b646501e$var$ie([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$U.prototype, "loading", 2), $e634d3d4b646501e$var$ie([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$U.prototype, "firstFetch", 2), $e634d3d4b646501e$var$ie([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$U.prototype, "search", 2), $e634d3d4b646501e$var$ie([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$U.prototype, "endReached", 2), $e634d3d4b646501e$var$U = $e634d3d4b646501e$var$ie([
    (0, $7UJjG.customElement)("wcm-wallet-explorer-view")
], $e634d3d4b646501e$var$U);
const $e634d3d4b646501e$var$dr = (0, $lEG98.css)`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;
var $e634d3d4b646501e$var$mr = Object.defineProperty, $e634d3d4b646501e$var$hr = Object.getOwnPropertyDescriptor, $e634d3d4b646501e$var$Ge = (e, o, r, a)=>{
    for(var t = a > 1 ? void 0 : a ? $e634d3d4b646501e$var$hr(o, r) : o, l = e.length - 1, i; l >= 0; l--)(i = e[l]) && (t = (a ? i(o, r, t) : i(t)) || t);
    return a && t && $e634d3d4b646501e$var$mr(o, r, t), t;
};
let $e634d3d4b646501e$var$we = class extends (0, $356Px.LitElement) {
    constructor(){
        super(), this.isError = !1, this.openWebWallet();
    }
    onFormatAndRedirect(e) {
        const { desktop: o, name: r } = (0, $dYErK.CoreUtil).getWalletRouterData(), a = o?.universal;
        if (a) {
            const t = (0, $dYErK.CoreUtil).formatUniversalUrl(a, e, r);
            (0, $dYErK.CoreUtil).openHref(t, "_blank");
        }
    }
    openWebWallet() {
        const { walletConnectUri: e } = (0, $dYErK.OptionsCtrl).state, o = (0, $dYErK.CoreUtil).getWalletRouterData();
        $e634d3d4b646501e$var$c.setRecentWallet(o), e && this.onFormatAndRedirect(e);
    }
    render() {
        const { name: e, id: o, image_id: r } = (0, $dYErK.CoreUtil).getWalletRouterData(), { isMobile: a, isDesktop: t } = $e634d3d4b646501e$var$c.getCachedRouterWalletPlatforms(), l = (0, $dYErK.CoreUtil).isMobile();
        return (0, $7mSD6.html)`<wcm-modal-header title="${e}" .onAction="${$e634d3d4b646501e$var$c.handleUriCopy}" .actionIcon="${$e634d3d4b646501e$var$v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${(0, $7He6a.ifDefined)(r)}" label="${`Continue in ${e}...`}" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`${e} web app has opened in a new tab. Go there, accept the connection, and come back`}</wcm-text><wcm-platform-selection .isMobile="${a}" .isDesktop="${l ? !1 : t}" .isRetry="${!0}"><wcm-button .onClick="${this.openWebWallet.bind(this)}" .iconRight="${$e634d3d4b646501e$var$v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection></wcm-info-footer>`;
    }
};
$e634d3d4b646501e$var$we.styles = [
    $e634d3d4b646501e$var$h.globalCss,
    $e634d3d4b646501e$var$dr
], $e634d3d4b646501e$var$Ge([
    (0, $7WxjU.state)()
], $e634d3d4b646501e$var$we.prototype, "isError", 2), $e634d3d4b646501e$var$we = $e634d3d4b646501e$var$Ge([
    (0, $7UJjG.customElement)("wcm-web-connecting-view")
], $e634d3d4b646501e$var$we);

});
parcelRegister("hO4b7", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("lEG98")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("7mSD6")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("356Px")).LitElement; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("7mSD6")).svg; });
parcelRequire("2VhxT");
parcelRequire("7mSD6");
parcelRequire("356Px");
parcelRequire("dB4vK");

});
parcelRegister("2VhxT", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", function () { return $220e83d71314010a$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("lEG98")).css; });

var $lEG98 = parcelRequire("lEG98");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $220e83d71314010a$var$s;
const $220e83d71314010a$var$e = window, $220e83d71314010a$var$r = $220e83d71314010a$var$e.trustedTypes, $220e83d71314010a$var$h = $220e83d71314010a$var$r ? $220e83d71314010a$var$r.emptyScript : "", $220e83d71314010a$var$o = $220e83d71314010a$var$e.reactiveElementPolyfillSupport, $220e83d71314010a$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $220e83d71314010a$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $220e83d71314010a$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $220e83d71314010a$var$l = {
    attribute: !0,
    type: String,
    converter: $220e83d71314010a$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $220e83d71314010a$export$53a6892c50694894
}, $220e83d71314010a$var$d = "finalized";
class $220e83d71314010a$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $220e83d71314010a$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $220e83d71314010a$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($220e83d71314010a$var$d)) return !1;
        this[$220e83d71314010a$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $lEG98.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $lEG98.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $lEG98.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $220e83d71314010a$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $220e83d71314010a$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $220e83d71314010a$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $220e83d71314010a$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$220e83d71314010a$export$c7c07a37856565d[$220e83d71314010a$var$d] = !0, $220e83d71314010a$export$c7c07a37856565d.elementProperties = new Map, $220e83d71314010a$export$c7c07a37856565d.elementStyles = [], $220e83d71314010a$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $220e83d71314010a$var$o || $220e83d71314010a$var$o({
    ReactiveElement: $220e83d71314010a$export$c7c07a37856565d
}), (null !== ($220e83d71314010a$var$s = $220e83d71314010a$var$e.reactiveElementVersions) && void 0 !== $220e83d71314010a$var$s ? $220e83d71314010a$var$s : $220e83d71314010a$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("lEG98", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $fc3e06c5d1c8927b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $fc3e06c5d1c8927b$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $fc3e06c5d1c8927b$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fc3e06c5d1c8927b$var$t = window, $fc3e06c5d1c8927b$export$b4d10f6001c083c2 = $fc3e06c5d1c8927b$var$t.ShadowRoot && (void 0 === $fc3e06c5d1c8927b$var$t.ShadyCSS || $fc3e06c5d1c8927b$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fc3e06c5d1c8927b$var$s = Symbol(), $fc3e06c5d1c8927b$var$n = new WeakMap;
class $fc3e06c5d1c8927b$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $fc3e06c5d1c8927b$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($fc3e06c5d1c8927b$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $fc3e06c5d1c8927b$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $fc3e06c5d1c8927b$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $fc3e06c5d1c8927b$export$8d80f9cac07cdb3 = (t)=>new $fc3e06c5d1c8927b$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $fc3e06c5d1c8927b$var$s), $fc3e06c5d1c8927b$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $fc3e06c5d1c8927b$export$505d1e8739bad805(n, t, $fc3e06c5d1c8927b$var$s);
}, $fc3e06c5d1c8927b$export$2ca4a66ec4cecb90 = (s, n)=>{
    $fc3e06c5d1c8927b$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $fc3e06c5d1c8927b$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $fc3e06c5d1c8927b$export$ee69dfd951e24778 = $fc3e06c5d1c8927b$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $fc3e06c5d1c8927b$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("7mSD6", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $55d4f6cb7ddbea62$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $55d4f6cb7ddbea62$export$7ed1367e7fa1ad68; });
$parcel$export(module.exports, "noChange", function () { return $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $55d4f6cb7ddbea62$export$45b790e32b2810ee; });
$parcel$export(module.exports, "render", function () { return $55d4f6cb7ddbea62$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $55d4f6cb7ddbea62$var$t;
const $55d4f6cb7ddbea62$var$i = window, $55d4f6cb7ddbea62$var$s = $55d4f6cb7ddbea62$var$i.trustedTypes, $55d4f6cb7ddbea62$var$e = $55d4f6cb7ddbea62$var$s ? $55d4f6cb7ddbea62$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $55d4f6cb7ddbea62$var$o = "$lit$", $55d4f6cb7ddbea62$var$n = `lit$${(Math.random() + "").slice(9)}$`, $55d4f6cb7ddbea62$var$l = "?" + $55d4f6cb7ddbea62$var$n, $55d4f6cb7ddbea62$var$h = `<${$55d4f6cb7ddbea62$var$l}>`, $55d4f6cb7ddbea62$var$r = document, $55d4f6cb7ddbea62$var$u = ()=>$55d4f6cb7ddbea62$var$r.createComment(""), $55d4f6cb7ddbea62$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $55d4f6cb7ddbea62$var$c = Array.isArray, $55d4f6cb7ddbea62$var$v = (t)=>$55d4f6cb7ddbea62$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $55d4f6cb7ddbea62$var$a = "[ 	\n\f\r]", $55d4f6cb7ddbea62$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $55d4f6cb7ddbea62$var$_ = /-->/g, $55d4f6cb7ddbea62$var$m = />/g, $55d4f6cb7ddbea62$var$p = RegExp(`>|${$55d4f6cb7ddbea62$var$a}(?:([^\\s"'>=/]+)(${$55d4f6cb7ddbea62$var$a}*=${$55d4f6cb7ddbea62$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $55d4f6cb7ddbea62$var$g = /'/g, $55d4f6cb7ddbea62$var$$ = /"/g, $55d4f6cb7ddbea62$var$y = /^(?:script|style|textarea|title)$/i, $55d4f6cb7ddbea62$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $55d4f6cb7ddbea62$export$c0bb0b647f701bb5 = $55d4f6cb7ddbea62$var$w(1), $55d4f6cb7ddbea62$export$7ed1367e7fa1ad68 = $55d4f6cb7ddbea62$var$w(2), $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $55d4f6cb7ddbea62$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $55d4f6cb7ddbea62$var$E = new WeakMap, $55d4f6cb7ddbea62$var$C = $55d4f6cb7ddbea62$var$r.createTreeWalker($55d4f6cb7ddbea62$var$r, 129, null, !1);
function $55d4f6cb7ddbea62$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $55d4f6cb7ddbea62$var$e ? $55d4f6cb7ddbea62$var$e.createHTML(i) : i;
}
const $55d4f6cb7ddbea62$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $55d4f6cb7ddbea62$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $55d4f6cb7ddbea62$var$f ? "!--" === c[1] ? u = $55d4f6cb7ddbea62$var$_ : void 0 !== c[1] ? u = $55d4f6cb7ddbea62$var$m : void 0 !== c[2] ? ($55d4f6cb7ddbea62$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $55d4f6cb7ddbea62$var$p) : void 0 !== c[3] && (u = $55d4f6cb7ddbea62$var$p) : u === $55d4f6cb7ddbea62$var$p ? ">" === c[0] ? (u = null != l ? l : $55d4f6cb7ddbea62$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $55d4f6cb7ddbea62$var$p : '"' === c[3] ? $55d4f6cb7ddbea62$var$$ : $55d4f6cb7ddbea62$var$g) : u === $55d4f6cb7ddbea62$var$$ || u === $55d4f6cb7ddbea62$var$g ? u = $55d4f6cb7ddbea62$var$p : u === $55d4f6cb7ddbea62$var$_ || u === $55d4f6cb7ddbea62$var$m ? u = $55d4f6cb7ddbea62$var$f : (u = $55d4f6cb7ddbea62$var$p, l = void 0);
        const w = u === $55d4f6cb7ddbea62$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $55d4f6cb7ddbea62$var$f ? s + $55d4f6cb7ddbea62$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $55d4f6cb7ddbea62$var$o + s.slice(v) + $55d4f6cb7ddbea62$var$n + w) : s + $55d4f6cb7ddbea62$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $55d4f6cb7ddbea62$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $55d4f6cb7ddbea62$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $55d4f6cb7ddbea62$var$V(t, i);
        if (this.el = $55d4f6cb7ddbea62$var$N.createElement(a, e), $55d4f6cb7ddbea62$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $55d4f6cb7ddbea62$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($55d4f6cb7ddbea62$var$o) || i.startsWith($55d4f6cb7ddbea62$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $55d4f6cb7ddbea62$var$o).split($55d4f6cb7ddbea62$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $55d4f6cb7ddbea62$var$H : "?" === i[1] ? $55d4f6cb7ddbea62$var$L : "@" === i[1] ? $55d4f6cb7ddbea62$var$z : $55d4f6cb7ddbea62$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($55d4f6cb7ddbea62$var$y.test(h.tagName)) {
                    const t = h.textContent.split($55d4f6cb7ddbea62$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $55d4f6cb7ddbea62$var$s ? $55d4f6cb7ddbea62$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $55d4f6cb7ddbea62$var$u()), $55d4f6cb7ddbea62$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $55d4f6cb7ddbea62$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $55d4f6cb7ddbea62$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($55d4f6cb7ddbea62$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $55d4f6cb7ddbea62$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $55d4f6cb7ddbea62$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $55d4f6cb7ddbea62$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $55d4f6cb7ddbea62$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $55d4f6cb7ddbea62$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $55d4f6cb7ddbea62$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $55d4f6cb7ddbea62$var$r).importNode(s, !0);
        $55d4f6cb7ddbea62$var$C.currentNode = o;
        let n = $55d4f6cb7ddbea62$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $55d4f6cb7ddbea62$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $55d4f6cb7ddbea62$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $55d4f6cb7ddbea62$var$C.nextNode(), l++);
        }
        return $55d4f6cb7ddbea62$var$C.currentNode = $55d4f6cb7ddbea62$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $55d4f6cb7ddbea62$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $55d4f6cb7ddbea62$var$S(this, t, i), $55d4f6cb7ddbea62$var$d(t) ? t === $55d4f6cb7ddbea62$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && this._$AR(), this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee) : t !== this._$AH && t !== $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $55d4f6cb7ddbea62$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && $55d4f6cb7ddbea62$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($55d4f6cb7ddbea62$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $55d4f6cb7ddbea62$var$N.createElement($55d4f6cb7ddbea62$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $55d4f6cb7ddbea62$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $55d4f6cb7ddbea62$var$E.get(t.strings);
        return void 0 === i && $55d4f6cb7ddbea62$var$E.set(t.strings, i = new $55d4f6cb7ddbea62$var$N(t)), i;
    }
    T(t) {
        $55d4f6cb7ddbea62$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $55d4f6cb7ddbea62$var$R(this.k($55d4f6cb7ddbea62$var$u()), this.k($55d4f6cb7ddbea62$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $55d4f6cb7ddbea62$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $55d4f6cb7ddbea62$var$S(this, t, i, 0), n = !$55d4f6cb7ddbea62$var$d(t) || t !== this._$AH && t !== $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $55d4f6cb7ddbea62$var$S(this, e[s + l], i, l), h === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$55d4f6cb7ddbea62$var$d(h) || h !== this._$AH[l]), h === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? t = $55d4f6cb7ddbea62$export$45b790e32b2810ee : t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $55d4f6cb7ddbea62$var$H extends $55d4f6cb7ddbea62$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $55d4f6cb7ddbea62$var$I = $55d4f6cb7ddbea62$var$s ? $55d4f6cb7ddbea62$var$s.emptyScript : "";
class $55d4f6cb7ddbea62$var$L extends $55d4f6cb7ddbea62$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $55d4f6cb7ddbea62$var$I) : this.element.removeAttribute(this.name);
    }
}
class $55d4f6cb7ddbea62$var$z extends $55d4f6cb7ddbea62$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $55d4f6cb7ddbea62$var$S(this, t, i, 0)) && void 0 !== s ? s : $55d4f6cb7ddbea62$export$45b790e32b2810ee) === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $55d4f6cb7ddbea62$export$45b790e32b2810ee && e !== $55d4f6cb7ddbea62$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && (e === $55d4f6cb7ddbea62$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $55d4f6cb7ddbea62$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $55d4f6cb7ddbea62$var$S(this, t);
    }
}
const $55d4f6cb7ddbea62$export$8613d1ca9052b22e = {
    O: $55d4f6cb7ddbea62$var$o,
    P: $55d4f6cb7ddbea62$var$n,
    A: $55d4f6cb7ddbea62$var$l,
    C: 1,
    M: $55d4f6cb7ddbea62$var$V,
    L: $55d4f6cb7ddbea62$var$M,
    R: $55d4f6cb7ddbea62$var$v,
    D: $55d4f6cb7ddbea62$var$S,
    I: $55d4f6cb7ddbea62$var$R,
    V: $55d4f6cb7ddbea62$var$k,
    H: $55d4f6cb7ddbea62$var$L,
    N: $55d4f6cb7ddbea62$var$z,
    U: $55d4f6cb7ddbea62$var$H,
    F: $55d4f6cb7ddbea62$var$Z
}, $55d4f6cb7ddbea62$var$B = $55d4f6cb7ddbea62$var$i.litHtmlPolyfillSupport;
null == $55d4f6cb7ddbea62$var$B || $55d4f6cb7ddbea62$var$B($55d4f6cb7ddbea62$var$N, $55d4f6cb7ddbea62$var$R), (null !== ($55d4f6cb7ddbea62$var$t = $55d4f6cb7ddbea62$var$i.litHtmlVersions) && void 0 !== $55d4f6cb7ddbea62$var$t ? $55d4f6cb7ddbea62$var$t : $55d4f6cb7ddbea62$var$i.litHtmlVersions = []).push("2.8.0");
const $55d4f6cb7ddbea62$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $55d4f6cb7ddbea62$var$R(i.insertBefore($55d4f6cb7ddbea62$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("356Px", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("lEG98")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("2VhxT")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("7mSD6")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("7mSD6")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("7mSD6")).render; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("7mSD6")).svg; });

$parcel$export(module.exports, "LitElement", function () { return $23e72313714efa3c$export$3f2f9f5909897157; });

var $2VhxT = parcelRequire("2VhxT");

var $7mSD6 = parcelRequire("7mSD6");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $23e72313714efa3c$var$l, $23e72313714efa3c$var$o;
const $23e72313714efa3c$export$8bf27daf9e8907c9 = (0, $2VhxT.ReactiveElement);
class $23e72313714efa3c$export$3f2f9f5909897157 extends (0, $2VhxT.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $7mSD6.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $7mSD6.noChange;
    }
}
$23e72313714efa3c$export$3f2f9f5909897157.finalized = !0, $23e72313714efa3c$export$3f2f9f5909897157._$litElement$ = !0, null === ($23e72313714efa3c$var$l = globalThis.litElementHydrateSupport) || void 0 === $23e72313714efa3c$var$l || $23e72313714efa3c$var$l.call(globalThis, {
    LitElement: $23e72313714efa3c$export$3f2f9f5909897157
});
const $23e72313714efa3c$var$n = globalThis.litElementPolyfillSupport;
null == $23e72313714efa3c$var$n || $23e72313714efa3c$var$n({
    LitElement: $23e72313714efa3c$export$3f2f9f5909897157
});
const $23e72313714efa3c$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($23e72313714efa3c$var$o = globalThis.litElementVersions) && void 0 !== $23e72313714efa3c$var$o ? $23e72313714efa3c$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("dB4vK", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9e623adca87f3a47$export$6acf61af03e62db = !1;

});


parcelRegister("bJ6qj", function(module, exports) {
$parcel$export(module.exports, "customElement", function () { return (parcelRequire("7UJjG")).customElement; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("N2oWd")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("7WxjU")).state; });
parcelRequire("7UJjG");
parcelRequire("N2oWd");
parcelRequire("7WxjU");
parcelRequire("lTs3Y");
parcelRequire("c8oqw");
parcelRequire("dax1e");
parcelRequire("i5Ztg");
parcelRequire("5hzED");
parcelRequire("dTRmm");

});
parcelRegister("7UJjG", function(module, exports) {

$parcel$export(module.exports, "customElement", function () { return $5c30ea4b08dcd69f$export$da64fc29f17f9d0e; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5c30ea4b08dcd69f$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("N2oWd", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $0936708d16581d69$export$d541bacb2bda4494; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0936708d16581d69$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $0936708d16581d69$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $0936708d16581d69$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $0936708d16581d69$var$e(n, t, o) : $0936708d16581d69$var$i(n, t);
}

});

parcelRegister("7WxjU", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e; });

var $N2oWd = parcelRequire("N2oWd");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e(t) {
    return (0, $N2oWd.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("lTs3Y", function(module, exports) {

var $k7mmh = parcelRequire("k7mmh");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ff0480c4bad933eb$export$b2b799818fbabcf3(e) {
    return (0, $k7mmh.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("k7mmh", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", function () { return $ea55cdfd67d0b78a$export$757d561a932dc1cb; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ea55cdfd67d0b78a$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $ea55cdfd67d0b78a$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $ea55cdfd67d0b78a$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("c8oqw", function(module, exports) {

var $k7mmh = parcelRequire("k7mmh");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8d592e0ae133699b$export$2fa187e846a241c4(i, n) {
    return (0, $k7mmh.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("dax1e", function(module, exports) {

var $k7mmh = parcelRequire("k7mmh");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9965d2609e5deb5d$export$dcd0d083aa86c355(e) {
    return (0, $k7mmh.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("i5Ztg", function(module, exports) {

var $k7mmh = parcelRequire("k7mmh");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d2c86078d7066c37$export$163dfc35cc43f240(e) {
    return (0, $k7mmh.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("5hzED", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", function () { return $3d8a3282c8d293e2$export$4682af2d9ee91415; });

var $k7mmh = parcelRequire("k7mmh");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $3d8a3282c8d293e2$var$n;
const $3d8a3282c8d293e2$var$e = null != (null === ($3d8a3282c8d293e2$var$n = window.HTMLSlotElement) || void 0 === $3d8a3282c8d293e2$var$n ? void 0 : $3d8a3282c8d293e2$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $3d8a3282c8d293e2$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $k7mmh.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $3d8a3282c8d293e2$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("dTRmm", function(module, exports) {

var $k7mmh = parcelRequire("k7mmh");

var $5hzED = parcelRequire("5hzED");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a1e9cd8288b34889$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $5hzED.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $k7mmh.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("3EeEZ", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("f1WVg")).classMap; });
parcelRequire("f1WVg");

});
parcelRegister("f1WVg", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $af14a7d4f9968de8$export$56cc687933817664; });

var $7mSD6 = parcelRequire("7mSD6");

var $5Ug9c = parcelRequire("5Ug9c");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af14a7d4f9968de8$export$56cc687933817664 = (0, $5Ug9c.directive)(class extends (0, $5Ug9c.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $5Ug9c.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $7mSD6.noChange;
    }
});

});
parcelRegister("5Ug9c", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $44ceb53f9bbed706$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $44ceb53f9bbed706$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $44ceb53f9bbed706$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $44ceb53f9bbed706$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $44ceb53f9bbed706$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $44ceb53f9bbed706$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("4TjqH", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $38fb5ecae4d2e932$export$e3607ec2d7a891c4; });

var $ifF79 = parcelRequire("ifF79");
var $gUMOw = parcelRequire("gUMOw");

var $k1l7e = parcelRequire("k1l7e");

var $8SybE = parcelRequire("8SybE");
function $38fb5ecae4d2e932$export$290670472807ab5b(target, options = {}) {
    return (0, $gUMOw.withControls)([
        ()=>{
            const animation = new (0, $8SybE.Animation)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $38fb5ecae4d2e932$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $k1l7e.isFunction)(target) ? $38fb5ecae4d2e932$export$290670472807ab5b : (0, $ifF79.animate);
    return factory(target, keyframesOrOptions, options);
}

});
parcelRegister("ifF79", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $d4998528021370ff$export$e3607ec2d7a891c4; });

var $8SybE = parcelRequire("8SybE");

var $1r0tI = parcelRequire("1r0tI");
const $d4998528021370ff$export$e3607ec2d7a891c4 = (0, $1r0tI.createAnimate)((0, $8SybE.Animation));

});
parcelRegister("8SybE", function(module, exports) {

$parcel$export(module.exports, "Animation", function () { return $676de2b14dafae36$export$c35d437ae5945fcd; });

var $i1k7E = parcelRequire("i1k7E");
var $gJ0Et = parcelRequire("gJ0Et");
var $aTdWT = parcelRequire("aTdWT");
var $dzSv3 = parcelRequire("dzSv3");
var $hO24T = parcelRequire("hO24T");

var $lyGQA = parcelRequire("lyGQA");
class $676de2b14dafae36$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $i1k7E.defaults).duration, delay: delay = (0, $i1k7E.defaults).delay, endDelay: endDelay = (0, $i1k7E.defaults).endDelay, repeat: repeat = (0, $i1k7E.defaults).repeat, offset: offset, direction: direction = "normal" } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $hO24T.noopReturn);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $i1k7E.defaults).easing;
        if ((0, $aTdWT.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $dzSv3.isEasingList)(easing) ? (0, $hO24T.noopReturn) : (0, $lyGQA.getEasingFunction)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $gJ0Et.interpolate)(keyframes, offset, (0, $dzSv3.isEasingList)(easing) ? easing.map((0, $lyGQA.getEasingFunction)) : (0, $hO24T.noopReturn));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}

});
parcelRegister("i1k7E", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $d1e7ede0742e7dbd$export$ebe90cb607ad99e; });
const $d1e7ede0742e7dbd$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

});

parcelRegister("gJ0Et", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $c2d15ac3e5c4f82e$export$89e29e4ab65e70a9; });

var $fRUwH = parcelRequire("fRUwH");

var $hO24T = parcelRequire("hO24T");

var $kiwqk = parcelRequire("kiwqk");

var $eBzTq = parcelRequire("eBzTq");

var $9l3Xt = parcelRequire("9l3Xt");

var $6TahW = parcelRequire("6TahW");
function $c2d15ac3e5c4f82e$export$89e29e4ab65e70a9(output, input = (0, $kiwqk.defaultOffset)(output.length), easing = (0, $hO24T.noopReturn)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $kiwqk.fillOffset)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $6TahW.clamp)(0, 1, (0, $eBzTq.progress)(input[i], input[i + 1], t));
        const segmentEasing = (0, $9l3Xt.getEasingForSegment)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $fRUwH.mix)(output[i], output[i + 1], progressInRange);
    };
}

});
parcelRegister("fRUwH", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $b8d7a735e5ff9087$export$2c9e8a9632a706b2; });
const $b8d7a735e5ff9087$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;

});

parcelRegister("hO24T", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $cf68b7d5f6548204$export$8793edee2d425525; });
$parcel$export(module.exports, "noopReturn", function () { return $cf68b7d5f6548204$export$ea6e51872ab1b721; });
const $cf68b7d5f6548204$export$8793edee2d425525 = ()=>{};
const $cf68b7d5f6548204$export$ea6e51872ab1b721 = (v)=>v;

});

parcelRegister("kiwqk", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $ec6ea3c337719942$export$dafee61230cf05c6; });
$parcel$export(module.exports, "defaultOffset", function () { return $ec6ea3c337719942$export$24dbcec0b26e6d9d; });

var $fRUwH = parcelRequire("fRUwH");

var $eBzTq = parcelRequire("eBzTq");
function $ec6ea3c337719942$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $eBzTq.progress)(0, remaining, i);
        offset.push((0, $fRUwH.mix)(min, 1, offsetProgress));
    }
}
function $ec6ea3c337719942$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $ec6ea3c337719942$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}

});
parcelRegister("eBzTq", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $aa205cfc41a54ac5$export$504d7abb21fa8c9; });
const $aa205cfc41a54ac5$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);

});


parcelRegister("9l3Xt", function(module, exports) {

$parcel$export(module.exports, "getEasingForSegment", function () { return $6cc9253b965e8f09$export$41c5e731255a462; });

var $dzSv3 = parcelRequire("dzSv3");

var $a52Mx = parcelRequire("a52Mx");
function $6cc9253b965e8f09$export$41c5e731255a462(easing, i) {
    return (0, $dzSv3.isEasingList)(easing) ? easing[(0, $a52Mx.wrap)(0, easing.length, i)] : easing;
}

});
parcelRegister("dzSv3", function(module, exports) {

$parcel$export(module.exports, "isEasingList", function () { return $9e28d1cb3ae3b322$export$981cc9ef33696dc8; });

var $3PFzL = parcelRequire("3PFzL");
const $9e28d1cb3ae3b322$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $3PFzL.isNumber)(easing[0]);

});
parcelRegister("3PFzL", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $2ca66296b3d178b9$export$7e4aa119212bc614; });
const $2ca66296b3d178b9$export$7e4aa119212bc614 = (value)=>typeof value === "number";

});


parcelRegister("a52Mx", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $756c876a2b4712ae$export$4997ffc0176396a6; });
const $756c876a2b4712ae$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

});


parcelRegister("6TahW", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $503fdc3448f3ae6e$export$7d15b64cf5a3a4c4; });
const $503fdc3448f3ae6e$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});


parcelRegister("aTdWT", function(module, exports) {

$parcel$export(module.exports, "isEasingGenerator", function () { return $7ed9dc690bd3b919$export$d81a3021299cadf2; });
const $7ed9dc690bd3b919$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);

});

parcelRegister("lyGQA", function(module, exports) {

$parcel$export(module.exports, "getEasingFunction", function () { return $fb1e02834713e1b5$export$9681b459c1c8f0f4; });

var $ktAx6 = parcelRequire("ktAx6");
var $iZzn0 = parcelRequire("iZzn0");

var $d7dME = parcelRequire("d7dME");
var $k1l7e = parcelRequire("k1l7e");
var $hO24T = parcelRequire("hO24T");
const $fb1e02834713e1b5$var$namedEasings = {
    ease: (0, $ktAx6.cubicBezier)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $ktAx6.cubicBezier)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $ktAx6.cubicBezier)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $ktAx6.cubicBezier)(0.0, 0.0, 0.58, 1.0)
};
const $fb1e02834713e1b5$var$functionArgsRegex = /\((.*?)\)/;
function $fb1e02834713e1b5$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $k1l7e.isFunction)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $d7dME.isCubicBezier)(definition)) return (0, $ktAx6.cubicBezier)(...definition);
    // If we have a predefined easing function, return
    if ($fb1e02834713e1b5$var$namedEasings[definition]) return $fb1e02834713e1b5$var$namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $fb1e02834713e1b5$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $iZzn0.steps)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $hO24T.noopReturn;
}

});
parcelRegister("ktAx6", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $ee82dabe3c24399e$export$2c575fa1d20488bd; });

var $hO24T = parcelRequire("hO24T");
/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $ee82dabe3c24399e$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $ee82dabe3c24399e$var$subdivisionPrecision = 0.0000001;
const $ee82dabe3c24399e$var$subdivisionMaxIterations = 12;
function $ee82dabe3c24399e$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $ee82dabe3c24399e$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $ee82dabe3c24399e$var$subdivisionPrecision && ++i < $ee82dabe3c24399e$var$subdivisionMaxIterations);
    return currentT;
}
function $ee82dabe3c24399e$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $hO24T.noopReturn;
    const getTForX = (aX)=>$ee82dabe3c24399e$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $ee82dabe3c24399e$var$calcBezier(getTForX(t), mY1, mY2);
}

});

parcelRegister("iZzn0", function(module, exports) {

$parcel$export(module.exports, "steps", function () { return $dd395c40c08de6b4$export$be3f796aed065412; });

var $6TahW = parcelRequire("6TahW");
const $dd395c40c08de6b4$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $6TahW.clamp)(0, 1, rounded / steps);
    };

});

parcelRegister("d7dME", function(module, exports) {

$parcel$export(module.exports, "isCubicBezier", function () { return $98c69ef8c14db3d3$export$77290801a62f77a2; });

var $3PFzL = parcelRequire("3PFzL");
const $98c69ef8c14db3d3$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $3PFzL.isNumber)(easing[0]);

});

parcelRegister("k1l7e", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $e93447c063bb73b8$export$f6e2535fb5126e54; });
const $e93447c063bb73b8$export$f6e2535fb5126e54 = (value)=>typeof value === "function";

});



parcelRegister("1r0tI", function(module, exports) {

$parcel$export(module.exports, "createAnimate", function () { return $10b8af06fd43a0ee$export$2a47ca22dbf0bb08; });

var $8Ijeh = parcelRequire("8Ijeh");

var $1YLGK = parcelRequire("1YLGK");

var $cvI7S = parcelRequire("cvI7S");

var $2l6Ny = parcelRequire("2l6Ny");

var $gUMOw = parcelRequire("gUMOw");

var $lUX7I = parcelRequire("lUX7I");
function $10b8af06fd43a0ee$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $2l6Ny.resolveElements)(elements);
        const numElements = elements.length;
        (0, $8Ijeh.invariant)(Boolean(numElements), "No valid element provided.");
        (0, $8Ijeh.invariant)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $cvI7S.getOptions)(options, key);
                valueOptions.delay = (0, $lUX7I.resolveOption)(valueOptions.delay, i, numElements);
                const animation = (0, $1YLGK.animateStyle)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $gUMOw.withControls)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}

});
parcelRegister("8Ijeh", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $6581595267cec75d$export$f5708dca728d7177; });
var $6581595267cec75d$export$491112666e282270 = function() {};
var $6581595267cec75d$export$f5708dca728d7177 = function() {};

});

parcelRegister("1YLGK", function(module, exports) {

$parcel$export(module.exports, "animateStyle", function () { return $171062fc9eb4e9d5$export$c76cd972d26986f9; });

var $6G1cz = parcelRequire("6G1cz");

var $1TBge = parcelRequire("1TBge");

var $i1k7E = parcelRequire("i1k7E");
var $aTdWT = parcelRequire("aTdWT");
var $dzSv3 = parcelRequire("dzSv3");
var $k1l7e = parcelRequire("k1l7e");
var $3PFzL = parcelRequire("3PFzL");
var $hO24T = parcelRequire("hO24T");
var $1ydyQ = parcelRequire("1ydyQ");

var $2Qqkv = parcelRequire("2Qqkv");

var $ahI0m = parcelRequire("ahI0m");

var $98rA0 = parcelRequire("98rA0");

var $F8HIF = parcelRequire("F8HIF");

var $alcNo = parcelRequire("alcNo");

var $eYv8w = parcelRequire("eYv8w");

var $eOVNU = parcelRequire("eOVNU");

var $jLMfl = parcelRequire("jLMfl");
function $171062fc9eb4e9d5$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $171062fc9eb4e9d5$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $171062fc9eb4e9d5$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $i1k7E.defaults).duration, delay: delay = (0, $i1k7E.defaults).delay, endDelay: endDelay = (0, $i1k7E.defaults).endDelay, repeat: repeat = (0, $i1k7E.defaults).repeat, easing: easing = (0, $i1k7E.defaults).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false } = options;
    const data = (0, $6G1cz.getAnimationData)(element);
    const valueIsTransform = (0, $2Qqkv.isTransform)(key);
    let canAnimateNatively = (0, $98rA0.supports).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $2Qqkv.addTransformToElement)(element, key);
    const name = (0, $eYv8w.getStyleName)(key);
    const motionValue = (0, $6G1cz.getMotionValue)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $2Qqkv.transformDefinitions).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $eOVNU.stopAnimation)(motionValue.animation, !((0, $aTdWT.isEasingGenerator)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $alcNo.style).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $F8HIF.hydrateKeyframes)((0, $F8HIF.keyframesList)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $jLMfl.getUnitConverter)(keyframes, definition);
        if ((0, $aTdWT.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $1TBge.isCssVar)(name)) {
            if ((0, $98rA0.supports).cssRegisterProperty()) (0, $1TBge.registerCssVariable)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $98rA0.supports).linearEasing() && ((0, $k1l7e.isFunction)(easing) || (0, $dzSv3.isEasingList)(easing) && easing.some((0, $k1l7e.isFunction)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $3PFzL.isNumber)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $98rA0.supports).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $1ydyQ.time).ms(delay),
                duration: (0, $1ydyQ.time).ms(duration),
                endDelay: (0, $1ydyQ.time).ms(endDelay),
                easing: !(0, $dzSv3.isEasingList)(easing) ? (0, $ahI0m.convertEasing)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $dzSv3.isEasingList)(easing) ? easing.map((thisEasing)=>(0, $ahI0m.convertEasing)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $alcNo.style).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $hO24T.noop));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $alcNo.style).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $alcNo.style).set(element, name, definition && (0, $3PFzL.isNumber)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        return animation;
    };
}

});
parcelRegister("6G1cz", function(module, exports) {

$parcel$export(module.exports, "getAnimationData", function () { return $014127a0cc980367$export$213eea93596b44f; });
$parcel$export(module.exports, "getMotionValue", function () { return $014127a0cc980367$export$c0999ba824977ca6; });

var $fOdw1 = parcelRequire("fOdw1");
const $014127a0cc980367$var$data = new WeakMap();
function $014127a0cc980367$export$213eea93596b44f(element) {
    if (!$014127a0cc980367$var$data.has(element)) $014127a0cc980367$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $014127a0cc980367$var$data.get(element);
}
function $014127a0cc980367$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $fOdw1.MotionValue)());
    return motionValues.get(name);
}

});
parcelRegister("fOdw1", function(module, exports) {

$parcel$export(module.exports, "MotionValue", function () { return $b826026c28e3a78a$export$8cea36d14ee64562; });
/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $b826026c28e3a78a$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}

});


parcelRegister("1TBge", function(module, exports) {

$parcel$export(module.exports, "isCssVar", function () { return $1617d4b9d4b7d320$export$30a9abfd5fb9f5f6; });
$parcel$export(module.exports, "registerCssVariable", function () { return $1617d4b9d4b7d320$export$9fdd8c2f6f59adb0; });

var $2Qqkv = parcelRequire("2Qqkv");
const $1617d4b9d4b7d320$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $1617d4b9d4b7d320$export$7a740cb9e3dd106d = new Set();
function $1617d4b9d4b7d320$export$9fdd8c2f6f59adb0(name) {
    if ($1617d4b9d4b7d320$export$7a740cb9e3dd106d.has(name)) return;
    $1617d4b9d4b7d320$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $2Qqkv.transformDefinitions).has(name) ? (0, $2Qqkv.transformDefinitions).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}

});
parcelRegister("2Qqkv", function(module, exports) {

$parcel$export(module.exports, "transformAlias", function () { return $2124dc9d38bd5d47$export$97b5d3c90609c212; });
$parcel$export(module.exports, "transformDefinitions", function () { return $2124dc9d38bd5d47$export$a9dad2abc3d443d; });
$parcel$export(module.exports, "asTransformCssVar", function () { return $2124dc9d38bd5d47$export$7bbd29b1fa8b68d4; });
$parcel$export(module.exports, "isTransform", function () { return $2124dc9d38bd5d47$export$8a546e9da811625d; });
$parcel$export(module.exports, "addTransformToElement", function () { return $2124dc9d38bd5d47$export$40eba1f1af915c93; });

var $dbaTp = parcelRequire("dbaTp");
var $hO24T = parcelRequire("hO24T");

var $6G1cz = parcelRequire("6G1cz");
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $2124dc9d38bd5d47$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $2124dc9d38bd5d47$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $2124dc9d38bd5d47$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $2124dc9d38bd5d47$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $2124dc9d38bd5d47$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $2124dc9d38bd5d47$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $hO24T.noopReturn)
    },
    skew: $2124dc9d38bd5d47$var$rotation
};
const $2124dc9d38bd5d47$export$a9dad2abc3d443d = new Map();
const $2124dc9d38bd5d47$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $2124dc9d38bd5d47$var$transforms = [
    "x",
    "y",
    "z"
];
$2124dc9d38bd5d47$var$order.forEach((name)=>{
    $2124dc9d38bd5d47$export$a9a762b9618d4a18.forEach((axis)=>{
        $2124dc9d38bd5d47$var$transforms.push(name + axis);
        $2124dc9d38bd5d47$export$a9dad2abc3d443d.set($2124dc9d38bd5d47$export$7bbd29b1fa8b68d4(name + axis), $2124dc9d38bd5d47$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $2124dc9d38bd5d47$export$11410fe03e8c4042 = (a, b)=>$2124dc9d38bd5d47$var$transforms.indexOf(a) - $2124dc9d38bd5d47$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $2124dc9d38bd5d47$var$transformLookup = new Set($2124dc9d38bd5d47$var$transforms);
const $2124dc9d38bd5d47$export$8a546e9da811625d = (name)=>$2124dc9d38bd5d47$var$transformLookup.has(name);
const $2124dc9d38bd5d47$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($2124dc9d38bd5d47$export$97b5d3c90609c212[name]) name = $2124dc9d38bd5d47$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $6G1cz.getAnimationData)(element);
    (0, $dbaTp.addUniqueItem)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $2124dc9d38bd5d47$export$785216816cb6f870(transforms);
};
const $2124dc9d38bd5d47$export$785216816cb6f870 = (transforms)=>transforms.sort($2124dc9d38bd5d47$export$11410fe03e8c4042).reduce($2124dc9d38bd5d47$var$transformListToString, "").trim();
const $2124dc9d38bd5d47$var$transformListToString = (template, name)=>`${template} ${name}(var(${$2124dc9d38bd5d47$export$7bbd29b1fa8b68d4(name)}))`;

});
parcelRegister("dbaTp", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $9984c080c67cfc4c$export$20e507e47fae79fd; });
function $9984c080c67cfc4c$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $9984c080c67cfc4c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

});



parcelRegister("1ydyQ", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $12137c562e9f415c$export$2da9be4cfdb689b1; });
const $12137c562e9f415c$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};

});

parcelRegister("ahI0m", function(module, exports) {

$parcel$export(module.exports, "convertEasing", function () { return $77cda060fa526743$export$284d1118c33f9836; });

var $i1k7E = parcelRequire("i1k7E");
var $d7dME = parcelRequire("d7dME");
var $k1l7e = parcelRequire("k1l7e");
var $eBzTq = parcelRequire("eBzTq");

var $98rA0 = parcelRequire("98rA0");
// Create a linear easing point for every x second
const $77cda060fa526743$var$resolution = 0.015;
const $77cda060fa526743$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $77cda060fa526743$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $eBzTq.progress)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $77cda060fa526743$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $k1l7e.isFunction)(easing)) return (0, $98rA0.supports).linearEasing() ? `linear(${$77cda060fa526743$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $i1k7E.defaults).easing;
    else return (0, $d7dME.isCubicBezier)(easing) ? $77cda060fa526743$export$2523b8f0bd8f44cb(easing) : easing;
};
const $77cda060fa526743$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

});
parcelRegister("98rA0", function(module, exports) {

$parcel$export(module.exports, "supports", function () { return $6a6a4132491a7c97$export$cde6a56f9669daf6; });
const $6a6a4132491a7c97$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $6a6a4132491a7c97$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $6a6a4132491a7c97$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($6a6a4132491a7c97$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $6a6a4132491a7c97$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $6a6a4132491a7c97$var$results = {};
const $6a6a4132491a7c97$export$cde6a56f9669daf6 = {};
for(const key in $6a6a4132491a7c97$var$featureTests)$6a6a4132491a7c97$export$cde6a56f9669daf6[key] = ()=>{
    if ($6a6a4132491a7c97$var$results[key] === undefined) $6a6a4132491a7c97$var$results[key] = $6a6a4132491a7c97$var$featureTests[key]();
    return $6a6a4132491a7c97$var$results[key];
};

});


parcelRegister("F8HIF", function(module, exports) {

$parcel$export(module.exports, "hydrateKeyframes", function () { return $07ba94e9d2bf266b$export$3d2f5b3e7004e0cf; });
$parcel$export(module.exports, "keyframesList", function () { return $07ba94e9d2bf266b$export$388e66a97327a012; });
function $07ba94e9d2bf266b$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $07ba94e9d2bf266b$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];

});

parcelRegister("alcNo", function(module, exports) {

$parcel$export(module.exports, "style", function () { return $7875ca7eea341179$export$1d567c320f4763bc; });

var $1TBge = parcelRequire("1TBge");

var $eYv8w = parcelRequire("eYv8w");

var $2Qqkv = parcelRequire("2Qqkv");
const $7875ca7eea341179$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $eYv8w.getStyleName)(name);
        let value = (0, $1TBge.isCssVar)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, $2Qqkv.transformDefinitions).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $eYv8w.getStyleName)(name);
        if ((0, $1TBge.isCssVar)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};

});
parcelRegister("eYv8w", function(module, exports) {

$parcel$export(module.exports, "getStyleName", function () { return $ae6ed25c621f682e$export$b6557f397a74f857; });

var $2Qqkv = parcelRequire("2Qqkv");
function $ae6ed25c621f682e$export$b6557f397a74f857(key) {
    if ((0, $2Qqkv.transformAlias)[key]) key = (0, $2Qqkv.transformAlias)[key];
    return (0, $2Qqkv.isTransform)(key) ? (0, $2Qqkv.asTransformCssVar)(key) : key;
}

});


parcelRegister("eOVNU", function(module, exports) {

$parcel$export(module.exports, "stopAnimation", function () { return $aca292e0fd716f22$export$3cc6f911ef1fd837; });
function $aca292e0fd716f22$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}

});

parcelRegister("jLMfl", function(module, exports) {

$parcel$export(module.exports, "getUnitConverter", function () { return $e647d4daa1141cd1$export$4bcf070800a2fd35; });

var $lkIZe = parcelRequire("lkIZe");
var $hO24T = parcelRequire("hO24T");
function $e647d4daa1141cd1$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $hO24T.noopReturn);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $lkIZe.isString)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}

});
parcelRegister("lkIZe", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $f87e5ca7b7784ad2$export$844ec244b1367d54; });
const $f87e5ca7b7784ad2$export$844ec244b1367d54 = (value)=>typeof value === "string";

});



parcelRegister("cvI7S", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $91ba9bcd06039c04$export$d2312e68e1f5ad00; });
const $91ba9bcd06039c04$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);

});

parcelRegister("2l6Ny", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $1b42d0f16d964c14$export$90ceba2564a894f8; });
function $1b42d0f16d964c14$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

});

parcelRegister("gUMOw", function(module, exports) {

$parcel$export(module.exports, "withControls", function () { return $c507bdbb1e26029d$export$c5e4bb50450218c1; });

var $i1k7E = parcelRequire("i1k7E");
var $hO24T = parcelRequire("hO24T");
var $1ydyQ = parcelRequire("1ydyQ");

var $eOVNU = parcelRequire("eOVNU");
const $c507bdbb1e26029d$var$createAnimation = (factory)=>factory();
const $c507bdbb1e26029d$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $i1k7E.defaults).duration)=>{
    return new Proxy({
        animations: animationFactory.map($c507bdbb1e26029d$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $c507bdbb1e26029d$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $c507bdbb1e26029d$var$getActiveAnimation = (state)=>state.animations[0];
const $c507bdbb1e26029d$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $c507bdbb1e26029d$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $1ydyQ.time).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($c507bdbb1e26029d$var$selectFinished)).catch((0, $hO24T.noop));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $eOVNU.stopAnimation)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $1ydyQ.time).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $c507bdbb1e26029d$var$selectFinished = (animation)=>animation.finished;

});

parcelRegister("lUX7I", function(module, exports) {

$parcel$export(module.exports, "resolveOption", function () { return $ff4cb09aea64db7c$export$4cf8f03b86be8175; });

var $k1l7e = parcelRequire("k1l7e");
var $3PFzL = parcelRequire("3PFzL");

var $lyGQA = parcelRequire("lyGQA");
function $ff4cb09aea64db7c$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $3PFzL.isNumber)(from) ? from : $ff4cb09aea64db7c$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $lyGQA.getEasingFunction)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $ff4cb09aea64db7c$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $ff4cb09aea64db7c$export$4cf8f03b86be8175(option, i, total) {
    return (0, $k1l7e.isFunction)(option) ? option(i, total) : option;
}

});




parcelRegister("4a57W", function(module, exports) {
$parcel$export(module.exports, "ifDefined", function () { return (parcelRequire("7He6a")).ifDefined; });
parcelRequire("7He6a");

});
parcelRegister("7He6a", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $59a77c34f33be81e$export$f68dd208b5df064d; });

var $7mSD6 = parcelRequire("7mSD6");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $59a77c34f33be81e$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $7mSD6.nothing);

});


parcelRegister("doQTd", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $9c168b0797dbeca7$export$185802fd694ee1f5; }, function (v) { return $9c168b0797dbeca7$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "toCanvas", function () { return $9c168b0797dbeca7$export$f87f6982d1fd4f81; }, function (v) { return $9c168b0797dbeca7$export$f87f6982d1fd4f81 = v; });
$parcel$export(module.exports, "toDataURL", function () { return $9c168b0797dbeca7$export$723e4939e5a27c8; }, function (v) { return $9c168b0797dbeca7$export$723e4939e5a27c8 = v; });
$parcel$export(module.exports, "toString", function () { return $9c168b0797dbeca7$export$f84e8e69fd4488a5; }, function (v) { return $9c168b0797dbeca7$export$f84e8e69fd4488a5 = v; });
var $9c168b0797dbeca7$export$185802fd694ee1f5;
var $9c168b0797dbeca7$export$f87f6982d1fd4f81;
var $9c168b0797dbeca7$export$723e4939e5a27c8;
// only svg for now.
var $9c168b0797dbeca7$export$f84e8e69fd4488a5;

var $d8dUW = parcelRequire("d8dUW");

var $247DG = parcelRequire("247DG");

var $eJCjM = parcelRequire("eJCjM");

var $flZLo = parcelRequire("flZLo");
function $9c168b0797dbeca7$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$d8dUW()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $247DG.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $247DG.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$9c168b0797dbeca7$export$185802fd694ee1f5 = $247DG.create;
$9c168b0797dbeca7$export$f87f6982d1fd4f81 = $9c168b0797dbeca7$var$renderCanvas.bind(null, $eJCjM.render);
$9c168b0797dbeca7$export$723e4939e5a27c8 = $9c168b0797dbeca7$var$renderCanvas.bind(null, $eJCjM.renderToDataURL);
$9c168b0797dbeca7$export$f84e8e69fd4488a5 = $9c168b0797dbeca7$var$renderCanvas.bind(null, function(data, _, opts) {
    return $flZLo.render(data, opts);
});

});
parcelRegister("d8dUW", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("247DG", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $1811e16ed7e5288e$export$185802fd694ee1f5; }, function (v) { return $1811e16ed7e5288e$export$185802fd694ee1f5 = v; });
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $1811e16ed7e5288e$export$185802fd694ee1f5;

var $hc0K2 = parcelRequire("hc0K2");

var $5A7FP = parcelRequire("5A7FP");

var $a4aX4 = parcelRequire("a4aX4");

var $9svXv = parcelRequire("9svXv");

var $cWL3N = parcelRequire("cWL3N");

var $l8AS6 = parcelRequire("l8AS6");

var $hn4Hm = parcelRequire("hn4Hm");

var $8b9mQ = parcelRequire("8b9mQ");

var $jmrum = parcelRequire("jmrum");

var $cMcRp = parcelRequire("cMcRp");

var $a7Ejv = parcelRequire("a7Ejv");

var $5sgEO = parcelRequire("5sgEO");

var $1AMOQ = parcelRequire("1AMOQ");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1811e16ed7e5288e$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $l8AS6.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $1811e16ed7e5288e$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1811e16ed7e5288e$var$setupAlignmentPattern(matrix, version) {
    const pos = $cWL3N.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1811e16ed7e5288e$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $cMcRp.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $1811e16ed7e5288e$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $a7Ejv.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $1811e16ed7e5288e$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $1811e16ed7e5288e$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $a4aX4();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $5sgEO.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $hc0K2.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $8b9mQ.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $1811e16ed7e5288e$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $1811e16ed7e5288e$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $hc0K2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $8b9mQ.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $8b9mQ.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $jmrum(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $1811e16ed7e5288e$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $1AMOQ.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $1AMOQ.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $cMcRp.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $1AMOQ.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $cMcRp.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $1811e16ed7e5288e$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $hc0K2.getSymbolSize(version);
    const modules = new $9svXv(moduleCount);
    // Add function modules
    $1811e16ed7e5288e$var$setupFinderPattern(modules, version);
    $1811e16ed7e5288e$var$setupTimingPattern(modules);
    $1811e16ed7e5288e$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $1811e16ed7e5288e$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $1811e16ed7e5288e$var$setupVersionInfo(modules, version);
    // Add data codewords
    $1811e16ed7e5288e$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $hn4Hm.getBestMask(modules, $1811e16ed7e5288e$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $hn4Hm.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $1811e16ed7e5288e$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$1811e16ed7e5288e$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $5A7FP.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $5A7FP.from(options.errorCorrectionLevel, $5A7FP.M);
        version = $cMcRp.from(options.version);
        mask = $hn4Hm.from(options.maskPattern);
        if (options.toSJISFunc) $hc0K2.setToSJISFunction(options.toSJISFunc);
    }
    return $1811e16ed7e5288e$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("hc0K2", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", function () { return $c84421e5dacd7952$export$8d4a06d3facd414b; }, function (v) { return $c84421e5dacd7952$export$8d4a06d3facd414b = v; });
$parcel$export(module.exports, "getSymbolTotalCodewords", function () { return $c84421e5dacd7952$export$b05dac13c7a35c32; }, function (v) { return $c84421e5dacd7952$export$b05dac13c7a35c32 = v; });
$parcel$export(module.exports, "getBCHDigit", function () { return $c84421e5dacd7952$export$ed1d66da50968976; }, function (v) { return $c84421e5dacd7952$export$ed1d66da50968976 = v; });
$parcel$export(module.exports, "setToSJISFunction", function () { return $c84421e5dacd7952$export$6733b14783f975c2; }, function (v) { return $c84421e5dacd7952$export$6733b14783f975c2 = v; });
$parcel$export(module.exports, "isKanjiModeEnabled", function () { return $c84421e5dacd7952$export$ce5b1274f8597fa0; }, function (v) { return $c84421e5dacd7952$export$ce5b1274f8597fa0 = v; });
$parcel$export(module.exports, "toSJIS", function () { return $c84421e5dacd7952$export$43dd553ecded716d; }, function (v) { return $c84421e5dacd7952$export$43dd553ecded716d = v; });
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c84421e5dacd7952$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c84421e5dacd7952$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c84421e5dacd7952$export$ed1d66da50968976;
var $c84421e5dacd7952$export$6733b14783f975c2;
var $c84421e5dacd7952$export$ce5b1274f8597fa0;
var $c84421e5dacd7952$export$43dd553ecded716d;
let $c84421e5dacd7952$var$toSJISFunction;
const $c84421e5dacd7952$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c84421e5dacd7952$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c84421e5dacd7952$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c84421e5dacd7952$var$CODEWORDS_COUNT[version];
};
$c84421e5dacd7952$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c84421e5dacd7952$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c84421e5dacd7952$var$toSJISFunction = f;
};
$c84421e5dacd7952$export$ce5b1274f8597fa0 = function() {
    return typeof $c84421e5dacd7952$var$toSJISFunction !== "undefined";
};
$c84421e5dacd7952$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c84421e5dacd7952$var$toSJISFunction(kanji);
};

});

parcelRegister("5A7FP", function(module, exports) {

$parcel$export(module.exports, "L", function () { return $4106445f3e02cedb$export$61196ced6d74a310; }, function (v) { return $4106445f3e02cedb$export$61196ced6d74a310 = v; });
$parcel$export(module.exports, "M", function () { return $4106445f3e02cedb$export$3a1a48c8f6ef640e; }, function (v) { return $4106445f3e02cedb$export$3a1a48c8f6ef640e = v; });
$parcel$export(module.exports, "Q", function () { return $4106445f3e02cedb$export$3722cfe417b6ed86; }, function (v) { return $4106445f3e02cedb$export$3722cfe417b6ed86 = v; });
$parcel$export(module.exports, "H", function () { return $4106445f3e02cedb$export$7f8ddf7c7c20b3cd; }, function (v) { return $4106445f3e02cedb$export$7f8ddf7c7c20b3cd = v; });
$parcel$export(module.exports, "isValid", function () { return $4106445f3e02cedb$export$1ea939691cdc45b8; }, function (v) { return $4106445f3e02cedb$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $4106445f3e02cedb$export$6788812c4e6611e6; }, function (v) { return $4106445f3e02cedb$export$6788812c4e6611e6 = v; });
var $4106445f3e02cedb$export$61196ced6d74a310;
var $4106445f3e02cedb$export$3a1a48c8f6ef640e;
var $4106445f3e02cedb$export$3722cfe417b6ed86;
var $4106445f3e02cedb$export$7f8ddf7c7c20b3cd;
var $4106445f3e02cedb$export$1ea939691cdc45b8;
var $4106445f3e02cedb$export$6788812c4e6611e6;
$4106445f3e02cedb$export$61196ced6d74a310 = {
    bit: 1
};
$4106445f3e02cedb$export$3a1a48c8f6ef640e = {
    bit: 0
};
$4106445f3e02cedb$export$3722cfe417b6ed86 = {
    bit: 3
};
$4106445f3e02cedb$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $4106445f3e02cedb$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $4106445f3e02cedb$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $4106445f3e02cedb$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $4106445f3e02cedb$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $4106445f3e02cedb$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$4106445f3e02cedb$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$4106445f3e02cedb$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($4106445f3e02cedb$export$1ea939691cdc45b8(value)) return value;
    try {
        return $4106445f3e02cedb$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("a4aX4", function(module, exports) {
function $7542c5e7ece2f1a2$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$7542c5e7ece2f1a2$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $7542c5e7ece2f1a2$var$BitBuffer;

});

parcelRegister("9svXv", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $6e2f84eea9527b49$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $6e2f84eea9527b49$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $6e2f84eea9527b49$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $6e2f84eea9527b49$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $6e2f84eea9527b49$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $6e2f84eea9527b49$var$BitMatrix;

});

parcelRegister("cWL3N", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", function () { return $96cf6803b6f9e254$export$cb05537eb8e57a83; }, function (v) { return $96cf6803b6f9e254$export$cb05537eb8e57a83 = v; });
$parcel$export(module.exports, "getPositions", function () { return $96cf6803b6f9e254$export$c39457c570f2b189; }, function (v) { return $96cf6803b6f9e254$export$c39457c570f2b189 = v; });
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $96cf6803b6f9e254$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $96cf6803b6f9e254$export$c39457c570f2b189;

var $hc0K2 = parcelRequire("hc0K2");
var $96cf6803b6f9e254$require$getSymbolSize = $hc0K2.getSymbolSize;
$96cf6803b6f9e254$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $96cf6803b6f9e254$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$96cf6803b6f9e254$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $96cf6803b6f9e254$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("l8AS6", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $f636f2476ae2fc8d$export$c39457c570f2b189; }, function (v) { return $f636f2476ae2fc8d$export$c39457c570f2b189 = v; });
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $f636f2476ae2fc8d$export$c39457c570f2b189;

var $hc0K2 = parcelRequire("hc0K2");
var $f636f2476ae2fc8d$require$getSymbolSize = $hc0K2.getSymbolSize;
const $f636f2476ae2fc8d$var$FINDER_PATTERN_SIZE = 7;
$f636f2476ae2fc8d$export$c39457c570f2b189 = function getPositions(version) {
    const size = $f636f2476ae2fc8d$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $f636f2476ae2fc8d$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $f636f2476ae2fc8d$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("hn4Hm", function(module, exports) {

$parcel$export(module.exports, "Patterns", function () { return $03437cd1075cd598$export$7ed115685df827af; }, function (v) { return $03437cd1075cd598$export$7ed115685df827af = v; });
$parcel$export(module.exports, "isValid", function () { return $03437cd1075cd598$export$1ea939691cdc45b8; }, function (v) { return $03437cd1075cd598$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $03437cd1075cd598$export$6788812c4e6611e6; }, function (v) { return $03437cd1075cd598$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getPenaltyN1", function () { return $03437cd1075cd598$export$a5fd3a02c14d0b3e; }, function (v) { return $03437cd1075cd598$export$a5fd3a02c14d0b3e = v; });
$parcel$export(module.exports, "getPenaltyN2", function () { return $03437cd1075cd598$export$9a9385107a518e46; }, function (v) { return $03437cd1075cd598$export$9a9385107a518e46 = v; });
$parcel$export(module.exports, "getPenaltyN3", function () { return $03437cd1075cd598$export$ade754353f0dc75e; }, function (v) { return $03437cd1075cd598$export$ade754353f0dc75e = v; });
$parcel$export(module.exports, "getPenaltyN4", function () { return $03437cd1075cd598$export$3ff6f04d40d9962b; }, function (v) { return $03437cd1075cd598$export$3ff6f04d40d9962b = v; });
$parcel$export(module.exports, "applyMask", function () { return $03437cd1075cd598$export$a1c9aa9c0e8ba394; }, function (v) { return $03437cd1075cd598$export$a1c9aa9c0e8ba394 = v; });
$parcel$export(module.exports, "getBestMask", function () { return $03437cd1075cd598$export$fe9625aaceb0e563; }, function (v) { return $03437cd1075cd598$export$fe9625aaceb0e563 = v; });
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $03437cd1075cd598$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $03437cd1075cd598$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $03437cd1075cd598$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $03437cd1075cd598$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $03437cd1075cd598$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $03437cd1075cd598$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $03437cd1075cd598$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $03437cd1075cd598$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $03437cd1075cd598$export$fe9625aaceb0e563;
$03437cd1075cd598$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $03437cd1075cd598$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$03437cd1075cd598$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$03437cd1075cd598$export$6788812c4e6611e6 = function from(value) {
    return $03437cd1075cd598$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$03437cd1075cd598$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $03437cd1075cd598$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $03437cd1075cd598$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $03437cd1075cd598$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $03437cd1075cd598$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$03437cd1075cd598$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $03437cd1075cd598$var$PenaltyScores.N2;
};
$03437cd1075cd598$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $03437cd1075cd598$var$PenaltyScores.N3;
};
$03437cd1075cd598$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $03437cd1075cd598$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $03437cd1075cd598$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $03437cd1075cd598$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$03437cd1075cd598$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $03437cd1075cd598$var$getMaskAt(pattern, row, col));
    }
};
$03437cd1075cd598$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($03437cd1075cd598$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $03437cd1075cd598$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $03437cd1075cd598$export$a5fd3a02c14d0b3e(data) + $03437cd1075cd598$export$9a9385107a518e46(data) + $03437cd1075cd598$export$ade754353f0dc75e(data) + $03437cd1075cd598$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $03437cd1075cd598$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("8b9mQ", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", function () { return $5f469df9b5d4f2f1$export$41a1fc627aca72b9; }, function (v) { return $5f469df9b5d4f2f1$export$41a1fc627aca72b9 = v; });
$parcel$export(module.exports, "getTotalCodewordsCount", function () { return $5f469df9b5d4f2f1$export$683d1b3e8a1a8438; }, function (v) { return $5f469df9b5d4f2f1$export$683d1b3e8a1a8438 = v; });
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $5f469df9b5d4f2f1$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $5f469df9b5d4f2f1$export$683d1b3e8a1a8438;

var $5A7FP = parcelRequire("5A7FP");
const $5f469df9b5d4f2f1$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $5f469df9b5d4f2f1$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$5f469df9b5d4f2f1$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $5A7FP.L:
            return $5f469df9b5d4f2f1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $5A7FP.M:
            return $5f469df9b5d4f2f1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $5A7FP.Q:
            return $5f469df9b5d4f2f1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $5A7FP.H:
            return $5f469df9b5d4f2f1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$5f469df9b5d4f2f1$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $5A7FP.L:
            return $5f469df9b5d4f2f1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $5A7FP.M:
            return $5f469df9b5d4f2f1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $5A7FP.Q:
            return $5f469df9b5d4f2f1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $5A7FP.H:
            return $5f469df9b5d4f2f1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("jmrum", function(module, exports) {

var $flqan = parcelRequire("flqan");
function $e1856514d2d2c0e6$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $e1856514d2d2c0e6$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $flqan.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $e1856514d2d2c0e6$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $flqan.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $e1856514d2d2c0e6$var$ReedSolomonEncoder;

});
parcelRegister("flqan", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $b2bd1d49b55e0555$export$6e3a27864ab166fe; }, function (v) { return $b2bd1d49b55e0555$export$6e3a27864ab166fe = v; });
$parcel$export(module.exports, "mod", function () { return $b2bd1d49b55e0555$export$842a2cf37af977e1; }, function (v) { return $b2bd1d49b55e0555$export$842a2cf37af977e1 = v; });
$parcel$export(module.exports, "generateECPolynomial", function () { return $b2bd1d49b55e0555$export$7b8be06a973a9d05; }, function (v) { return $b2bd1d49b55e0555$export$7b8be06a973a9d05 = v; });
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $b2bd1d49b55e0555$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $b2bd1d49b55e0555$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $b2bd1d49b55e0555$export$7b8be06a973a9d05;

var $2g7NU = parcelRequire("2g7NU");
$b2bd1d49b55e0555$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $2g7NU.mul(p1[i], p2[j]);
    return coeff;
};
$b2bd1d49b55e0555$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $2g7NU.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$b2bd1d49b55e0555$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $b2bd1d49b55e0555$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $2g7NU.exp(i)
    ]));
    return poly;
};

});
parcelRegister("2g7NU", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $1a53211f4de0f54c$export$b310ec824aaee37f; }, function (v) { return $1a53211f4de0f54c$export$b310ec824aaee37f = v; });
$parcel$export(module.exports, "mul", function () { return $1a53211f4de0f54c$export$6e3a27864ab166fe; }, function (v) { return $1a53211f4de0f54c$export$6e3a27864ab166fe = v; });
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $1a53211f4de0f54c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $1a53211f4de0f54c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $1a53211f4de0f54c$export$6e3a27864ab166fe;
const $1a53211f4de0f54c$var$EXP_TABLE = new Uint8Array(512);
const $1a53211f4de0f54c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $1a53211f4de0f54c$var$EXP_TABLE[i] = x;
        $1a53211f4de0f54c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$1a53211f4de0f54c$var$EXP_TABLE[i] = $1a53211f4de0f54c$var$EXP_TABLE[i - 255];
})();
$1a53211f4de0f54c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $1a53211f4de0f54c$var$LOG_TABLE[n];
};
$1a53211f4de0f54c$export$b310ec824aaee37f = function exp(n) {
    return $1a53211f4de0f54c$var$EXP_TABLE[n];
};
$1a53211f4de0f54c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $1a53211f4de0f54c$var$EXP_TABLE[$1a53211f4de0f54c$var$LOG_TABLE[x] + $1a53211f4de0f54c$var$LOG_TABLE[y]];
};

});



parcelRegister("cMcRp", function(module, exports) {

$parcel$export(module.exports, "getCapacity", function () { return $94d3f18b05d4137a$export$55b283886ec2d3fb; }, function (v) { return $94d3f18b05d4137a$export$55b283886ec2d3fb = v; });
$parcel$export(module.exports, "from", function () { return $94d3f18b05d4137a$export$6788812c4e6611e6; }, function (v) { return $94d3f18b05d4137a$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getBestVersionForData", function () { return $94d3f18b05d4137a$export$264e969aa7a8ff7e; }, function (v) { return $94d3f18b05d4137a$export$264e969aa7a8ff7e = v; });
$parcel$export(module.exports, "getEncodedBits", function () { return $94d3f18b05d4137a$export$eee5438974ef6f0e; }, function (v) { return $94d3f18b05d4137a$export$eee5438974ef6f0e = v; });
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $94d3f18b05d4137a$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $94d3f18b05d4137a$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $94d3f18b05d4137a$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $94d3f18b05d4137a$export$eee5438974ef6f0e;

var $hc0K2 = parcelRequire("hc0K2");

var $8b9mQ = parcelRequire("8b9mQ");

var $5A7FP = parcelRequire("5A7FP");

var $5sgEO = parcelRequire("5sgEO");

var $c3LTx = parcelRequire("c3LTx");
// Generator polynomial used to encode version information
const $94d3f18b05d4137a$var$G18 = 7973;
const $94d3f18b05d4137a$var$G18_BCH = $hc0K2.getBCHDigit($94d3f18b05d4137a$var$G18);
function $94d3f18b05d4137a$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $94d3f18b05d4137a$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $94d3f18b05d4137a$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $5sgEO.getCharCountIndicator(mode, version) + 4;
}
function $94d3f18b05d4137a$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $94d3f18b05d4137a$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $94d3f18b05d4137a$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $94d3f18b05d4137a$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $94d3f18b05d4137a$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $5sgEO.MIXED)) return currentVersion;
    }
    return undefined;
}
$94d3f18b05d4137a$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($c3LTx.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$94d3f18b05d4137a$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$c3LTx.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $5sgEO.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $hc0K2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $8b9mQ.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $5sgEO.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $94d3f18b05d4137a$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $5sgEO.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $5sgEO.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $5sgEO.KANJI:
            return Math.floor(usableBits / 13);
        case $5sgEO.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$94d3f18b05d4137a$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $5A7FP.from(errorCorrectionLevel, $5A7FP.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $94d3f18b05d4137a$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $94d3f18b05d4137a$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$94d3f18b05d4137a$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$c3LTx.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($hc0K2.getBCHDigit(d) - $94d3f18b05d4137a$var$G18_BCH >= 0)d ^= $94d3f18b05d4137a$var$G18 << $hc0K2.getBCHDigit(d) - $94d3f18b05d4137a$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("5sgEO", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", function () { return $3f8c7d1186c29758$export$4d318981b5a83836; }, function (v) { return $3f8c7d1186c29758$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $3f8c7d1186c29758$export$376a9ed239d6c1c8; }, function (v) { return $3f8c7d1186c29758$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "BYTE", function () { return $3f8c7d1186c29758$export$8f4bf8f7eb581284; }, function (v) { return $3f8c7d1186c29758$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "KANJI", function () { return $3f8c7d1186c29758$export$a4d452c2363c8e12; }, function (v) { return $3f8c7d1186c29758$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "MIXED", function () { return $3f8c7d1186c29758$export$bb410559a65d3418; }, function (v) { return $3f8c7d1186c29758$export$bb410559a65d3418 = v; });
$parcel$export(module.exports, "getCharCountIndicator", function () { return $3f8c7d1186c29758$export$e79764af6ffaeb8d; }, function (v) { return $3f8c7d1186c29758$export$e79764af6ffaeb8d = v; });
$parcel$export(module.exports, "getBestModeForData", function () { return $3f8c7d1186c29758$export$1bd4c93ffb42e55e; }, function (v) { return $3f8c7d1186c29758$export$1bd4c93ffb42e55e = v; });
$parcel$export(module.exports, "toString", function () { return $3f8c7d1186c29758$export$f84e8e69fd4488a5; }, function (v) { return $3f8c7d1186c29758$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isValid", function () { return $3f8c7d1186c29758$export$1ea939691cdc45b8; }, function (v) { return $3f8c7d1186c29758$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $3f8c7d1186c29758$export$6788812c4e6611e6; }, function (v) { return $3f8c7d1186c29758$export$6788812c4e6611e6 = v; });
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $3f8c7d1186c29758$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $3f8c7d1186c29758$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $3f8c7d1186c29758$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $3f8c7d1186c29758$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $3f8c7d1186c29758$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $3f8c7d1186c29758$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $3f8c7d1186c29758$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $3f8c7d1186c29758$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $3f8c7d1186c29758$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $3f8c7d1186c29758$export$6788812c4e6611e6;

var $c3LTx = parcelRequire("c3LTx");

var $e3Ud0 = parcelRequire("e3Ud0");
$3f8c7d1186c29758$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$3f8c7d1186c29758$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$3f8c7d1186c29758$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$3f8c7d1186c29758$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$3f8c7d1186c29758$export$bb410559a65d3418 = {
    bit: -1
};
$3f8c7d1186c29758$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$c3LTx.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$3f8c7d1186c29758$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($e3Ud0.testNumeric(dataStr)) return $3f8c7d1186c29758$export$4d318981b5a83836;
    else if ($e3Ud0.testAlphanumeric(dataStr)) return $3f8c7d1186c29758$export$376a9ed239d6c1c8;
    else if ($e3Ud0.testKanji(dataStr)) return $3f8c7d1186c29758$export$a4d452c2363c8e12;
    else return $3f8c7d1186c29758$export$8f4bf8f7eb581284;
};
$3f8c7d1186c29758$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$3f8c7d1186c29758$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $3f8c7d1186c29758$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $3f8c7d1186c29758$export$4d318981b5a83836;
        case "alphanumeric":
            return $3f8c7d1186c29758$export$376a9ed239d6c1c8;
        case "kanji":
            return $3f8c7d1186c29758$export$a4d452c2363c8e12;
        case "byte":
            return $3f8c7d1186c29758$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$3f8c7d1186c29758$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($3f8c7d1186c29758$export$1ea939691cdc45b8(value)) return value;
    try {
        return $3f8c7d1186c29758$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("c3LTx", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $8c7aeac3d19da20a$export$1ea939691cdc45b8; }, function (v) { return $8c7aeac3d19da20a$export$1ea939691cdc45b8 = v; });
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $8c7aeac3d19da20a$export$1ea939691cdc45b8;
$8c7aeac3d19da20a$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("e3Ud0", function(module, exports) {

$parcel$export(module.exports, "KANJI", function () { return $a3ccf26450645e97$export$a4d452c2363c8e12; }, function (v) { return $a3ccf26450645e97$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "BYTE_KANJI", function () { return $a3ccf26450645e97$export$9df7c29d562bab83; }, function (v) { return $a3ccf26450645e97$export$9df7c29d562bab83 = v; });
$parcel$export(module.exports, "BYTE", function () { return $a3ccf26450645e97$export$8f4bf8f7eb581284; }, function (v) { return $a3ccf26450645e97$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "NUMERIC", function () { return $a3ccf26450645e97$export$4d318981b5a83836; }, function (v) { return $a3ccf26450645e97$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $a3ccf26450645e97$export$376a9ed239d6c1c8; }, function (v) { return $a3ccf26450645e97$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "testKanji", function () { return $a3ccf26450645e97$export$175f16aef75a4569; }, function (v) { return $a3ccf26450645e97$export$175f16aef75a4569 = v; });
$parcel$export(module.exports, "testNumeric", function () { return $a3ccf26450645e97$export$50b7f9bf92c74274; }, function (v) { return $a3ccf26450645e97$export$50b7f9bf92c74274 = v; });
$parcel$export(module.exports, "testAlphanumeric", function () { return $a3ccf26450645e97$export$4ba5f52893b4ac97; }, function (v) { return $a3ccf26450645e97$export$4ba5f52893b4ac97 = v; });
var $a3ccf26450645e97$export$a4d452c2363c8e12;
var $a3ccf26450645e97$export$9df7c29d562bab83;
var $a3ccf26450645e97$export$8f4bf8f7eb581284;
var $a3ccf26450645e97$export$4d318981b5a83836;
var $a3ccf26450645e97$export$376a9ed239d6c1c8;
var $a3ccf26450645e97$export$175f16aef75a4569;
var $a3ccf26450645e97$export$50b7f9bf92c74274;
var $a3ccf26450645e97$export$4ba5f52893b4ac97;
const $a3ccf26450645e97$var$numeric = "[0-9]+";
const $a3ccf26450645e97$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $a3ccf26450645e97$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$a3ccf26450645e97$var$kanji = $a3ccf26450645e97$var$kanji.replace(/u/g, "\\u");
const $a3ccf26450645e97$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $a3ccf26450645e97$var$kanji + ")(?:.|[\r\n]))+";
$a3ccf26450645e97$export$a4d452c2363c8e12 = new RegExp($a3ccf26450645e97$var$kanji, "g");
$a3ccf26450645e97$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$a3ccf26450645e97$export$8f4bf8f7eb581284 = new RegExp($a3ccf26450645e97$var$byte, "g");
$a3ccf26450645e97$export$4d318981b5a83836 = new RegExp($a3ccf26450645e97$var$numeric, "g");
$a3ccf26450645e97$export$376a9ed239d6c1c8 = new RegExp($a3ccf26450645e97$var$alphanumeric, "g");
const $a3ccf26450645e97$var$TEST_KANJI = new RegExp("^" + $a3ccf26450645e97$var$kanji + "$");
const $a3ccf26450645e97$var$TEST_NUMERIC = new RegExp("^" + $a3ccf26450645e97$var$numeric + "$");
const $a3ccf26450645e97$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$a3ccf26450645e97$export$175f16aef75a4569 = function testKanji(str) {
    return $a3ccf26450645e97$var$TEST_KANJI.test(str);
};
$a3ccf26450645e97$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $a3ccf26450645e97$var$TEST_NUMERIC.test(str);
};
$a3ccf26450645e97$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $a3ccf26450645e97$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("a7Ejv", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", function () { return $75e9d442081c71dd$export$eee5438974ef6f0e; }, function (v) { return $75e9d442081c71dd$export$eee5438974ef6f0e = v; });
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $75e9d442081c71dd$export$eee5438974ef6f0e;

var $hc0K2 = parcelRequire("hc0K2");
const $75e9d442081c71dd$var$G15 = 1335;
const $75e9d442081c71dd$var$G15_MASK = 21522;
const $75e9d442081c71dd$var$G15_BCH = $hc0K2.getBCHDigit($75e9d442081c71dd$var$G15);
$75e9d442081c71dd$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($hc0K2.getBCHDigit(d) - $75e9d442081c71dd$var$G15_BCH >= 0)d ^= $75e9d442081c71dd$var$G15 << $hc0K2.getBCHDigit(d) - $75e9d442081c71dd$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $75e9d442081c71dd$var$G15_MASK;
};

});

parcelRegister("1AMOQ", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $128f05ac01034752$export$571d59b505e6bb4e; }, function (v) { return $128f05ac01034752$export$571d59b505e6bb4e = v; });
$parcel$export(module.exports, "fromString", function () { return $128f05ac01034752$export$3004f64547af360e; }, function (v) { return $128f05ac01034752$export$3004f64547af360e = v; });
$parcel$export(module.exports, "rawSplit", function () { return $128f05ac01034752$export$89ab1afb9839589b; }, function (v) { return $128f05ac01034752$export$89ab1afb9839589b = v; });
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $128f05ac01034752$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $128f05ac01034752$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $128f05ac01034752$export$89ab1afb9839589b;

var $5sgEO = parcelRequire("5sgEO");

var $zeUnN = parcelRequire("zeUnN");

var $ljJ13 = parcelRequire("ljJ13");

var $2QQRP = parcelRequire("2QQRP");

var $kztzp = parcelRequire("kztzp");

var $e3Ud0 = parcelRequire("e3Ud0");

var $hc0K2 = parcelRequire("hc0K2");

var $dJq0T = parcelRequire("dJq0T");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $128f05ac01034752$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $128f05ac01034752$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $128f05ac01034752$var$getSegmentsFromString(dataStr) {
    const numSegs = $128f05ac01034752$var$getSegments($e3Ud0.NUMERIC, $5sgEO.NUMERIC, dataStr);
    const alphaNumSegs = $128f05ac01034752$var$getSegments($e3Ud0.ALPHANUMERIC, $5sgEO.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($hc0K2.isKanjiModeEnabled()) {
        byteSegs = $128f05ac01034752$var$getSegments($e3Ud0.BYTE, $5sgEO.BYTE, dataStr);
        kanjiSegs = $128f05ac01034752$var$getSegments($e3Ud0.KANJI, $5sgEO.KANJI, dataStr);
    } else {
        byteSegs = $128f05ac01034752$var$getSegments($e3Ud0.BYTE_KANJI, $5sgEO.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $128f05ac01034752$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $5sgEO.NUMERIC:
            return $zeUnN.getBitsLength(length);
        case $5sgEO.ALPHANUMERIC:
            return $ljJ13.getBitsLength(length);
        case $5sgEO.KANJI:
            return $kztzp.getBitsLength(length);
        case $5sgEO.BYTE:
            return $2QQRP.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $128f05ac01034752$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $128f05ac01034752$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $5sgEO.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5sgEO.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $5sgEO.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $5sgEO.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5sgEO.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $5sgEO.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5sgEO.BYTE,
                        length: $128f05ac01034752$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $5sgEO.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $5sgEO.BYTE,
                        length: $128f05ac01034752$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $128f05ac01034752$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $128f05ac01034752$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $128f05ac01034752$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $128f05ac01034752$var$getSegmentBitsLength(node.length, node.mode) + 4 + $5sgEO.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $128f05ac01034752$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $5sgEO.getBestModeForData(data);
    mode = $5sgEO.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $5sgEO.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $5sgEO.toString(mode) + ".\n Suggested mode is: " + $5sgEO.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $5sgEO.KANJI && !$hc0K2.isKanjiModeEnabled()) mode = $5sgEO.BYTE;
    switch(mode){
        case $5sgEO.NUMERIC:
            return new $zeUnN(data);
        case $5sgEO.ALPHANUMERIC:
            return new $ljJ13(data);
        case $5sgEO.KANJI:
            return new $kztzp(data);
        case $5sgEO.BYTE:
            return new $2QQRP(data);
    }
}
$128f05ac01034752$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($128f05ac01034752$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($128f05ac01034752$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$128f05ac01034752$export$3004f64547af360e = function fromString(data, version) {
    const segs = $128f05ac01034752$var$getSegmentsFromString(data, $hc0K2.isKanjiModeEnabled());
    const nodes = $128f05ac01034752$var$buildNodes(segs);
    const graph = $128f05ac01034752$var$buildGraph(nodes, version);
    const path = $dJq0T.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $128f05ac01034752$export$571d59b505e6bb4e($128f05ac01034752$var$mergeSegments(optimizedSegs));
};
$128f05ac01034752$export$89ab1afb9839589b = function rawSplit(data) {
    return $128f05ac01034752$export$571d59b505e6bb4e($128f05ac01034752$var$getSegmentsFromString(data, $hc0K2.isKanjiModeEnabled()));
};

});
parcelRegister("zeUnN", function(module, exports) {

var $5sgEO = parcelRequire("5sgEO");
function $069ed57f2fee2503$var$NumericData(data) {
    this.mode = $5sgEO.NUMERIC;
    this.data = data.toString();
}
$069ed57f2fee2503$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$069ed57f2fee2503$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$069ed57f2fee2503$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $069ed57f2fee2503$var$NumericData.getBitsLength(this.data.length);
};
$069ed57f2fee2503$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $069ed57f2fee2503$var$NumericData;

});

parcelRegister("ljJ13", function(module, exports) {

var $5sgEO = parcelRequire("5sgEO");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f84e4a900832254f$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f84e4a900832254f$var$AlphanumericData(data) {
    this.mode = $5sgEO.ALPHANUMERIC;
    this.data = data;
}
$f84e4a900832254f$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f84e4a900832254f$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f84e4a900832254f$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f84e4a900832254f$var$AlphanumericData.getBitsLength(this.data.length);
};
$f84e4a900832254f$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f84e4a900832254f$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f84e4a900832254f$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f84e4a900832254f$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $f84e4a900832254f$var$AlphanumericData;

});

parcelRegister("2QQRP", function(module, exports) {

var $k30bW = parcelRequire("k30bW");

var $5sgEO = parcelRequire("5sgEO");
function $213972704559624a$var$ByteData(data) {
    this.mode = $5sgEO.BYTE;
    if (typeof data === "string") data = $k30bW(data);
    this.data = new Uint8Array(data);
}
$213972704559624a$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$213972704559624a$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$213972704559624a$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $213972704559624a$var$ByteData.getBitsLength(this.data.length);
};
$213972704559624a$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $213972704559624a$var$ByteData;

});
parcelRegister("k30bW", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("kztzp", function(module, exports) {

var $5sgEO = parcelRequire("5sgEO");

var $hc0K2 = parcelRequire("hc0K2");
function $ef9e03878c047cca$var$KanjiData(data) {
    this.mode = $5sgEO.KANJI;
    this.data = data;
}
$ef9e03878c047cca$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$ef9e03878c047cca$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$ef9e03878c047cca$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $ef9e03878c047cca$var$KanjiData.getBitsLength(this.data.length);
};
$ef9e03878c047cca$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $hc0K2.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $ef9e03878c047cca$var$KanjiData;

});

parcelRegister("dJq0T", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $02947231c5fa060f$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $02947231c5fa060f$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $02947231c5fa060f$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $02947231c5fa060f$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $02947231c5fa060f$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $02947231c5fa060f$var$dijkstra;

});



parcelRegister("eJCjM", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $aba2fdd85b66a7cb$export$b3890eb0ae9dca99; }, function (v) { return $aba2fdd85b66a7cb$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "renderToDataURL", function () { return $aba2fdd85b66a7cb$export$c3e5526bbaf70a25; }, function (v) { return $aba2fdd85b66a7cb$export$c3e5526bbaf70a25 = v; });
var $aba2fdd85b66a7cb$export$b3890eb0ae9dca99;
var $aba2fdd85b66a7cb$export$c3e5526bbaf70a25;

var $g9y5G = parcelRequire("g9y5G");
function $aba2fdd85b66a7cb$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $aba2fdd85b66a7cb$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$aba2fdd85b66a7cb$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $aba2fdd85b66a7cb$var$getCanvasElement();
    opts = $g9y5G.getOptions(opts);
    const size = $g9y5G.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $g9y5G.qrToImageData(image.data, qrData, opts);
    $aba2fdd85b66a7cb$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$aba2fdd85b66a7cb$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $aba2fdd85b66a7cb$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("g9y5G", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $bc27ee4770e66c14$export$d2312e68e1f5ad00; }, function (v) { return $bc27ee4770e66c14$export$d2312e68e1f5ad00 = v; });
$parcel$export(module.exports, "getScale", function () { return $bc27ee4770e66c14$export$5cdac61cf538712e; }, function (v) { return $bc27ee4770e66c14$export$5cdac61cf538712e = v; });
$parcel$export(module.exports, "getImageWidth", function () { return $bc27ee4770e66c14$export$c3a1a1f268a8142b; }, function (v) { return $bc27ee4770e66c14$export$c3a1a1f268a8142b = v; });
$parcel$export(module.exports, "qrToImageData", function () { return $bc27ee4770e66c14$export$83136f57c739c5f3; }, function (v) { return $bc27ee4770e66c14$export$83136f57c739c5f3 = v; });
var $bc27ee4770e66c14$export$d2312e68e1f5ad00;
var $bc27ee4770e66c14$export$5cdac61cf538712e;
var $bc27ee4770e66c14$export$c3a1a1f268a8142b;
var $bc27ee4770e66c14$export$83136f57c739c5f3;
function $bc27ee4770e66c14$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$bc27ee4770e66c14$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $bc27ee4770e66c14$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $bc27ee4770e66c14$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$bc27ee4770e66c14$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$bc27ee4770e66c14$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $bc27ee4770e66c14$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$bc27ee4770e66c14$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $bc27ee4770e66c14$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("flZLo", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b2d8ba1511d35fdb$export$b3890eb0ae9dca99; }, function (v) { return $b2d8ba1511d35fdb$export$b3890eb0ae9dca99 = v; });
var $b2d8ba1511d35fdb$export$b3890eb0ae9dca99;

var $g9y5G = parcelRequire("g9y5G");
function $b2d8ba1511d35fdb$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $b2d8ba1511d35fdb$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $b2d8ba1511d35fdb$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $b2d8ba1511d35fdb$var$svgCmd("M", col + margin, 0.5 + row + margin) : $b2d8ba1511d35fdb$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $b2d8ba1511d35fdb$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$b2d8ba1511d35fdb$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $g9y5G.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $b2d8ba1511d35fdb$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $b2d8ba1511d35fdb$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $b2d8ba1511d35fdb$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});




//# sourceMappingURL=dist.04d2ce28.js.map
